// import hero
// import hero1Spritesheet from "../../assets/hero1_walk.png";
// import hero2Spritesheet from "../../assets/hero2_walk.png";
// import hero3Spritesheet from "../../assets/hero3_walk.png";
// import hero4Spritesheet from "../../assets/hero4_walk.png";
import minisHeroesSpritesheet from "../../assets/heros/minis_heroes.png";
import archerMaleSpritesheet from "../../assets/heros/male_archer.png";
import archerFemaleSpritesheet from "../../assets/heros/female_archer.png";
import knightMaleSpritesheet from "../../assets/heros/male_knight.png";
import knightFemaleSpritesheet from "../../assets/heros/female_knight.png";
import thiefMaleSpritesheet from "../../assets/heros/male_thief.png";
import thiefFemaleSpritesheet from "../../assets/heros/female_thief.png";
import warriorMaleSpritesheet from "../../assets/heros/male_warrior.png";
import warriorFemaleSpritesheet from "../../assets/heros/female_warrior.png";
import wizardMaleSpritesheet from "../../assets/heros/male_wizard.png";
import wizardFemaleSpritesheet from "../../assets/heros/female_wizard.png";
import barbarianMaleSpritesheet from "../../assets/heros/male_barbarian.png";
import barbarianFemaleSpritesheet from "../../assets/heros/female_barbarian.png";
import druidMaleSpritesheet from "../../assets/heros/male_druid.png";
import druidFemaleSpritesheet from "../../assets/heros/female_druid.png";
import mageMaleSpritesheet from "../../assets/heros/male_mage.png";
import mageFemaleSpritesheet from "../../assets/heros/female_mage.png";
import monkMaleSpritesheet from "../../assets/heros/male_priest.png";
import monkFemaleSpritesheet from "../../assets/heros/female_monk.png";
//import familiar
import wolfSpriteSheet from "../../assets/wolf.png";

// import enemy
import enemy1Spritesheet from "../../assets/enemy1_walk.png";
import enemy2Spritesheet from "../../assets/enemy2_walk.png";
import goblin2Spritesheet from "../../assets/goblin2_walk.png";
import bat1Spritesheet from "../../assets/ennemies/bat1_fly.png";
import kobold1Spritesheet from "../../assets/ennemies/$Kobold_1.png";
import kobold2Spritesheet from "../../assets/ennemies/$Kobold_2.png";
import kobold3Spritesheet from "../../assets/ennemies/$Kobold_3.png";
import naga1Spritesheet from "../../assets/ennemies/$Naga_1.png";
import naga2Spritesheet from "../../assets/ennemies/$Naga_2.png";
import naga3Spritesheet from "../../assets/ennemies/$Naga_3.png";
import naga4Spritesheet from "../../assets/ennemies/$Naga_4.png";
import naga5Spritesheet from "../../assets/ennemies/$Naga_5.png";
import naga6Spritesheet from "../../assets/ennemies/$Naga_6.png";
import naga7Spritesheet from "../../assets/ennemies/$Naga_7.png";
import orc1Spritesheet from "../../assets/ennemies/$Orc_1.png";
import orc2Spritesheet from "../../assets/ennemies/$Orc_2.png";
import orc3Spritesheet from "../../assets/ennemies/$Orc_3.png";
import orc4Spritesheet from "../../assets/ennemies/$Orc_4.png";
import orc5Spritesheet from "../../assets/ennemies/$Orc_5.png";
import orc6Spritesheet from "../../assets/ennemies/$Orc_6.png";
import orc7Spritesheet from "../../assets/ennemies/$Orc_7.png";
import orc8Spritesheet from "../../assets/ennemies/$Orc_8.png";
import bat1aSpritesheet from "../../assets/ennemies/$Bat_1.png";
import bee1Spritesheet from "../../assets/ennemies/$Bee_1.png";
import bird1Spritesheet from "../../assets/ennemies/$Bird_1.png";
import bug1aSpritesheet from "../../assets/ennemies/$Bug_1a.png";
import bug1bSpritesheet from "../../assets/ennemies/$Bug_1b.png";
import cockatrice1Spritesheet from "../../assets/ennemies/$Cockatrice_1.png";
import deer1Spritesheet from "../../assets/ennemies/$Deer_1.png";
import deer2Spritesheet from "../../assets/ennemies/$Deer_2.png";
import fox1Spritesheet from "../../assets/ennemies/$Fox_1.png";
import fox2Spritesheet from "../../assets/ennemies/$Fox_2.png";
import lizardSpritesheet from "../../assets/ennemies/$Lizard.png";
import raccoon1Spritesheet from "../../assets/ennemies/$Raccoon_1.png";
import slime1Spritesheet from "../../assets/ennemies/$Slime_1.png";
import snake1Spritesheet from "../../assets/ennemies/$Snake_1.png";
import snake2Spritesheet from "../../assets/ennemies/$Snake_2.png";
import snake3Spritesheet from "../../assets/ennemies/$Snake_3.png";
import snake4Spritesheet from "../../assets/ennemies/$Snake_4.png";
import spider1Spritesheet from "../../assets/ennemies/$Spider_1.png";
import spider2Spritesheet from "../../assets/ennemies/$Spider_2.png";
import spider3Spritesheet from "../../assets/ennemies/$Spider_3.png";
import worm1Spritesheet from "../../assets/ennemies/$Worm_1.png";
import miniDragon1Spritesheet from "../../assets/ennemies/mini_dragon1.png";
import miniDragon2Spritesheet from "../../assets/ennemies/mini_dragon2.png";
import miniDragon3Spritesheet from "../../assets/ennemies/mini_dragon3.png";
import miniDragon4Spritesheet from "../../assets/ennemies/mini_dragon4.png";
import miniDragon5Spritesheet from "../../assets/ennemies/mini_dragon5.png";
import miniDragon6Spritesheet from "../../assets/ennemies/mini_dragon6.png";
import plantMonster1Spritesheet from "../../assets/ennemies/plant_monster1.png";
import plantMonster2Spritesheet from "../../assets/ennemies/plant_monster2.png";
import lamiasSpritesheet from "../../assets/ennemies/lamias.png";
import minisMonksSpritesheet from "../../assets/ennemies/minis_monks.png";
import minisSoldiers1Spritesheet from "../../assets/ennemies/minis_soldiers1.png";
import minisSoldiers2Spritesheet from "../../assets/ennemies/minis_soldiers2.png";
import fairiesElementalSpritesheet from "../../assets/ennemies/fairies_elemental.png";
import fairiesElemental2Spritesheet from "../../assets/ennemies/fairies_elemental2.png";
import fairiesSpritesheet from "../../assets/ennemies/fairies.png";
import demonLadySpritesheet from "../../assets/ennemies/demon_lady.png";
import colorBatSpritesheet from "../../assets/ennemies/color_bat.png";
import forestMonsterSpritesheet from "../../assets/ennemies/forest_monster.png";
import vampiresSpritesheet from "../../assets/ennemies/vampires.png";
import gazerSpritesheet from "../../assets/ennemies/gazer.png";
// ennemies with full animations
import angryTrentSpritesheet from "../../assets/ennemies/angry_trent.png";
import angryTrentGreySpritesheet from "../../assets/ennemies/angry_trent_grey.png";
import angryTrentOrangeSpritesheet from "../../assets/ennemies/angry_trent_orange.png";
import angryTrentRedSpritesheet from "../../assets/ennemies/angry_trent_red.png";
import angryTrentYellowSpritesheet from "../../assets/ennemies/angry_trent_yellow.png";
import gnomeGreenSpritesheet from "../../assets/ennemies/gnomeGreen.png";
import gnomeRedSpritesheet from "../../assets/ennemies/gnomeRed.png";
import gnomeBlueSpritesheet from "../../assets/ennemies/gnomeBlue.png";
import gnomeYellowSpritesheet from "../../assets/ennemies/gnomeYellow.png";
import gnomeBrownSpritesheet from "../../assets/ennemies/gnomeBrown.png";
import knifedBatSpritesheet from "../../assets/ennemies/knifed_bat.png";
import mudGolemSpritesheet from "../../assets/ennemies/mud_golem.png";
import redBeetleSpritesheet from "../../assets/ennemies/red_beetle.png";
import pinkOgreSpritesheet from "../../assets/ennemies/pink_ogre.png";
import batSpritesheet from "../../assets/ennemies/bat.png";
import batBlueSpritesheet from "../../assets/ennemies/bat_blue.png";
import batBrownSpritesheet from "../../assets/ennemies/bat_brown.png";
import batGreenSpritesheet from "../../assets/ennemies/bat_green.png";
import batPurpleSpritesheet from "../../assets/ennemies/bat_purple.png";
import batShadowSpritesheet from "../../assets/ennemies/bat_shadow.png";
import brownBearSpritesheet from "../../assets/ennemies/brownBear.png";
import blackBearSpritesheet from "../../assets/ennemies/blackBear.png";
import whiteBearSpritesheet from "../../assets/ennemies/whiteBear.png";
import beeSpritesheet from "../../assets/ennemies/bee.png";
import bigtickSpritesheet from "../../assets/ennemies/bigtick.png";
import blackDragonSpritesheet from "../../assets/ennemies/blackDragon.png";
import darkelfSpritesheet from "../../assets/ennemies/darkelf.png";
import demondragonSpritesheet from "../../assets/ennemies/demondragon.png";
import dwarfSpritesheet from "../../assets/ennemies/dwarf.png";
import fantasy1Spritesheet from "../../assets/ennemies/fantasy-1.png";
import fantasy2Spritesheet from "../../assets/ennemies/fantasy-2.png";
import fantasy3Spritesheet from "../../assets/ennemies/fantasy-3.png";
import fantasy4Spritesheet from "../../assets/ennemies/fantasy-4.png";
import orqueGreenSpritesheet from "../../assets/ennemies/orqueGreen.png";
import orqueBlackSpritesheet from "../../assets/ennemies/orqueBlack.png";
import orqueBlueSpritesheet from "../../assets/ennemies/orqueBlue.png";
import orqueRedSpritesheet from "../../assets/ennemies/orqueRed.png";
import orquePurpleSpritesheet from "../../assets/ennemies/orquePurple.png";
import orqueGreySpritesheet from "../../assets/ennemies/orqueGrey.png";
import orqueYellowSpritesheet from "../../assets/ennemies/orqueYellow.png";
import redWarriorMushroomSpritesheet from "../../assets/ennemies/red_warrior_mushroom.png";
import yellowWarriorMushroomSpritesheet from "../../assets/ennemies/yellow_warrior_mushroom.png";
import blueWarriorMushroomSpritesheet from "../../assets/ennemies/blue_warrior_mushroom.png";
import greenWarriorMushroomSpritesheet from "../../assets/ennemies/green_warrior_mushroom.png";
import purpleWarriorMushroomSpritesheet from "../../assets/ennemies/purple_warrior_mushroom.png";
import orangeWarriorMushroomSpritesheet from "../../assets/ennemies/orange_warrior_mushroom.png";
import fantasy7Spritesheet from "../../assets/ennemies/fantasy-7.png";
import massecailleBlueSpritesheet from "../../assets/ennemies/massecailleBlue.png";
import massecailleGreenSpritesheet from "../../assets/ennemies/massecailleGreen.png";
import massecaillePurpleSpritesheet from "../../assets/ennemies/massecaillePurple.png";
import massecailleRedSpritesheet from "../../assets/ennemies/massecailleRed.png";
import massecailleYellowSpritesheet from "../../assets/ennemies/massecailleYellow.png";
import fantasy9Spritesheet from "../../assets/ennemies/fantasy-9.png";
import knightJauneRougeSpritesheet from "../../assets/ennemies/knightJauneRouge.png";
import knightBleuArgentSpritesheet from "../../assets/ennemies/knightBleuArgent.png";
import knightNoirCramoisiSpritesheet from "../../assets/ennemies/knightNoirCramoisi.png";
import knightVertOrSpritesheet from "../../assets/ennemies/knightVertOr.png";
import knightVioletArgentSpritesheet from "../../assets/ennemies/knightVioletArgent.png";
import gargoyleSpritesheet from "../../assets/ennemies/gargoyle.png";
import ghostSpritesheet from "../../assets/ennemies/ghost.png";
import gnomeFouSpritesheet from "../../assets/ennemies/gnomeFou.png";
import golemSpritesheet from "../../assets/ennemies/golem.png";
import golemEauSpritesheet from "../../assets/ennemies/golem_eau.png";
import golemFeuSpritesheet from "../../assets/ennemies/golem_feu.png";
import golemFoudreSpritesheet from "../../assets/ennemies/golem_foudre.png";
import golemGlaceSpritesheet from "../../assets/ennemies/golem_glace.png";
import golemOmbreSpritesheet from "../../assets/ennemies/golem_ombre.png";
import gorillaSpritesheet from "../../assets/ennemies/gorilla.png";
import greendragonSpritesheet from "../../assets/ennemies/greendragon.png";
import ogreBrownSpritesheet from "../../assets/ennemies/ogre_brown.png";
import ogreGreenSpritesheet from "../../assets/ennemies/ogre_green.png";
import ogreBlackSpritesheet from "../../assets/ennemies/ogre_black.png";
import ogreGreySpritesheet from "../../assets/ennemies/ogre_grey.png";
import ogreWhiteSpritesheet from "../../assets/ennemies/ogre_white.png";
import ogreYellowSpritesheet from "../../assets/ennemies/ogre_yellow.png";
import redbeetleSpritesheet from "../../assets/ennemies/redbeetle.png";
import robot1Spritesheet from "../../assets/ennemies/robot-1.png";
import robot2Spritesheet from "../../assets/ennemies/robot-2.png";
import robot3Spritesheet from "../../assets/ennemies/robot-3.png";
import robot4Spritesheet from "../../assets/ennemies/robot-4.png";
import robot5Spritesheet from "../../assets/ennemies/robot-5.png";
import robot6Spritesheet from "../../assets/ennemies/robot-6.png";
import robot7Spritesheet from "../../assets/ennemies/robot-7.png";
import robot8Spritesheet from "../../assets/ennemies/robot-8.png";
import robot9Spritesheet from "../../assets/ennemies/robot-9.png";
import robot10Spritesheet from "../../assets/ennemies/robot-10.png";
import skeletonSpritesheet from "../../assets/ennemies/skeleton.png";
import skeletonkingSpritesheet from "../../assets/ennemies/skeletonking.png";
import slimeVertSpritesheet from "../../assets/ennemies/slime_vert.png";
import slimeJauneSpritesheet from "../../assets/ennemies/slime_jaune.png";
import slimeBleuSpritesheet from "../../assets/ennemies/slime_bleu.png";
import slimeVioletSpritesheet from "../../assets/ennemies/slime_violet.png";
import slimeRougeSpritesheet from "../../assets/ennemies/slime_rouge.png";
import slimeOrangeSpritesheet from "../../assets/ennemies/slime_orange.png";
import slimeBleuCielSpritesheet from "../../assets/ennemies/slime_bleu_ciel.png";
import spiderSpritesheet from "../../assets/ennemies/spider.png";
import spiderBlackPoisonSpritesheet from "../../assets/ennemies/spider_black_poison.png";
import spiderBlueAcidSpritesheet from "../../assets/ennemies/spider_blue_acid.png";
import spiderBrownIceSpritesheet from "../../assets/ennemies/spider_brown_ice.png";
import spiderGreenFireSpritesheet from "../../assets/ennemies/spider_green_fire.png";
import strongArcherSpritesheet from "../../assets/ennemies/strong_archer.png";
import strongBatSpritesheet from "../../assets/ennemies/strong_bat.png";
import strongDemonSpritesheet from "../../assets/ennemies/strong_demon.png";
import strongDemondragonSpritesheet from "../../assets/ennemies/strong_demondragon.png";
import strongDragonSpritesheet from "../../assets/ennemies/strong_dragon.png";
import strongDragonbigSpritesheet from "../../assets/ennemies/strong_dragonbig.png";
import strongDwarfSpritesheet from "../../assets/ennemies/strong_dwarf.png";
import strongEagleSpritesheet from "../../assets/ennemies/strong_eagle.png";
import strongGargoyleSpritesheet from "../../assets/ennemies/strong_gargoyle.png";
import strongGnomeSpritesheet from "../../assets/ennemies/strong_gnome.png";
import strongGolemSpritesheet from "../../assets/ennemies/strong_golem.png";
import strongOgreBrownSpritesheet from "../../assets/ennemies/strong_ogre_brown.png";
import strongOgreBlackSpritesheet from "../../assets/ennemies/strong_ogre_black.png";
import strongOgreWhiteSpritesheet from "../../assets/ennemies/strong_ogre_white.png";
import strongOgreGreySpritesheet from "../../assets/ennemies/strong_ogre_grey.png";
import strongOgreGreenSpritesheet from "../../assets/ennemies/strong_ogre_green.png";
import strongOgreYellowSpritesheet from "../../assets/ennemies/strong_ogre_yellow.png";
import strongRedbeetleSpritesheet from "../../assets/ennemies/strong_redbeetle.png";
import strongSkeletonSpritesheet from "../../assets/ennemies/strong_skeleton.png";
import strongSkeletonkingSpritesheet from "../../assets/ennemies/strong_skeletonking.png";
import strongSlimeSpritesheet from "../../assets/ennemies/strong_slime.png";
import strongSpiderSpritesheet from "../../assets/ennemies/strong_spider.png";
import strongSpiderBlueSpritesheet from "../../assets/ennemies/strong_spider_blue.png";
import strongSpiderRedSpritesheet from "../../assets/ennemies/strong_spider_red.png";
import strongSpiderGreenSpritesheet from "../../assets/ennemies/strong_spider_green.png";
import strongSpiderPurpleSpritesheet from "../../assets/ennemies/strong_spider_purple.png";
import strongSpiderShadowSpritesheet from "../../assets/ennemies/strong_spider_shadow.png";
import strongWarlockSpritesheet from "../../assets/ennemies/strong_warlock.png";
import strongWormSpritesheet from "../../assets/ennemies/strong_worm.png";
import strongZombieSpritesheet from "../../assets/ennemies/strong_zombie.png";
import trollBleuSpritesheet from "../../assets/ennemies/troll_bleu.png";
import trollGrisSpritesheet from "../../assets/ennemies/troll_gris.png";
import trollRoseSpritesheet from "../../assets/ennemies/troll_rose.png";
import trollRougeSpritesheet from "../../assets/ennemies/troll_rouge.png";
import trollVertSpritesheet from "../../assets/ennemies/troll_vert.png";
import trollVioletSpritesheet from "../../assets/ennemies/troll_violet.png";
import vampireSpritesheet from "../../assets/ennemies/vampire.png";
import warlockRougeSpritesheet from "../../assets/ennemies/warlock_rouge.png";
import warlockVertSpritesheet from "../../assets/ennemies/warlock_vert.png";
import warlockBleuSpritesheet from "../../assets/ennemies/warlock_bleu.png";
import warlockNoirSpritesheet from "../../assets/ennemies/warlock_noir.png";
import warlockBlancSpritesheet from "../../assets/ennemies/warlock_blanc.png";
import warlockVioletSpritesheet from "../../assets/ennemies/warlock_violet.png";
import wormSpritesheet from "../../assets/ennemies/worm.png";
import wormGiantSpritesheet from "../../assets/ennemies/wormGiant.png";
import zombieSpritesheet from "../../assets/ennemies/zombie.png";
import zombiequeenSpritesheet from "../../assets/ennemies/zombiequeen.png";
import grayGriblinSpritesheet from "../../assets/ennemies/grayGriblin.png";
import greenGriblinSpritesheet from "../../assets/ennemies/greenGriblin.png";
import redGriblinSpritesheet from "../../assets/ennemies/redGriblin.png";
import blueGriblinSpritesheet from "../../assets/ennemies/blueGriblin.png";
import purpleGriblinSpritesheet from "../../assets/ennemies/purpleGriblin.png";
import goldGriblinSpritesheet from "../../assets/ennemies/goldGriblin.png";
import redManditaureSpritesheet from "../../assets/ennemies/redManditaure.png";
import blueManditaureSpritesheet from "../../assets/ennemies/blueManditaure.png";
import greenManditaureSpritesheet from "../../assets/ennemies/greenManditaure.png";
import purpleManditaureSpritesheet from "../../assets/ennemies/purpleManditaure.png";
import yellowManditaureSpritesheet from "../../assets/ennemies/yellowManditaure.png";
import blackManditaureSpritesheet from "../../assets/ennemies/blackManditaure.png";
import shadowManditaureSpritesheet from "../../assets/ennemies/shadowManditaure.png";
import purpleSpectrelinSpritesheet from "../../assets/ennemies/purpleSpectrelin.png";
import orangeSpectrelinSpritesheet from "../../assets/ennemies/orangeSpectrelin.png";
import cyanSpectrelinSpritesheet from "../../assets/ennemies/cyanSpectrelin.png";
import pinkSpectrelinSpritesheet from "../../assets/ennemies/pinkSpectrelin.png";
import silverSpectrelinSpritesheet from "../../assets/ennemies/silverSpectrelin.png";
import bronzeSpectrelinSpritesheet from "../../assets/ennemies/bronzeSpectrelin.png";
import greenGemmacrabeSpritesheet from "../../assets/ennemies/greenGemmacrabe.png";
import redGemmacrabeSpritesheet from "../../assets/ennemies/redGemmacrabe.png";
import blueGemmacrabeSpritesheet from "../../assets/ennemies/blueGemmacrabe.png";
import yellowGemmacrabeSpritesheet from "../../assets/ennemies/yellowGemmacrabe.png";
import orangeGemmacrabeSpritesheet from "../../assets/ennemies/orangeGemmacrabe.png";
import whiteGemmacrabeSpritesheet from "../../assets/ennemies/whiteGemmacrabe.png";
import blueGrayVesperinSpritesheet from "../../assets/ennemies/blueGrayVesperin.png";
import silverVesperinSpritesheet from "../../assets/ennemies/silverVesperin.png";
import goldVesperinSpritesheet from "../../assets/ennemies/goldVesperin.png";
import copperVesperinSpritesheet from "../../assets/ennemies/copperVesperin.png";
import steelVesperinSpritesheet from "../../assets/ennemies/steelVesperin.png";
import emeraldVesperinSpritesheet from "../../assets/ennemies/emeraldVesperin.png";
import orangeTikorinSpritesheet from "../../assets/ennemies/orangeTikorin.png";
import lightOakTikorinSpritesheet from "../../assets/ennemies/lightOakTikorin.png";
import walnutTikorinSpritesheet from "../../assets/ennemies/walnutTikorin.png";
import mahoganyTikorinSpritesheet from "../../assets/ennemies/mahoganyTikorin.png";
import ebonyTikorinSpritesheet from "../../assets/ennemies/ebonyTikorin.png";
import goldenBeechTikorinSpritesheet from "../../assets/ennemies/goldenBeechTikorin.png";
import pinkLimacorneSpritesheet from "../../assets/ennemies/pinkLimacorne.png";
import deepBlueLimacorneSpritesheet from "../../assets/ennemies/deepBlueLimacorne.png";
import turquoiseLimacorneSpritesheet from "../../assets/ennemies/turquoiseLimacorne.png";
import algaeGreenLimacorneSpritesheet from "../../assets/ennemies/algaeGreenLimacorne.png";
import coralLimacorneSpritesheet from "../../assets/ennemies/coralLimacorne.png";
import pearlLimacorneSpritesheet from "../../assets/ennemies/pearlLimacorne.png";
import craquelinSpritesheet from "../../assets/ennemies/craquelin.png";
import craqueglaceSpritesheet from "../../assets/ennemies/craqueglace.png";
import craqueveninSpritesheet from "../../assets/ennemies/craquevenin.png";
import craquarcaneSpritesheet from "../../assets/ennemies/craquarcane.png";
import craquorSpritesheet from "../../assets/ennemies/craquor.png";
import craquombreSpritesheet from "../../assets/ennemies/craquombre.png";

//import boss
import GhostskullSpritesheet from "../../assets/boss/$GhostSkull_1.png";
import BigSpiderSpritesheet from "../../assets/boss/big_spider.png";
import BoneKing1Spritesheet from "../../assets/boss/bone_king_1.png";
import BoneKing2Spritesheet from "../../assets/boss/bone_king_2.png";
import dragonSpritesheet from "../../assets/boss/dragon.png";
import giantAntSpritesheet from "../../assets/boss/giant_ant.png";
import medusaSpritesheet from "../../assets/boss/medusa.png";
import zombiequeenBossSpritesheet from "../../assets/boss/zombiequeenBoss.png";
import beequeenBossSpritesheet from "../../assets/boss/beequeenBoss.png";
// import tiles
import wallCaveSprite from "../../assets/tilesets/wall_cave.png";
import floorCaveSprite from "../../assets/tilesets/floor_cave.png";
import wallDesertSprite from "../../assets/tilesets/wall_desert.png";
import floorDesertSprite from "../../assets/tilesets/floor_desert.png";
import stairdownSprite from "../../assets/tilesets/stair_down.png";
import stairupSprite from "../../assets/tilesets/stair_up.png";
import wallTreeSprite from "../../assets/tilesets/wall_tree.png";
import floorTreeSprite from "../../assets/tilesets/floor_tree.png";
import desertAutotileImg from "../../assets/tilesets/Set_A_Desert1.png";
import desert2AutotileImg from "../../assets/tilesets/Set_A_Desert2.png";
import hillsAutotileImg from "../../assets/tilesets/Set_A_Hills1.png";
import hills2AutotileImg from "../../assets/tilesets/Set_A_Hills2.png";
import hills3AutotileImg from "../../assets/tilesets/Set_A_Hills3.png";
import snowAutotileImg from "../../assets/tilesets/Set_A_Snow1.png";
import darkwoodsAutotileImg from "../../assets/tilesets/Set_A_Darkwoods1.png";
import darkwoods2AutotileImg from "../../assets/tilesets/Set_A_Darkwoods2.png";
import darkwoods3AutotileImg from "../../assets/tilesets/Set_A_Darkwoods3.png";
import cityWalls1AutotileImg from "../../assets/tilesets/Set_A_CityWalls1.png";
import cityWalls2AutotileImg from "../../assets/tilesets/Set_A_CityWalls2.png";
import cityWalls3AutotileImg from "../../assets/tilesets/Set_A_CityWalls3.png";
import cityWallsE2AutotileImg from "../../assets/tilesets/Set_E_CityWalls2.png";
import cityWallsE3AutotileImg from "../../assets/tilesets/Set_E_CityWalls3.png";
import fortress1AutotileImg from "../../assets/tilesets/Set_A_Fortress1.png";
import fortress2AutotileImg from "../../assets/tilesets/Set_A_Fortress2.png";
import fortress3AutotileImg from "../../assets/tilesets/Set_A_Fortress3.png";
import fortressE1AutotileImg from "../../assets/tilesets/Set_E_Fortress1.png";
import fortressE2AutotileImg from "../../assets/tilesets/Set_E_Fortress2.png";
import fortressE3AutotileImg from "../../assets/tilesets/Set_E_Fortress3.png";
import mines1AutotileImg from "../../assets/tilesets/Set_A_Mines1.png";
import mines2AutotileImg from "../../assets/tilesets/Set_A_Mines2.png";
import mines3AutotileImg from "../../assets/tilesets/Set_A_Mines3.png";
import mines4AutotileImg from "../../assets/tilesets/Set_A_Mines4.png";
import mines5AutotileImg from "../../assets/tilesets/Set_A_Mines5.png";
import mines6AutotileImg from "../../assets/tilesets/Set_A_Mines6.png";
import techFortress1AutotileImg from "../../assets/tilesets/Set_A_TechFortress1.png";
import techFortress2AutotileImg from "../../assets/tilesets/Set_A_TechFortress2.png";
import techFortressE1AutotileImg from "../../assets/tilesets/Set_E_TechFortress1.png";
import techFortressE2AutotileImg from "../../assets/tilesets/Set_E_TechFortress2.png";
import tower1AutotileImg from "../../assets/tilesets/Set_A_Tower1.png";
import tower2AutotileImg from "../../assets/tilesets/Set_A_Tower2.png";
import tower3AutotileImg from "../../assets/tilesets/Set_A_Tower3.png";
import tower4AutotileImg from "../../assets/tilesets/Set_A_Tower4.png";
import towerE1AutotileImg from "../../assets/tilesets/Set_E_Tower1.png";
import towerE2AutotileImg from "../../assets/tilesets/Set_E_Tower2.png";
import towerE3AutotileImg from "../../assets/tilesets/Set_E_Tower3.png";
import desertTownE1AutotileImg from "../../assets/tilesets/Set_E_Desert_Town1.png";
import desertTownE2AutotileImg from "../../assets/tilesets/Set_E_Desert_Town2.png";
import rooftopsFAutotileImg from "../../assets/tilesets/Set_F_Rooftops.png";
import dungeonsA21AutotileImg from "../../assets/tilesets/Set_A2_Dungeons1.png";
import dungeonsA22AutotileImg from "../../assets/tilesets/Set_A2_Dungeons2.png";
import standardFields2AutotileImg from "../../assets/tilesets/Set_A_StandardFields2.png";
import greyCoastA51AutotileImg from "../../assets/tilesets/Set_A5_GreyCoast1.png";
import cityTilesetAutotileImg from "../../assets/tilesets/city_tileset.png";
import cityTilesetV2AutotileImg from "../../assets/tilesets/city_tileset_v2.png";
import beigeCoastAAutotileImg from "../../assets/tilesets/Set_A_Beige_Coast.png";
import beigeFieldsA1AutotileImg from "../../assets/tilesets/Set_A_Beige_Fields1.png";
import greyCoastAAutotileImg from "../../assets/tilesets/Set_A_Grey_Coast.png";
import standardCoastAAutotileImg from "../../assets/tilesets/Set_A_Standard_Coast.png";
import standardFields1AutotileImg from "../../assets/tilesets/Set_A_Standard_Fields1.png";
import standardFields3AutotileImg from "../../assets/tilesets/Set_A_Standard_Fields3.png";
import worldBAutotileImg from "../../assets/tilesets/Set_B_World.png";
import muddyCaveAutotileImg from "../../assets/tilesets/muddy_cave.png";
import muddyCaveV2AutotileImg from "../../assets/tilesets/muddy_cave_v2.png";
import muddyCaveV3AutotileImg from "../../assets/tilesets/muddy_cave_v3.png";
import muddyCaveV4AutotileImg from "../../assets/tilesets/muddy_cave_v4.png";
import muddyCaveV5AutotileImg from "../../assets/tilesets/muddy_cave_v5.png";
import muddyCaveV6AutotileImg from "../../assets/tilesets/muddy_cave_v6.png";
import muddyCaveV7AutotileImg from "../../assets/tilesets/muddy_cave_v7.png";
import muddyCaveV8AutotileImg from "../../assets/tilesets/muddy_cave_v8.png";
import muddyCaveV9AutotileImg from "../../assets/tilesets/muddy_cave_v9.png";
import muddyCaveV10AutotileImg from "../../assets/tilesets/muddy_cave_v10.png";
import muddyCaveV11AutotileImg from "../../assets/tilesets/muddy_cave_v11.png";
import summerForestAutotileImg from "../../assets/tilesets/summer_forest.png";
import springForestAutotileImg from "../../assets/tilesets/spring_forest.png";
import autumnForestAutotileImg from "../../assets/tilesets/autumn_forest.png";
import winterForestAutotileImg from "../../assets/tilesets/winter_forest.png";
import winterForestSnowyAutotileImg from "../../assets/tilesets/winter_forest_snowy.png";
import castleDungeonV01AutotileImg from "../../assets/tilesets/castle_dungeon_v01.png";
import castleDungeonV02AutotileImg from "../../assets/tilesets/castle_dungeon_v02.png";
import castleDungeonV03AutotileImg from "../../assets/tilesets/castle_dungeon_v03.png";
import castleDungeonV04AutotileImg from "../../assets/tilesets/castle_dungeon_v04.png";
// import objects
import chestsSpritesheet from "../../assets/objects_icons/Chests.png";
import iconSheet1 from "../../assets/objects_icons/icon_sheet1.png";
import iconSheet2 from "../../assets/objects_icons/icon_sheet2.png";
import iconskill1Spritesheet from "../../assets/objects_icons/icon_skill_1.png";
import items1Spritesheet from "../../assets/objects_icons/items1.png";
import monster_lootsSpritesheet from "../../assets/objects_icons/monster_loots.png";
import leverSpritesheet from "../../assets/objects_icons/lever.png";
import weaponsTiersSpritesheet from "../../assets/objects_icons/weapons_tiers_sheet.png";
import armorTiersSpritesheet from "../../assets/objects_icons/armor_tiers_sheet.png";
import staffAllTiersSpritesheet from "../../assets/objects_icons/staff_all_tiers_sheet.png";
import armorTextileTiersSpritesheet from "../../assets/objects_icons/armor_textile_tiers_sheet.png";
import pantsAllTiersSpritesheet from "../../assets/objects_icons/pants_all_tiers_sheet.png";
import beltAllTiersSpritesheet from "../../assets/objects_icons/belt_all_tiers_sheet.png";
import ringNecklaceAllTiersSpritesheet from "../../assets/objects_icons/ring_necklace_all_tiers_sheet.png";
import objectsDungeon01Spritesheet from "../../assets/objects_icons/objects_Dungeon_01.png";
import detailsSpritesheet from "../../assets/objects_icons/details.png";
import iconScrollSpritesheet from "../../assets/objects_icons/icon_scroll.png";
import runesVariantesFullSpritesheet from "../../assets/objects_icons/runes_variantes_full.png";
import gemsSpritesheet from "../../assets/objects_icons/gems_spritesheet.png";
// import animation effects
import meleeSlashSpritesheet from "../../assets/animations/melee_slash_effect.png";
// import town PNJ spritesheets here when available
import town1NPCf1Spritesheet from "../../assets/npc/town1_F1_walk.png";
import town1NPCf2Spritesheet from "../../assets/npc/town1_F2_walk.png";
import town1NPCf3Spritesheet from "../../assets/npc/town1_F3_walk.png";
import town1NPCf4Spritesheet from "../../assets/npc/town1_F4_walk.png";
import town1NPCf5Spritesheet from "../../assets/npc/town1_F5_walk.png";
import town1NPCm1Spritesheet from "../../assets/npc/town1_M1_walk.png";
import town1NPCm2Spritesheet from "../../assets/npc/town1_M2_walk.png";
import town1NPCm3Spritesheet from "../../assets/npc/town1_M3_walk.png";
import town1NPCm4Spritesheet from "../../assets/npc/town1_M4_walk.png";
import town1NPCm5Spritesheet from "../../assets/npc/town1_M5_walk.png";
import town2NPCf1Spritesheet from "../../assets/npc/town2_F1_walk.png";
import town2NPCf2Spritesheet from "../../assets/npc/town2_F2_walk.png";
import town2NPCf3Spritesheet from "../../assets/npc/town2_F3_walk.png";
import town2NPCf4Spritesheet from "../../assets/npc/town2_F4_walk.png";
import town2NPCf5Spritesheet from "../../assets/npc/town2_F5_walk.png";
import town2NPCm1Spritesheet from "../../assets/npc/town2_M1_walk.png";
import town2NPCm2Spritesheet from "../../assets/npc/town2_M2_walk.png";
import town2NPCm3Spritesheet from "../../assets/npc/town2_M3_walk.png";
import town2NPCm4Spritesheet from "../../assets/npc/town2_M4_walk.png";
import town2NPCm5Spritesheet from "../../assets/npc/town2_M5_walk.png";
import town3NPCf1Spritesheet from "../../assets/npc/town3_F1_walk.png";
import town3NPCf2Spritesheet from "../../assets/npc/town3_F2_walk.png";
import town3NPCf3Spritesheet from "../../assets/npc/town3_F3_walk.png";
import town3NPCf4Spritesheet from "../../assets/npc/town3_F4_walk.png";
import town3NPCf5Spritesheet from "../../assets/npc/town3_F5_walk.png";
import town3NPCm1Spritesheet from "../../assets/npc/town3_M1_walk.png";
import town3NPCm2Spritesheet from "../../assets/npc/town3_M2_walk.png";
import town3NPCm3Spritesheet from "../../assets/npc/town3_M3_walk.png";
import town3NPCm4Spritesheet from "../../assets/npc/town3_M4_walk.png";
import town3NPCm5Spritesheet from "../../assets/npc/town3_M5_walk.png";
import dungeonAutotileImg from "../../assets/tilesets/dungeon1_splittiler.png"; // ajuste ce chemin relatif si spriteRegistry.js n'est pas directement dans client/src/arpg/
import fortressAutotileImg from "../../assets/tilesets/fortress1_splitiler.png"; // ajuste ce chemin relatif si spriteRegistry.js n'est pas directement dans client/src/arpg/
const SAFE_WORLD_WIDTH = 18;
const SAFE_WORLD_HEIGHT = 24;
const FEET_MARGIN = 2;

export const DUNGEON_AUTOTILE_SPRITESHEET = {
  key: "dungeonAutotile",
  path: dungeonAutotileImg,
  frameWidth: 32,
  frameHeight: 32,
};

export const FORTRESS_AUTOTILE_SPRITESHEET = {
  key: "fortressAutotile",
  path: fortressAutotileImg,
  frameWidth: 32,
  frameHeight: 32,
};

export const DESERT_AUTOTILE_SPRITESHEET = {
  key: "desertAutotile",
  path: desertAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const DESERT2_AUTOTILE_SPRITESHEET = {
  key: "desert2Autotile",
  path: desert2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const HILLS1_AUTOTILE_SPRITESHEET = {
  key: "hillsAutotile",
  path: hillsAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const HILLS2_AUTOTILE_SPRITESHEET = {
  key: "hills2Autotile",
  path: hills2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const HILLS3_AUTOTILE_SPRITESHEET = {
  key: "hills3Autotile",
  path: hills3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const SNOW_AUTOTILE_SPRITESHEET = {
  key: "snowAutotile",
  path: snowAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const DARKWOODS_AUTOTILE_SPRITESHEET = {
  key: "darkwoodsAutotile",
  path: darkwoodsAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const DARKWOODS2_AUTOTILE_SPRITESHEET = {
  key: "darkwoods2Autotile",
  path: darkwoods2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const DARKWOODS3_AUTOTILE_SPRITESHEET = {
  key: "darkwoods3Autotile",
  path: darkwoods3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const STANDARD_FIELDS2_AUTOTILE_SPRITESHEET = {
  key: "standardFields2Autotile",
  path: standardFields2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CITY_WALLS1_AUTOTILE_SPRITESHEET = {
  key: "cityWalls1Autotile",
  path: cityWalls1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CITY_WALLS2_AUTOTILE_SPRITESHEET = {
  key: "cityWalls2Autotile",
  path: cityWalls2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CITY_WALLS3_AUTOTILE_SPRITESHEET = {
  key: "cityWalls3Autotile",
  path: cityWalls3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CITY_WALLSE2_AUTOTILE_SPRITESHEET = {
  key: "cityWallsE2Autotile",
  path: cityWallsE2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CITY_WALLSE3_AUTOTILE_SPRITESHEET = {
  key: "cityWallsE3Autotile",
  path: cityWallsE3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const FORTRESS1_AUTOTILE_SPRITESHEET = {
  key: "fortress1Autotile",
  path: fortress1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const FORTRESS2_AUTOTILE_SPRITESHEET = {
  key: "fortress2Autotile",
  path: fortress2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const FORTRESS3_AUTOTILE_SPRITESHEET = {
  key: "fortress3Autotile",
  path: fortress3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const FORTRESSE1_AUTOTILE_SPRITESHEET = {
  key: "fortressE1Autotile",
  path: fortressE1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const FORTRESSE2_AUTOTILE_SPRITESHEET = {
  key: "fortressE2Autotile",
  path: fortressE2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const FORTRESSE3_AUTOTILE_SPRITESHEET = {
  key: "fortressE3Autotile",
  path: fortressE3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TECH_FORTRESS1_AUTOTILE_SPRITESHEET = {
  key: "techFortress1Autotile",
  path: techFortress1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TECH_FORTRESS2_AUTOTILE_SPRITESHEET = {
  key: "techFortress2Autotile",
  path: techFortress2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TECH_FORTRESSE1_AUTOTILE_SPRITESHEET = {
  key: "techFortressE1Autotile",
  path: techFortressE1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TECH_FORTRESSE2_AUTOTILE_SPRITESHEET = {
  key: "techFortressE2Autotile",
  path: techFortressE2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TOWER1_AUTOTILE_SPRITESHEET = {
  key: "towers1Autotile",
  path: tower1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TOWER2_AUTOTILE_SPRITESHEET = {
  key: "tower2Autotile",
  path: tower2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TOWER3_AUTOTILE_SPRITESHEET = {
  key: "tower3Autotile",
  path: tower3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TOWER4_AUTOTILE_SPRITESHEET = {
  key: "tower4Autotile",
  path: tower4AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TOWERE1_AUTOTILE_SPRITESHEET = {
  key: "towersE1Autotile",
  path: towerE1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TOWERE2_AUTOTILE_SPRITESHEET = {
  key: "towersE2Autotile",
  path: towerE2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const TOWERE3_AUTOTILE_SPRITESHEET = {
  key: "towerE3Autotile",
  path: towerE3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const MINES1_AUTOTILE_SPRITESHEET = {
  key: "mines1Autotile",
  path: mines1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MINES2_AUTOTILE_SPRITESHEET = {
  key: "mines2Autotile",
  path: mines2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MINES3_AUTOTILE_SPRITESHEET = {
  key: "mines3Autotile",
  path: mines3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MINES4_AUTOTILE_SPRITESHEET = {
  key: "mines4Autotile",
  path: mines4AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MINES5_AUTOTILE_SPRITESHEET = {
  key: "mines5Autotile",
  path: mines5AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MINES6_AUTOTILE_SPRITESHEET = {
  key: "mines6Autotile",
  path: mines6AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const DESERT_TOWNE1_AUTOTILE_SPRITESHEET = {
  key: "desertTownE1Autotile",
  path: desertTownE1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const DESERT_TOWNE2_AUTOTILE_SPRITESHEET = {
  key: "desertTownE2Autotile",
  path: desertTownE2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const ROUFTOPSF_AUTOTILE_SPRITESHEET = {
  key: "rooftopsFAutotile",
  path: rooftopsFAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const DUNGEONS_A21_AUTOTILE_SPRITESHEET = {
  key: "dungeonsA21Autotile",
  path: dungeonsA21AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const DUNGEONS_A22_AUTOTILE_SPRITESHEET = {
  key: "dungeonsA22Autotile",
  path: dungeonsA22AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const GREY_COASTA51_AUTOTILE_SPRITESHEET = {
  key: "greyCoastA51Autotile",
  path: greyCoastA51AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const CITY_TILES_AUTOTILE_SPRITESHEET = {
  key: "cityTilesA1Autotile",
  path: cityTilesetAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CITY_TILES_V2_AUTOTILE_SPRITESHEET = {
  key: "cityTilesV2Autotile",
  path: cityTilesetV2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const BEIGE_COAST_A_AUTOTILE_SPRITESHEET = {
  key: "beigeCoastAAutotile",
  path: beigeCoastAAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const BEIGE_FIELDS1_A_AUTOTILE_SPRITESHEET = {
  key: "beigeFields1AAutotile",
  path: beigeFieldsA1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const GREY_COAST_A_AUTOTILE_SPRITESHEET = {
  key: "greyCoastAAutotile",
  path: greyCoastAAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const STANDARD_COAST_A_AUTOTILE_SPRITESHEET = {
  key: "standardCoast2AAutotile",
  path: standardCoastAAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const STANDARD_FIELDS1_AUTOTILE_SPRITESHEET = {
  key: "standardFields1AAutotile",
  path: standardFields1AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const STANDARD_FIELDS3_AUTOTILE_SPRITESHEET = {
  key: "standardFields3AAutotile",
  path: standardFields3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const WORLD_B_AUTOTILE_SPRITESHEET = {
  key: "worldBAutotile",
  path: worldBAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const MUDDY_CAVE_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveAutotile",
  path: muddyCaveAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const MUDDY_CAVE_V2_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV2Autotile",
  path: muddyCaveV2AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V3_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV3Autotile",
  path: muddyCaveV3AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V4_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV4Autotile",
  path: muddyCaveV4AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V5_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV5Autotile",
  path: muddyCaveV5AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V6_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV6Autotile",
  path: muddyCaveV6AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V7_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV7Autotile",
  path: muddyCaveV7AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V8_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV8Autotile",
  path: muddyCaveV8AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V9_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV9Autotile",
  path: muddyCaveV9AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V10_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV10Autotile",
  path: muddyCaveV10AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const MUDDY_CAVE_V11_AUTOTILE_SPRITESHEET = {
  key: "muddyCaveV11Autotile",
  path: muddyCaveV11AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const SUMMER_FOREST_AUTOTILE_SPRITESHEET = {
  key: "summerForestAutotile",
  path: summerForestAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const SPRING_FOREST_AUTOTILE_SPRITESHEET = {
  key: "springForestAutotile",
  path: springForestAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const AUTUMN_FOREST_AUTOTILE_SPRITESHEET = {
  key: "autumnForestAutotile",
  path: autumnForestAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const WINTER_FOREST_AUTOTILE_SPRITESHEET = {
  key: "winterForestAutotile",
  path: winterForestAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const WINTER_FOREST_SNOWY_AUTOTILE_SPRITESHEET = {
  key: "winterForestSnowyAutotile",
  path: winterForestSnowyAutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CASTLE_DUNGEON_V01_AUTOTILE_SPRITESHEET = {
  key: "castleDungeonV01Autotile",
  path: castleDungeonV01AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CASTLE_DUNGEON_V02_AUTOTILE_SPRITESHEET = {
  key: "castleDungeonV02Autotile",
  path: castleDungeonV02AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const CASTLE_DUNGEON_V03_AUTOTILE_SPRITESHEET = {
  key: "castleDungeonV03Autotile",
  path: castleDungeonV03AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};
export const CASTLE_DUNGEON_V04_AUTOTILE_SPRITESHEET = {
  key: "castleDungeonV04Autotile",
  path: castleDungeonV04AutotileImg,
  frameWidth: 16,
  frameHeight: 16,
};

export const OBJECTS_DUNGEON_01_SPRITESHEET = {
  key: "objectsDungeon01",
  path: objectsDungeon01Spritesheet,
  frameWidth: 32,
  frameHeight: 32,
};

export const DETAILS_SPRITESHEET = {
  key: "details",
  path: detailsSpritesheet,
  columns: 16, // nombre de colonnes dans la feuille de sprites
  rows: 16, // nombre de lignes dans la feuille de sprites
  frameWidth: 32,
  frameHeight: 32,
};
export const ICON_SCROLL_SPRITESHEET = {
  key: "iconScroll",
  path: iconScrollSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
};
export const RUNES_VARIANTES_FULL_SPRITESHEET = {
  key: "runesVariantesFull",
  path: runesVariantesFullSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
};

export const GEMS_SPRITESHEET = {
  key: "gems",
  path: gemsSpritesheet,
  columns: 14,
  rows: 14,
  frameWidth: 32,
  frameHeight: 32,
};

// coordonnees precises (pixels, sur city_tileset.png source 512x512) de
// chaque maison - issu du decoupage fait precedemment
export const CITY_HOUSES = {
  house_small_red_1: { x: 151, y: 136, width: 66, height: 70 }, // ~4.1x4.4 tuiles
  house_small_orange_2: { x: 231, y: 136, width: 66, height: 70 }, // ~4.1x4.4 tuiles
  house_small_red_3: { x: 311, y: 136, width: 66, height: 70 }, // ~4.1x4.4 tuiles
  house_small_red_4: { x: 391, y: 136, width: 66, height: 70 }, // ~4.1x4.4 tuiles
  house_small_green_1: { x: 151, y: 216, width: 66, height: 70 }, // ~4.1x4.4 tuiles
  house_small_teal_2: { x: 231, y: 216, width: 66, height: 70 }, // ~4.1x4.4 tuiles
  house_small_teal_3: { x: 311, y: 216, width: 66, height: 70 }, // ~4.1x4.4 tuiles
  house_small_blue_4: { x: 391, y: 216, width: 66, height: 70 }, // ~4.1x4.4 tuiles
  house_row_red_A: { x: 0, y: 327, width: 80, height: 72 }, // ~5.0x4.5 tuiles
  house_row_red_B: { x: 80, y: 327, width: 80, height: 72 }, // ~5.0x4.5 tuiles
  house_row_green_A: { x: 0, y: 407, width: 80, height: 72 }, // ~5.0x4.5 tuiles
  house_row_teal_B: { x: 80, y: 407, width: 80, height: 72 }, // ~5.0x4.5 tuiles
  house_tall_red_A: { x: 160, y: 295, width: 112, height: 88 }, // ~7.0x5.5 tuiles
  house_tall_orange_B: { x: 272, y: 295, width: 112, height: 88 }, // ~7.0x5.5 tuiles
  house_tall_green_A: { x: 160, y: 391, width: 112, height: 88 }, // ~7.0x5.5 tuiles
  house_tall_teal_B: { x: 272, y: 391, width: 112, height: 88 }, // ~7.0x5.5 tuiles
};

export const HOUSE_FOOTPRINTS = [
  { key: "house_small_red_1", tileW: 5, tileH: 5 },
  { key: "house_small_orange_2", tileW: 5, tileH: 5 },
  { key: "house_small_red_3", tileW: 5, tileH: 5 },
  { key: "house_small_red_4", tileW: 5, tileH: 5 },
  { key: "house_small_green_1", tileW: 5, tileH: 5 },
  { key: "house_small_teal_2", tileW: 5, tileH: 5 },
  { key: "house_small_teal_3", tileW: 5, tileH: 5 },
  { key: "house_small_blue_4", tileW: 5, tileH: 5 },
  { key: "house_row_red_A", tileW: 5, tileH: 5 },
  { key: "house_row_red_B", tileW: 5, tileH: 5 },
  { key: "house_row_green_A", tileW: 5, tileH: 5 },
  { key: "house_row_teal_B", tileW: 5, tileH: 5 },
  { key: "house_tall_red_A", tileW: 7, tileH: 6 },
  { key: "house_tall_orange_B", tileW: 7, tileH: 6 },
  { key: "house_tall_green_A", tileW: 7, tileH: 6 },
  { key: "house_tall_teal_B", tileW: 7, tileH: 6 },
];

export function computeSafeHitbox(
  frameWidth,
  frameHeight,
  scale,
  feetMargin = FEET_MARGIN,
) {
  let width = SAFE_WORLD_WIDTH / scale;
  let height = SAFE_WORLD_HEIGHT / scale;

  width = Math.min(width, frameWidth * 0.9);
  height = Math.min(height, frameHeight * 0.9);

  const offsetX = Math.max(0, (frameWidth - width) / 2);
  const offsetY = Math.max(0, frameHeight - height - feetMargin);

  return {
    width: Math.round(width),
    height: Math.round(height),
    offsetX: Math.round(offsetX),
    offsetY: Math.round(offsetY),
  };
}

export const STANDARD_ANIMATION_FRAMES = {
  walkDown: [0, 1, 2, 1],
  walkLeft: [3, 4, 5, 4],
  walkRight: [6, 7, 8, 7],
  walkUp: [9, 10, 11, 10],
  idleDown: 1,
  idleLeft: 4,
  idleRight: 7,
  idleUp: 10,
};

export const STANDARD_ANIMATION_FRAMES_4X4 = {
  walkDown: [0, 1, 2, 3],
  walkLeft: [4, 5, 6, 7],
  walkRight: [8, 9, 10, 11],
  walkUp: [12, 13, 14, 15],
  idleDown: 1,
  idleLeft: 5,
  idleRight: 9,
  idleUp: 13,
};

export const STANDARD_ANIMATION_FRAMES_3X4_MULTI_1 = {
  walkDown: [0, 1, 2, 1],
  walkLeft: [12, 13, 14, 13],
  walkRight: [24, 25, 26, 25],
  walkUp: [36, 37, 38, 37],
  idleDown: 1,
  idleLeft: 13,
  idleRight: 25,
  idleUp: 37,
};

export const STANDARD_ANIMATION_FRAMES_3X4_MULTI_2 = {
  walkDown: [3, 4, 5, 4],
  walkLeft: [15, 16, 17, 16],
  walkRight: [27, 28, 29, 28],
  walkUp: [39, 40, 41, 40],
  idleDown: 4,
  idleLeft: 16,
  idleRight: 28,
  idleUp: 40,
};

export const STANDARD_ANIMATION_FRAMES_3X4_MULTI_3 = {
  walkDown: [6, 7, 8, 7],
  walkLeft: [18, 19, 20, 19],
  walkRight: [30, 31, 32, 31],
  walkUp: [42, 43, 44, 43],
  idleDown: 7,
  idleLeft: 19,
  idleRight: 31,
  idleUp: 43,
};

export const STANDARD_ANIMATION_FRAMES_3X4_MULTI_4 = {
  walkDown: [9, 10, 11, 10],
  walkLeft: [21, 22, 23, 22],
  walkRight: [33, 34, 35, 34],
  walkUp: [45, 46, 47, 46],
  idleDown: 10,
  idleLeft: 22,
  idleRight: 34,
  idleUp: 46,
};

export const STANDARD_ANIMATION_FRAMES_3X4_MULTI_5 = {
  walkDown: [48, 49, 50, 49],
  walkLeft: [60, 61, 62, 61],
  walkRight: [72, 73, 74, 73],
  walkUp: [84, 85, 86, 85],
  idleDown: 49,
  idleLeft: 61,
  idleRight: 73,
  idleUp: 85,
};

export const STANDARD_ANIMATION_FRAMES_3X4_MULTI_6 = {
  walkDown: [51, 52, 53, 52],
  walkLeft: [63, 64, 65, 64],
  walkRight: [75, 76, 77, 76],
  walkUp: [87, 88, 89, 88],
  idleDown: 52,
  idleLeft: 64,
  idleRight: 76,
  idleUp: 88,
};

export const STANDARD_ANIMATION_FRAMES_3X4_MULTI_7 = {
  walkDown: [54, 55, 56, 55],
  walkLeft: [66, 67, 68, 67],
  walkRight: [78, 79, 80, 79],
  walkUp: [90, 91, 92, 91],
  idleDown: 55,
  idleLeft: 67,
  idleRight: 79,
  idleUp: 91,
};

export const STANDARD_ANIMATION_FRAMES_3X4_MULTI_8 = {
  walkDown: [57, 58, 59, 58],
  walkLeft: [69, 70, 71, 70],
  walkRight: [81, 82, 83, 82],
  walkUp: [93, 94, 95, 94],
  idleDown: 58,
  idleLeft: 70,
  idleRight: 82,
  idleUp: 94,
};

export const FULL_ANIMATION_FRAMES = {
  walkDown: [4, 5, 6, 7],
  walkUp: [20, 21, 22, 23],
  walkLeft: [36, 37, 38, 39],
  walkRight: [52, 53, 54, 55],
  idleDown: 0,
  idleUp: 16,
  idleLeft: 32,
  idleRight: 48,
  attackDown: [8, 9, 10, 11],
  attackUp: [24, 25, 26, 27],
  attackLeft: [40, 41, 42, 43],
  attackRight: [56, 57, 58, 59],
  death: [12, 13, 14, 15],
};

// const HERO_FRAME_W = 26;
// const HERO_FRAME_H = 36;
// const HERO_SCALE = 1.2;

const HERO_FRAME_W = 48;
const HERO_FRAME_H = 48;
const HERO_SCALE = 0.8;

function makeHeroEntry(
  key,
  path,
  animations,
  scale = HERO_SCALE,
  sheetCols = 12,
  sheetRows = 8,
  frameWidth = HERO_FRAME_W,
  frameHeight = HERO_FRAME_H,
) {
  return {
    key,
    path,
    frameWidth,
    frameHeight,
    scale,
    // animations: STANDARD_ANIMATION_FRAMES,
    animations,
    sheetCols,
    sheetRows,

    hitbox: computeSafeHitbox(frameWidth, frameHeight, scale),
  };
}

export const SPRITE_REGISTRY = {
  // hero
  hero1: makeHeroEntry(
    "hero1",
    minisHeroesSpritesheet,
    STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
  ),
  hero2: makeHeroEntry(
    "hero2",
    minisHeroesSpritesheet,
    STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
  ),
  hero3: makeHeroEntry(
    "hero3",
    minisHeroesSpritesheet,
    STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
  ),
  hero4: makeHeroEntry(
    "hero4",
    minisHeroesSpritesheet,
    STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
  ),
  hero5: makeHeroEntry(
    "hero5",
    minisHeroesSpritesheet,
    STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
  ),
  hero6: makeHeroEntry(
    "hero6",
    minisHeroesSpritesheet,
    STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
  ),
  hero7: makeHeroEntry(
    "hero7",
    minisHeroesSpritesheet,
    STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
  ),
  hero8: makeHeroEntry(
    "hero8",
    minisHeroesSpritesheet,
    STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
  ),
  hero9: makeHeroEntry(
    "hero9",
    archerMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero10: makeHeroEntry(
    "hero10",
    archerFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero11: makeHeroEntry(
    "hero11",
    knightMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero12: makeHeroEntry(
    "hero12",
    knightFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero13: makeHeroEntry(
    "hero13",
    thiefMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero14: makeHeroEntry(
    "hero14",
    thiefFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero15: makeHeroEntry(
    "hero15",
    warriorMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero16: makeHeroEntry(
    "hero16",
    warriorFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero17: makeHeroEntry(
    "hero17",
    wizardMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),

  hero18: makeHeroEntry(
    "hero18",
    wizardFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),

  hero19: makeHeroEntry(
    "hero19",
    barbarianMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero20: makeHeroEntry(
    "hero20",
    barbarianFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero21: makeHeroEntry(
    "hero21",
    monkMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero22: makeHeroEntry(
    "hero22",
    monkFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero23: makeHeroEntry(
    "hero23",
    druidMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero24: makeHeroEntry(
    "hero24",
    druidFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero25: makeHeroEntry(
    "hero25",
    mageMaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),
  hero26: makeHeroEntry(
    "hero26",
    mageFemaleSpritesheet,
    FULL_ANIMATION_FRAMES,
    0.4,
    4,
    16,
    96,
    96,
  ),

  // enemy and familiar sprites

  enemyDefault: {
    key: "hero1",
    displayName: "Default Enemy",
    path: minisHeroesSpritesheet,
    frameWidth: HERO_FRAME_W,
    frameHeight: HERO_FRAME_H,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(HERO_FRAME_W, HERO_FRAME_H, 1),
  },
  wolfFamiliar: {
    key: "wolfFamiliar",
    displayName: "Familier de loup",
    path: wolfSpriteSheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  angryTrent: {
    key: "angryTrent",
    family: "angryTrentAny",
    familyName: "arbres grincheux",
    displayName: "Ronchêne",
    path: angryTrentSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "angryTrentDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.7, 12),
  },
  angryTrentGrey: {
    key: "angryTrentGrey",
    family: "angryTrentAny",
    displayName: "Grognorme",
    path: angryTrentGreySpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "angryTrentDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.7, 12),
  },
  angryTrentOrange: {
    key: "angryTrentOrange",
    family: "angryTrentAny",
    displayName: "Pesteaule",
    path: angryTrentOrangeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "angryTrentDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.7, 12),
  },
  angryTrentRed: {
    key: "angryTrentRed",
    family: "angryTrentAny",
    displayName: "Fulmipin",
    path: angryTrentRedSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "angryTrentDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.7, 12),
  },
  angryTrentYellow: {
    key: "angryTrentYellow",
    family: "angryTrentAny",
    displayName: "Maugrolivier",
    path: angryTrentYellowSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "angryTrentDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.7, 12),
  },
  gnomeGreen: {
    key: "gnomeGreen",
    displayName: "Gnome Vert",
    path: gnomeGreenSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "gnomeGreenDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.4, 12),
  },
  gnomeRed: {
    key: "gnomeRed",
    displayName: "Gnome Rouge",
    path: gnomeRedSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "gnomeRedDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.4, 12),
  },
  gnomeBlue: {
    key: "gnomeBlue",
    displayName: "Gnome Bleu",
    path: gnomeBlueSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "gnomeBlueDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.4, 12),
  },
  gnomeYellow: {
    key: "gnomeYellow",
    displayName: "Gnome Jaune",
    path: gnomeYellowSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "gnomeYellowDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.4, 12),
  },
  gnomeBrown: {
    key: "gnomeBrown",
    displayName: "Gnome Brun",
    path: gnomeBrownSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "gnomeBrownDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(96, 96, 0.4, 12),
  },
  knifedBat: {
    key: "knifedBat",
    displayName: "Knifed Bat",
    path: knifedBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.8,
    lootTable: "knifedBatDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(48, 48, 0.8),
  },
  mudGolem: {
    key: "mudGolem",
    displayName: "Mud Golem",
    path: mudGolemSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.7,
    lootTable: "mudGolemDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(48, 48, 1.7),
  },
  redBeetle: {
    key: "redBeetle",
    displayName: "Red Beetle",
    path: redBeetleSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "redBeetleDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  pinkOgre: {
    key: "pinkOgre",
    displayName: "Pink Ogre",
    path: pinkOgreSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.5,
    lootTable: "pinkOgreDrop",
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    hitbox: computeSafeHitbox(48, 48, 1.5),
  },
  bat: {
    key: "bat",
    family: "batAny",
    familyName: "Chauve-souris",
    displayName: "Chauve-souris grise",
    path: batSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "batDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.4, 18),
  },
  batBlue: {
    key: "batBlue",
    family: "batAny",
    familyName: "Chauve-souris",
    displayName: "Chauve-souris Bleue",
    path: batBlueSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "batBlueDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.4, 18),
  },
  batBrown: {
    key: "batBrown",
    family: "batAny",
    familyName: "Chauve-souris",
    displayName: "Chauve-souris Brune",
    path: batBrownSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "batBrownDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.4, 18),
  },
  batGreen: {
    key: "batGreen",
    family: "batAny",
    familyName: "Chauve-souris",
    displayName: "Chauve-souris Verte",
    path: batGreenSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "batGreenDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.4, 18),
  },
  batPurple: {
    key: "batPurple",
    family: "batAny",
    familyName: "Chauve-souris",
    displayName: "Chauve-souris Pourpre",
    path: batPurpleSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "batPurpleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.4, 18),
  },
  batShadow: {
    key: "batShadow",
    family: "batAny",
    familyName: "Chauve-souris",
    displayName: "Chauve-souris Ombre",
    path: batShadowSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.4,
    lootTable: "batShadowDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.4, 18),
  },
  brownBear: {
    key: "brownBear",
    family: "bearAny",
    familyName: "Ours",
    displayName: "Ours Brun",
    path: brownBearSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.4,
    lootTable: "brownBearDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.4),
  },
  whiteBear: {
    key: "whiteBear",
    family: "bearAny",
    familyName: "Ours",
    displayName: "Ours Blanc",
    path: whiteBearSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.4,
    lootTable: "whiteBearDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.4),
  },
  blackBear: {
    key: "blackBear",
    family: "bearAny",
    familyName: "Ours",
    displayName: "Ours Noir",
    path: blackBearSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.4,
    lootTable: "blackBearDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.4),
  },
  bee: {
    key: "bee",
    family: "beeAny",
    familyName: "Abeille",
    displayName: "Abeille",
    path: beeSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "beeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  beequeen: {
    key: "beequeen",
    family: "beeAny",
    familyName: "Abeille",
    displayName: "Reine Abeille",
    path: beequeenBossSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 1,
    animations: FULL_ANIMATION_FRAMES,
    sheetCols: 4,
    sheetRows: 16,
    lootTable: "beequeenDrop",
    hitbox: computeSafeHitbox(96, 96, 1),
  },

  bigtick: {
    key: "bigtick",
    family: "tickAny",
    familyName: "Tique",
    displayName: "Gros Tique",
    path: bigtickSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "bigtickDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  blackdragon: {
    key: "blackdragon",
    family: "dragonAny",
    familyName: "Dragons",
    displayName: "Dragon Noir",
    path: blackDragonSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "blackDragonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  darkelf: {
    key: "darkelf",
    family: "elfAny",
    familyName: "Elfes",
    displayName: "Elfe Noir",
    path: darkelfSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "darkelfDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  demonDragon: {
    key: "demonDragon",
    family: "dragonAny",
    familyName: "Dragons",
    displayName: "Dragon Démon",
    path: demondragonSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "demonDragonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  dwarf: {
    key: "dwarf",
    family: "dwarfAny",
    familyName: "Nains",
    displayName: "Nain",
    path: dwarfSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "dwarfDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  fantasy1: {
    key: "fantasy1",
    displayName: "Fantasy 1",
    path: fantasy1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "fantasy1Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  fantasy2: {
    key: "fantasy2",
    displayName: "Fantasy 2",
    path: fantasy2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "fantasy2Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  fantasy3: {
    key: "fantasy3",
    displayName: "Fantasy 3",
    path: fantasy3Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "fantasy3Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  fantasy4: {
    key: "fantasy4",
    displayName: "Fantasy 4",
    path: fantasy4Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "fantasy4Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  orqueGreen: {
    key: "orqueGreen",
    family: "orqueAny",
    familyName: "Orques",
    displayName: "Orque Vert",
    path: orqueGreenSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "orqueGreenDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  orqueBlack: {
    key: "orqueBlack",
    family: "orqueAny",
    familyName: "Orques",
    displayName: "Orque Noir",
    path: orqueBlackSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "orqueBlackDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  orqueYellow: {
    key: "orqueYellow",
    family: "orqueAny",
    familyName: "Orques",
    displayName: "Orque Jaune",
    path: orqueYellowSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "orqueYellowDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  orqueBlue: {
    key: "orqueBlue",
    family: "orqueAny",
    familyName: "Orques",
    displayName: "Orque Bleu",
    path: orqueBlueSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "orqueBlueDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  orqueRed: {
    key: "orqueRed",
    family: "orqueAny",
    familyName: "Orques",
    displayName: "Orque Rouge",
    path: orqueRedSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "orqueRedDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  orquePurple: {
    key: "orquePurple",
    family: "orqueAny",
    familyName: "Orques",
    displayName: "Orque Violet",
    path: orquePurpleSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "orquePurpleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  orqueGrey: {
    key: "orqueGrey",
    family: "orqueAny",
    familyName: "Orques",
    displayName: "Orque Gris",
    path: orqueGreySpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "orqueGreyDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },

  redWarriorMushroom: {
    key: "redWarriorMushroom",
    family: "mushroomAny",
    familyName: "Champignons",
    displayName: "Guerrier Champignon Rouge",
    path: redWarriorMushroomSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "redWarriorMushroomDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 15),
  },
  yellowWarriorMushroom: {
    key: "yellowWarriorMushroom",
    family: "mushroomAny",
    familyName: "Champignons",
    displayName: "Guerrier Champignon Jaune",
    path: yellowWarriorMushroomSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "yellowWarriorMushroomDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 15),
  },
  blueWarriorMushroom: {
    key: "blueWarriorMushroom",
    family: "mushroomAny",
    familyName: "Champignons",
    displayName: "Guerrier Champignon Bleu",
    path: blueWarriorMushroomSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "blueWarriorMushroomDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 15),
  },
  greenWarriorMushroom: {
    key: "greenWarriorMushroom",
    family: "mushroomAny",
    familyName: "Champignons",
    displayName: "Guerrier Champignon Vert",
    path: greenWarriorMushroomSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "greenWarriorMushroomDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 15),
  },
  purpleWarriorMushroom: {
    key: "purpleWarriorMushroom",
    family: "mushroomAny",
    familyName: "Champignons",
    displayName: "Guerrier Champignon Violet",
    path: purpleWarriorMushroomSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "purpleWarriorMushroomDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 15),
  },
  orangeWarriorMushroom: {
    key: "orangeWarriorMushroom",
    family: "mushroomAny",
    familyName: "Champignons",
    displayName: "Guerrier Champignon Orange",
    path: orangeWarriorMushroomSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "orangeWarriorMushroomDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 15),
  },

  fantasy7: {
    key: "fantasy7",
    displayName: "Fantasy 7",
    path: fantasy7Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "fantasy7Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  massecailleBlue: {
    key: "massecailleBlue",
    displayName: "Massecaille Bleu",
    path: massecailleBlueSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "massecailleBlueDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },

  massecailleGreen: {
    key: "massecailleGreen",
    displayName: "Massecaille Vert",
    path: massecailleGreenSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "massecailleGreenDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  massecaillePurple: {
    key: "massecaillePurple",
    displayName: "Massecaille Violet",
    path: massecaillePurpleSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "massecaillePurpleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  massecailleRed: {
    key: "massecailleRed",
    displayName: "Massecaille Rouge",
    path: massecailleRedSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "massecailleRedDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  massecailleYellow: {
    key: "massecailleYellow",
    displayName: "Massecaille Jaune",
    path: massecailleYellowSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "massecailleYellowDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  fantasy9: {
    key: "fantasy9",
    displayName: "Fantasy 9",
    path: fantasy9Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "fantasy9Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  knightJauneRouge: {
    key: "knightJauneRouge",
    displayName: "Chevalier Jaune Rouge",
    path: knightJauneRougeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "knightJauneRougeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 30),
  },
  knightBleuArgent: {
    key: "knightBleuArgent",
    displayName: "Chevalier Bleu Argent",
    path: knightBleuArgentSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "knightBleuArgentDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 30),
  },
  knightNoirCramoisi: {
    key: "knightNoirCramoisi",
    displayName: "Chevalier Noir Cramoisi",
    path: knightNoirCramoisiSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "knightNoirCramoisiDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 30),
  },
  knightVertOr: {
    key: "knightVertOr",
    displayName: "Chevalier Vert Or",
    path: knightVertOrSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "knightVertOrDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 30),
  },
  knightVioletArgent: {
    key: "knightVioletArgent",
    displayName: "Chevalier Violet Argent",
    path: knightVioletArgentSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "knightVioletArgentDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 30),
  },

  gargoyle: {
    key: "gargoyle",
    displayName: "Gargoyle",
    path: gargoyleSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "gargoyleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  ghost: {
    key: "ghost",
    displayName: "Ghost",
    path: ghostSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "ghostDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  gnomeFou: {
    key: "gnomeFou",
    displayName: "Gnome Fou",
    path: gnomeFouSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "gnomeFouDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  golem: {
    key: "golem",
    displayName: "Golem",
    path: golemSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "golemDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  golemEau: {
    key: "golemEau",
    displayName: "Golem d'eau",
    path: golemEauSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "golemEauDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  golemFeu: {
    key: "golemFeu",
    displayName: "Golem de Feu",
    path: golemFeuSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "golemFeuDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  golemFoudre: {
    key: "golemFoudre",
    displayName: "Golem de Foudre",
    path: golemFoudreSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "golemFoudreDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  golemGlace: {
    key: "golemGlace",
    displayName: "Golem de Glace",
    path: golemGlaceSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "golemGlaceDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  golemOmbre: {
    key: "golemOmbre",
    displayName: "Golem de l'Ombre",
    path: golemOmbreSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "golemOmbreDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },

  gorilla: {
    key: "gorilla",
    displayName: "Gorilla",
    path: gorillaSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "gorillaDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  greendragon: {
    key: "greendragon",
    displayName: "Green Dragon",
    path: greendragonSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "greendragonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  ogreBrown: {
    key: "ogreBrown",
    family: "ogre",
    familyName: "Ogres",
    displayName: "Gourdogre — Clan Fangebois",
    path: ogreBrownSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "ogreBrownDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  ogreBlack: {
    key: "ogreBlack",
    family: "ogre",
    familyName: "Ogres",
    displayName: "Gourdogre noir — Clan Cuirnoir",
    path: ogreBlackSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "ogreBlackDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  ogreWhite: {
    key: "ogreWhite",
    family: "ogre",
    familyName: "Ogres",
    displayName: "Gourdogre blanc — Clan Croc-Os",
    path: ogreWhiteSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "ogreWhiteDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  ogreGrey: {
    key: "ogreGrey",
    family: "ogre",
    familyName: "Ogres",
    displayName: "Gourdogre gris — Clan Brisecendre",
    path: ogreGreySpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "ogreGreyDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  ogreGreen: {
    key: "ogreGreen",
    family: "ogre",
    familyName: "Ogres",
    displayName: "Gourdogre vert — Clan Mâchemousse",
    path: ogreGreenSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "ogreGreenDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  ogreYellow: {
    key: "ogreYellow",
    family: "ogre",
    familyName: "Ogres",
    displayName: "Gourdogre jaune — Clan Soufrecorne",
    path: ogreYellowSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "ogreYellowDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },

  redbeetle: {
    key: "redbeetle",
    displayName: "Red Beetle",
    path: redbeetleSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "redbeetleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot1: {
    key: "robot1",
    displayName: "Robot 1",
    path: robot1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot1Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot2: {
    key: "robot2",
    displayName: "Robot 2",
    path: robot2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot2Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot3: {
    key: "robot3",
    displayName: "Robot 3",
    path: robot3Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot3Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot4: {
    key: "robot4",
    displayName: "Robot 4",
    path: robot4Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot4Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot5: {
    key: "robot5",
    displayName: "Robot 5",
    path: robot5Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot5Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot6: {
    key: "robot6",
    displayName: "Robot 6",
    path: robot6Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot6Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot7: {
    key: "robot7",
    displayName: "Robot 7",
    path: robot7Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot7Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot8: {
    key: "robot8",
    displayName: "Robot 8",
    path: robot8Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot8Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot9: {
    key: "robot9",
    displayName: "Robot 9",
    path: robot9Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot9Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  robot10: {
    key: "robot10",
    displayName: "Robot 10",
    path: robot10Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "robot10Drop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  skeleton: {
    key: "skeleton",
    displayName: "Squelette",
    path: skeletonSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "skeletonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  skeletonking: {
    key: "skeletonking",
    displayName: "Roi Squelette",
    path: skeletonkingSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "skeletonkingDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  greenSlime: {
    key: "greenSlime",
    family: "slimeAny",
    familyName: "Slimes",
    displayName: "Blob vert",
    path: slimeVertSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "greenSlimeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  yellowSlime: {
    key: "yellowSlime",
    family: "slimeAny",
    familyName: "Slimes",
    displayName: "Blob jaune",
    path: slimeJauneSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "yellowSlimeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  blueSlime: {
    key: "blueSlime",
    family: "slimeAny",
    familyName: "Slimes",
    displayName: "Blob bleu",
    path: slimeBleuSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "blueSlimeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  purpleSlime: {
    key: "purpleSlime",
    family: "slimeAny",
    familyName: "Slimes",
    displayName: "Blob violet",
    path: slimeVioletSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "purpleSlimeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  redSlime: {
    key: "redSlime",
    family: "slimeAny",
    familyName: "Slimes",
    displayName: "Blob rouge",
    path: slimeRougeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "redSlimeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  orangeSlime: {
    key: "orangeSlime",
    family: "slimeAny",
    familyName: "Slimes",
    displayName: "Blob orange",
    path: slimeOrangeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "orangeSlimeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  skyBlueSlime: {
    key: "skyBlueSlime",
    family: "slimeAny",
    familyName: "Slimes",
    displayName: "Blob bleu ciel",
    path: slimeBleuCielSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "skyBlueSlimeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },

  spider: {
    key: "spider",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Tarentule",
    path: spiderSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "spiderDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.7, 18),
  },
  spiderBlackPoison: {
    key: "spiderBlackPoison",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Tarentoxine",
    path: spiderBlackPoisonSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "spiderBlackPoisonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.7, 18),
  },
  spiderBlueAcid: {
    key: "spiderBlueAcid",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Tarentacide",
    path: spiderBlueAcidSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "spiderBlueAcidDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.7, 18),
  },
  spiderBrownIce: {
    key: "spiderBrownIce",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Tarenglace",
    path: spiderBrownIceSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "spiderBrownIceDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.7, 18),
  },
  spiderGreenFire: {
    key: "spiderGreenFire",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Tarentison",
    path: spiderGreenFireSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.7,
    lootTable: "spiderGreenFireDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.7, 18),
  },
  strongArcher: {
    key: "strongArcher",
    displayName: "Archer Fort",
    path: strongArcherSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongArcherDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongBat: {
    key: "strongBat",
    displayName: "Chauve-souris Forte",
    path: strongBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongBatDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongDemon: {
    key: "strongDemon",
    displayName: "Démon Fort",
    path: strongDemonSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongDemonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongDemondragon: {
    key: "strongDemondragon",
    displayName: "Dragon Démon Fort",
    path: strongDemondragonSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongDemondragonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongDragon: {
    key: "strongDragon",
    displayName: "Dragon Fort",
    path: strongDragonSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongDragonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongDragonbig: {
    key: "strongDragonbig",
    displayName: "Grand Dragon Fort",
    path: strongDragonbigSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongDragonbigDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongDwarf: {
    key: "strongDwarf",
    displayName: "Nain Fort",
    path: strongDwarfSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongDwarfDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongEagle: {
    key: "strongEagle",
    displayName: "Aigle Fort",
    path: strongEagleSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongEagleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongGargoyle: {
    key: "strongGargoyle",
    displayName: "Gargouille Forte",
    path: strongGargoyleSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongGargoyleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongGnome: {
    key: "strongGnome",
    displayName: "Gnome Fort",
    path: strongGnomeSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongGnomeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongGolem: {
    key: "strongGolem",
    displayName: "Golem Fort",
    path: strongGolemSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongGolemDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongBrownOgre: {
    key: "strongBrownOgre",
    family: "ogreAny",
    familyName: "Ogres",
    displayName: "Hérissogre - Clan Fangebois",
    path: strongOgreBrownSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongOgreBrownDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongBlackOgre: {
    key: "strongBlackOgre",
    family: "ogreAny",
    familyName: "Ogres",
    displayName: "Hérissogre - Clan Cuirnoir",
    path: strongOgreBlackSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongOgreBlackDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongWhiteOgre: {
    key: "strongWhiteOgre",
    family: "ogreAny",
    familyName: "Ogres",
    displayName: "Hérissogre - Clan Croc-Os",
    path: strongOgreWhiteSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongOgreWhiteDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongGreyOgre: {
    key: "strongGreyOgre",
    family: "ogreAny",
    familyName: "Ogres",
    displayName: "Hérissogre - Clan Brisecendre",
    path: strongOgreGreySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongOgreGreyDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongGreenOgre: {
    key: "strongGreenOgre",
    family: "ogreAny",
    familyName: "Ogres",
    displayName: "Hérissogre - Clan Mâchemousse",
    path: strongOgreGreenSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongOgreGreenDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongYellowOgre: {
    key: "strongYellowOgre",
    family: "ogreAny",
    familyName: "Ogres",
    displayName: "Hérissogre - Clan Soufrecorne",
    path: strongOgreYellowSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongOgreYellowDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongRedbeetle: {
    key: "strongRedbeetle",
    displayName: "Scarabée Rouge Fort",
    path: strongRedbeetleSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongRedbeetleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongSkeleton: {
    key: "strongSkeleton",
    displayName: "Squelette Fort",
    path: strongSkeletonSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongSkeletonDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongSkeletonKing: {
    key: "strongSkeletonKing",
    displayName: "Roi Squelette Fort",
    path: strongSkeletonkingSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongSkeletonKingDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  strongSlime: {
    key: "strongSlime",
    displayName: "Slime Fort",
    path: strongSlimeSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongSlimeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongSpider: {
    key: "strongSpider",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Mygale",
    path: strongSpiderSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "strongSpiderDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  strongSpiderBlue: {
    key: "strongSpiderBlue",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Mygalace",
    path: strongSpiderBlueSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "strongSpiderBlueDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  strongSpiderGreen: {
    key: "strongSpiderGreen",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Mygacide",
    path: strongSpiderGreenSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "strongSpiderGreenDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  strongSpiderRed: {
    key: "strongSpiderRed",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Mygaflamme",
    path: strongSpiderRedSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "strongSpiderRedDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  strongSpiderPurple: {
    key: "strongSpiderPurple",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Mygavenin",
    path: strongSpiderPurpleSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "strongSpiderPurpleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  strongSpiderShadow: {
    key: "strongSpiderShadow",
    family: "spiderAny",
    familyName: "Araignées",
    displayName: "Mygale de l'ombre",
    path: strongSpiderShadowSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "strongSpiderShadowDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  strongWarlock: {
    key: "strongWarlock",
    displayName: "Sorcier Fort",
    path: strongWarlockSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongWarlockDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongWorm: {
    key: "strongWorm",
    displayName: "Ver Fort",
    path: strongWormSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongWormDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  strongZombie: {
    key: "strongZombie",
    displayName: "Zombie Fort",
    path: strongZombieSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "strongZombieDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  trollBlue: {
    key: "trollBlue",
    displayName: "Troll Bleu",
    path: trollBleuSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.4,
    lootTable: "trollBlueDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.4),
  },
  trollGris: {
    key: "trollGris",
    displayName: "Troll Gris",
    path: trollGrisSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "trollGrisDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  trollRose: {
    key: "trollRose",
    displayName: "Troll Rose",
    path: trollRoseSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "trollRoseDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  trollRouge: {
    key: "trollRouge",
    displayName: "Troll Rouge",
    path: trollRougeSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "trollRougeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  trollVert: {
    key: "trollVert",
    displayName: "Troll Vert",
    path: trollVertSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "trollVertDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  trollViolet: {
    key: "trollViolet",
    displayName: "Troll Violet",
    path: trollVioletSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "trollVioletDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  vampire: {
    key: "vampire",
    displayName: "Vampire",
    path: vampireSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "vampireDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  warlockRed: {
    key: "warlockRed",
    displayName: "Sorcier Rouge",
    path: warlockRougeSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.2,
    lootTable: "warlockRedDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.2),
  },

  warlockWhite: {
    key: "warlockWhite",
    displayName: "Sorcier Blanc",
    path: warlockBlancSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.2,
    lootTable: "warlockWhiteDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.2),
  },
  warlockGreen: {
    key: "warlockGreen",
    displayName: "Sorcier Vert",
    path: warlockVertSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.2,
    lootTable: "warlockGreenDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.2),
  },
  warlockBlue: {
    key: "warlockBlue",
    displayName: "Sorcier Bleu",
    path: warlockBleuSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.2,
    lootTable: "warlockBlueDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.2),
  },
  warlockBlack: {
    key: "warlockBlack",
    displayName: "Sorcier Noir",
    path: warlockNoirSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.2,
    lootTable: "warlockBlackDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.2),
  },
  warlockPurple: {
    key: "warlockPurple",
    displayName: "Sorcier Violet",
    path: warlockVioletSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.2,
    lootTable: "warlockPurpleDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.2),
  },

  worm: {
    key: "worm",
    displayName: "Ver",
    path: wormSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "wormDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  wormGiant: {
    key: "wormGiant",
    displayName: "Ver Géant",
    path: wormGiantSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "wormGiantDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  zombie: {
    key: "zombie",
    displayName: "Zombie",
    path: zombieSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "zombieDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  zombiequeen: {
    key: "zombiequeen",
    displayName: "Reine Zombie",
    path: zombiequeenSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "zombiequeenDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  grayGriblin: {
    key: "grayGriblin",
    displayName: "Griblin",
    path: grayGriblinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "grayGriblinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6),
  },
  greenGriblin: {
    key: "greenGriblin",
    displayName: "Griblin émeraude",
    path: greenGriblinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "greenGriblinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6),
  },
  redGriblin: {
    key: "redGriblin",
    displayName: "Griblin écarlate",
    path: redGriblinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "redGriblinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6),
  },
  blueGriblin: {
    key: "blueGriblin",
    displayName: "Griblin azur",
    path: blueGriblinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "blueGriblinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6),
  },
  purpleGriblin: {
    key: "purpleGriblin",
    displayName: "Griblin améthyste",
    path: purpleGriblinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "purpleGriblinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6),
  },
  goldGriblin: {
    key: "goldGriblin",
    displayName: "Griblin Doré",
    path: goldGriblinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "goldGriblinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6),
  },
  redManditaure: {
    key: "redManditaure",
    displayName: "Manditaure écarlate",
    path: redManditaureSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "redManditaureDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  blueManditaure: {
    key: "blueManditaure",
    displayName: "Manditaure azur",
    path: blueManditaureSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "blueManditaureDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  greenManditaure: {
    key: "greenManditaure",
    displayName: "Manditaure émeraude",
    path: greenManditaureSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "greenManditaureDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  purpleManditaure: {
    key: "purpleManditaure",
    displayName: "Manditaure améthyste",
    path: purpleManditaureSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "purpleManditaureDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  yellowManditaure: {
    key: "yellowManditaure",
    displayName: "Manditaure doré",
    path: yellowManditaureSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "yellowManditaureDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  blackManditaure: {
    key: "blackManditaure",
    displayName: "Manditaure noir",
    path: blackManditaureSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "blackManditaureDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  shadowManditaure: {
    key: "shadowManditaure",
    displayName: "Manditaure d'ombre",
    path: shadowManditaureSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "shadowManditaureDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },

  purpleSpectrelin: {
    key: "purpleSpectrelin",
    displayName: "Spectrelin",
    path: purpleSpectrelinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "purpleSpectrelinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  orangeSpectrelin: {
    key: "orangeSpectrelin",
    displayName: "Brumelin",
    path: orangeSpectrelinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "orangeSpectrelinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  cyanSpectrelin: {
    key: "cyanSpectrelin",
    displayName: "Glaselin",
    path: cyanSpectrelinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "cyanSpectrelinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  pinkSpectrelin: {
    key: "pinkSpectrelin",
    displayName: "Hanteline",
    path: pinkSpectrelinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "pinkSpectrelinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  silverSpectrelin: {
    key: "silverSpectrelin",
    displayName: "Ombrelin",
    path: silverSpectrelinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "silverSpectrelinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  bronzeSpectrelin: {
    key: "bronzeSpectrelin",
    displayName: "Echolin",
    path: bronzeSpectrelinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "bronzeSpectrelinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 18),
  },
  greenGemmacrabe: {
    key: "greenGemmacrabe",
    family: "crabAny",
    familyName: "Crabes à gemme",
    displayName: "Gemmacrabe",
    path: greenGemmacrabeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "greenGemmacrabeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  redGemmacrabe: {
    key: "redGemmacrabe",
    family: "crabAny",
    familyName: "Crabes à gemme",
    displayName: "Braisecrabe",
    path: redGemmacrabeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "redGemmacrabeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  blueGemmacrabe: {
    key: "blueGemmacrabe",
    family: "crabAny",
    familyName: "Crabes à gemme",
    displayName: "Abyssacrabe",
    path: blueGemmacrabeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "blueGemmacrabeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  yellowGemmacrabe: {
    key: "yellowGemmacrabe",
    family: "crabAny",
    familyName: "Crabes à gemme",
    displayName: "Ambracrabe",
    path: yellowGemmacrabeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "yellowGemmacrabeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  orangeGemmacrabe: {
    key: "orangeGemmacrabe",
    family: "crabAny",
    familyName: "Crabes à gemme",
    displayName: "Corailcrabe",
    path: orangeGemmacrabeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "orangeGemmacrabeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  whiteGemmacrabe: {
    key: "whiteGemmacrabe",
    family: "crabAny",
    familyName: "Crabes à gemme",
    displayName: "Nacrabe",
    path: whiteGemmacrabeSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    lootTable: "whiteGemmacrabeDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.5, 12),
  },
  blueGrayVesperin: {
    key: "blueGrayVesperin",
    displayName: "Vesperin",
    path: blueGrayVesperinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "blueGrayVesperinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  silverVesperin: {
    key: "silverVesperin",
    displayName: "Astrelin",
    path: silverVesperinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "silverVesperinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  goldVesperin: {
    key: "goldVesperin",
    displayName: "Solelin",
    path: goldVesperinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "goldVesperinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  copperVesperin: {
    key: "copperVesperin",
    displayName: "Forgelin",
    path: copperVesperinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "copperVesperinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  steelVesperin: {
    key: "steelVesperin",
    displayName: "Lamelin",
    path: steelVesperinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "steelVesperinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },
  emeraldVesperin: {
    key: "emeraldVesperin",
    displayName: "Jadelin",
    path: emeraldVesperinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "emeraldVesperinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 18),
  },

  orangeTikorin: {
    key: "orangeTikorin",
    displayName: "Tikorin",
    path: orangeTikorinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "orangeTikorinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 20),
  },
  lightOakTikorin: {
    key: "lightOakTikorin",
    displayName: "Clarorin",
    path: lightOakTikorinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "lightOakTikorinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 20),
  },
  walnutTikorin: {
    key: "walnutTikorin",
    displayName: "Racorin",
    path: walnutTikorinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "walnutTikorinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 20),
  },
  mahoganyTikorin: {
    key: "mahoganyTikorin",
    displayName: "Braisorin",
    path: mahoganyTikorinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "mahoganyTikorinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 20),
  },
  ebonyTikorin: {
    key: "ebonyTikorin",
    displayName: "Noctorin",
    path: ebonyTikorinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "ebonyTikorinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },
  goldenBeechTikorin: {
    key: "goldenBeechTikorin",
    displayName: "Auréorin",
    path: goldenBeechTikorinSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.8,
    lootTable: "goldenBeechTikorinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.8, 25),
  },

  pinkLimacorne: {
    key: "pinkLimacorne",
    displayName: "Limacorne",
    path: pinkLimacorneSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "pinkLimacorneDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 20),
  },
  deepBlueLimacorne: {
    key: "deepBlueLimacorne",
    displayName: "Gouffrorne",
    path: deepBlueLimacorneSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "deepBlueLimacorneDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 20),
  },
  turquoiseLimacorne: {
    key: "turquoiseLimacorne",
    displayName: "Réciforne",
    path: turquoiseLimacorneSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "turquoiseLimacorneDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 20),
  },
  algaeGreenLimacorne: {
    key: "algaeGreenLimacorne",
    displayName: "Algorne",
    path: algaeGreenLimacorneSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "algaeGreenLimacorneDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 20),
  },
  coralLimacorne: {
    key: "coralLimacorne",
    displayName: "Corallorne",
    path: coralLimacorneSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "coralLimacorneDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 20),
  },
  pearlLimacorne: {
    key: "pearlLimacorne",
    displayName: "Perlorne",
    path: pearlLimacorneSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.6,
    lootTable: "pearlLimacorneDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(96, 96, 0.6, 20),
  },
  craquelin: {
    key: "craquelin",
    displayName: "Craquelin",
    path: craquelinSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "craquelinDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  craqueglace: {
    key: "craqueglace",
    displayName: "Craqueglace",
    path: craqueglaceSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "craqueglaceDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  craquevenin: {
    key: "craquevenin",
    displayName: "Craquevenin",
    path: craqueveninSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "craquevenimDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  craquarcane: {
    key: "craquarcane",
    displayName: "Craquarcane",
    path: craquarcaneSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "craquarcaneDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  craquor: {
    key: "craquor",
    displayName: "Craquor",
    path: craquorSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "craquorDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  craquombre: {
    key: "craquombre",
    displayName: "Craquombre",
    path: craquombreSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1,
    lootTable: "craquombreDrop",
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1),
  },

  monks1: {
    key: "monks1",
    displayName: "Moine 1",
    path: minisMonksSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "monks1Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    sheetCols: 12,
    sheetRows: 4,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  monks2: {
    key: "monks2",
    displayName: "Moine 2",
    path: minisMonksSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "monks2Drop",
    sheetCols: 12,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  monks3: {
    key: "monks3",
    displayName: "Moine 3",
    path: minisMonksSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "monks3Drop",
    sheetCols: 12,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  monks4: {
    key: "monks4",
    displayName: "Moine 4",
    path: minisMonksSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "monks4Drop",
    sheetCols: 12,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy1: {
    key: "elementalFairy1",
    displayName: "Fée élémentaire 1",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy1Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy2: {
    key: "elementalFairy2",
    displayName: "Fée élémentaire 2",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy2Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy3: {
    key: "elementalFairy3",
    displayName: "Fée élémentaire 3",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy3Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy4: {
    key: "elementalFairy4",
    displayName: "Fée élémentaire 4",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy4Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy5: {
    key: "elementalFairy5",
    displayName: "Fée élémentaire 5",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy5Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy6: {
    key: "elementalFairy6",
    displayName: "Fée élémentaire 6",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy6Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy7: {
    key: "elementalFairy7",
    displayName: "Fée élémentaire 7",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy7Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy8: {
    key: "elementalFairy8",
    displayName: "Fée élémentaire 8",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy8Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy9: {
    key: "elementalFairy9",
    displayName: "Fée élémentaire 9",
    path: fairiesElemental2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy9Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy10: {
    key: "elementalFairy10",
    displayName: "Fée élémentaire 10",
    path: fairiesElemental2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy10Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy11: {
    key: "elementalFairy11",
    displayName: "Fée élémentaire 11",
    path: fairiesElemental2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy11Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy12: {
    key: "elementalFairy12",
    displayName: "Fée élémentaire 12",
    path: fairiesElemental2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy12Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy13: {
    key: "elementalFairy13",
    displayName: "Fée élémentaire 13",
    path: fairiesElemental2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy13Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy14: {
    key: "elementalFairy14",
    displayName: "Fée élémentaire 14",
    path: fairiesElemental2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy14Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy15: {
    key: "elementalFairy15",
    displayName: "Fée élémentaire 15",
    path: fairiesElemental2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy15Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  elementalFairy16: {
    key: "elementalFairy16",
    displayName: "Fée élémentaire 16",
    path: fairiesElemental2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "elementalFairy16Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  fairy1: {
    key: "fairy1",
    displayName: "Fée 1",
    path: fairiesSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "fairy1Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  fairy2: {
    key: "fairy2",
    displayName: "Fée 2",
    path: fairiesSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "fairy2Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  fairy3: {
    key: "fairy3",
    displayName: "Fée 3",
    path: fairiesSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "fairy3Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  fairy4: {
    key: "fairy4",
    displayName: "Fée 4",
    path: fairiesSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "fairy4Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  fairy5: {
    key: "fairy5",
    displayName: "Fée 5",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "fairy5Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  fairy6: {
    key: "fairy6",
    displayName: "Fée 6",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "fairy6Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  fairy7: {
    key: "fairy7",
    displayName: "Fée 7",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "fairy7Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  fairy8: {
    key: "fairy8",
    displayName: "Fée 8",
    path: fairiesElementalSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "fairy8Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  colorBat1: {
    key: "colorBat1",
    displayName: "Chauve-souris colorée 1",
    path: colorBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "colorBat1Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  colorBat2: {
    key: "colorBat2",
    displayName: "Chauve-souris colorée 2",
    path: colorBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "colorBat2Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  colorBat3: {
    key: "colorBat3",
    displayName: "Chauve-souris colorée 3",
    path: colorBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.9,
    lootTable: "colorBat3Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    hitbox: computeSafeHitbox(48, 48, 0.9),
  },
  colorBat4: {
    key: "colorBat4",
    displayName: "Chauve-souris colorée 4",
    path: colorBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.9,
    lootTable: "colorBat4Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    hitbox: computeSafeHitbox(48, 48, 0.9),
  },
  colorBat5: {
    key: "colorBat5",
    displayName: "Chauve-souris colorée 5",
    path: colorBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "colorBat5Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  colorBat6: {
    key: "colorBat6",
    displayName: "Chauve-souris colorée 6",
    path: colorBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "colorBat6Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  colorBat7: {
    key: "colorBat7",
    displayName: "Chauve-souris colorée 7",
    path: colorBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "colorBat7Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  colorBat8: {
    key: "colorBat8",
    displayName: "Chauve-souris colorée 8",
    path: colorBatSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "colorBat8Drop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  brownMushroom: {
    key: "brownMushroom",
    displayName: "Champignon marron",
    path: forestMonsterSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "brownMushroomDrop",
    sheetCols: 12,
    sheetRows: 8,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  angryBrownMushroom: {
    key: "angryBrownMushroom",
    displayName: "Champignon marron en colère",
    path: forestMonsterSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "angryBrownMushroomDrop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  redMushroom: {
    key: "redMushroom",
    displayName: "Champignon rouge",
    path: forestMonsterSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "redMushroomDrop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  angryRedMushroom: {
    key: "angryRedMushroom",
    displayName: "Champignon rouge en colère",
    path: forestMonsterSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "angryRedMushroomDrop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  angryStump: {
    key: "angryStump",
    displayName: "Souche en colère",
    path: forestMonsterSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    lootTable: "angryStumpDrop",
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  armsAngryStumps: {
    key: "armsAngryStumps",
    displayName: "Bras de souches en colère",
    path: forestMonsterSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    lootTable: "armsAngryStumpsDrop",
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 1),
  },
  redEarthworms: {
    key: "redEarthworms",
    displayName: "Vers de terre rouges",
    path: forestMonsterSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "redEarthwormsDrop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  blackBug: {
    key: "blackBug",
    displayName: "Insecte noir",
    path: forestMonsterSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.5,
    lootTable: "blackBugDrop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.5),
  },
  demonLady1: {
    key: "demonLady1",
    displayName: "Dame démoniaque 1",
    path: demonLadySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "demonLady1Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  demonLady2: {
    key: "demonLady2",
    displayName: "Dame démoniaque 2",
    path: demonLadySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "demonLady2Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  demonLady3: {
    key: "demonLady3",
    displayName: "Dame démoniaque 3",
    path: demonLadySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "demonLady3Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  demonLady4: {
    key: "demonLady4",
    displayName: "Dame démoniaque 4",
    path: demonLadySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "demonLady4Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  demonLady5: {
    key: "demonLady5",
    displayName: "Dame démoniaque 5",
    path: demonLadySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "demonLady5Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  demonLady6: {
    key: "demonLady6",
    displayName: "Dame démoniaque 6",
    path: demonLadySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "demonLady6Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  demonLady7: {
    key: "demonLady7",
    displayName: "Dame démoniaque 7",
    path: demonLadySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "demonLady7Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  demonLady8: {
    key: "demonLady8",
    displayName: "Dame démoniaque 8",
    path: demonLadySpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "demonLady8Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  gazer1: {
    key: "gazer1",
    displayName: "Gazer rouge",
    path: gazerSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "gazer1Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  gazer2: {
    key: "gazer2",
    displayName: "Gazer bordeau",
    path: gazerSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "gazer2Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  gazer3: {
    key: "gazer3",
    displayName: "Gazer bleu",
    path: gazerSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "gazer3Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  gazer4: {
    key: "gazer4",
    displayName: "Gazer noir",
    path: gazerSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "gazer4Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  gazer5: {
    key: "gazer5",
    displayName: "Gazer vert",
    path: gazerSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "gazer5Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier1: {
    key: "soldier1",
    displayName: "soldier1",
    path: minisSoldiers1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier1Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier2: {
    key: "soldier2",
    displayName: "soldier2",
    path: minisSoldiers1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier2Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier3: {
    key: "soldier3",
    displayName: "soldier3",
    path: minisSoldiers1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier3Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier4: {
    key: "soldier4",
    displayName: "soldier4",
    path: minisSoldiers1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier4Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier5: {
    key: "soldier5",
    displayName: "soldier5",
    path: minisSoldiers1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier5Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier6: {
    key: "soldier6",
    displayName: "soldier6",
    path: minisSoldiers1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier6Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier7: {
    key: "soldier7",
    displayName: "soldier7",
    path: minisSoldiers1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier7Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier8: {
    key: "soldier8",
    displayName: "soldier8",
    path: minisSoldiers1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier8Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier9: {
    key: "soldier9",
    displayName: "soldier9",
    path: minisSoldiers2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier9Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier10: {
    key: "soldier10",
    displayName: "soldier10",
    path: minisSoldiers2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier10Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier11: {
    key: "soldier11",
    displayName: "soldier11",
    path: minisSoldiers2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier11Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier12: {
    key: "soldier12",
    displayName: "soldier12",
    path: minisSoldiers2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier12Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier13: {
    key: "soldier13",
    displayName: "soldier13",
    path: minisSoldiers2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier13Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier14: {
    key: "soldier14",
    displayName: "soldier14",
    path: minisSoldiers2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier14Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier15: {
    key: "soldier15",
    displayName: "soldier15",
    path: minisSoldiers2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier15Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_7,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  soldier16: {
    key: "soldier16",
    displayName: "soldier16",
    path: minisSoldiers2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "soldier16Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  enemy1: {
    key: "enemy1",
    displayName: "homme des bois",
    path: enemy1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "enemy1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  goblin: {
    key: "goblin",
    displayName: "gobelin furieux",
    path: enemy2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "goblinDrop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  goblin2: {
    key: "goblin2",
    displayName: "gobelin rusé",
    path: goblin2Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 0.8,
    lootTable: "goblin2Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 32, 0.8),
  },
  bat1: {
    key: "bat1",
    displayName: "chauve-souris",
    path: bat1Spritesheet,
    frameWidth: 16,
    frameHeight: 16,
    scale: 1.7,
    lootTable: "bat1Drop",
    animations: STANDARD_ANIMATION_FRAMES_4X4,
    sheetCols: 4,
    sheetRows: 4,
    hitbox: computeSafeHitbox(16, 16, 1.7),
  },
  bat1a: {
    key: "bat1a",
    displayName: "chauve-souris alpha",
    path: bat1aSpritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.6,
    lootTable: "bat1aDrop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.6),
  },
  bee1: {
    key: "bee1",
    displayName: "abeille",
    path: bee1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.5,
    lootTable: "bee1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.5),
  },

  bird1: {
    key: "bird1",
    displayName: "oiseau",
    path: bird1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "bird1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  bug1a: {
    key: "bug1a",
    displayName: "insecte vert",
    path: bug1aSpritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.7,
    lootTable: "bug1aDrop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.7),
  },
  bug1b: {
    key: "bug1b",
    displayName: "insecte rouge",
    path: bug1bSpritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.7,
    lootTable: "bug1bDrop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.7),
  },
  cockatrice1: {
    key: "cockatrice1",
    displayName: "basilic",
    path: cockatrice1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.7,
    lootTable: "cockatrice1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.7),
  },
  deer1: {
    key: "deer1",
    displayName: "cerf de feu",
    path: deer1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "deer1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  deer2: {
    key: "deer2",
    displayName: "cerf",
    path: deer2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "deer2Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  fox1: {
    key: "fox1",
    displayName: "renard bleu",
    path: fox1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.7,
    lootTable: "fox1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.7),
  },
  fox2: {
    key: "fox2",
    displayName: "renard rouge",
    path: fox2Spritesheet,
    frameWidth: 48,
    frameHeight: 60,
    spacing: 2,
    scale: 0.7,
    lootTable: "fox2Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(48, 60, 0.7),
  },
  lizard: {
    key: "lizard",
    displayName: "lézard",
    path: lizardSpritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    lootTable: "lizardDrop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  raccoon1: {
    key: "raccoon1",
    displayName: "raton laveur",
    path: raccoon1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    lootTable: "raccoon1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  slime1: {
    key: "slime1",
    displayName: "slime",
    path: slime1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    lootTable: "slime1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  snake1: {
    key: "snake1",
    displayName: "serpent vert",
    path: snake1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    lootTable: "snake1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  snake2: {
    key: "snake2",
    displayName: "serpent violet",
    path: snake2Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1.5,
    lootTable: "snake2Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 32, 1.5),
  },
  snake3: {
    key: "snake3",
    displayName: "serpent rouge",
    path: snake3Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1.5,
    lootTable: "snake3Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 32, 1.5),
  },
  snake4: {
    key: "snake4",
    displayName: "serpent blanc",
    path: snake4Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1.5,
    lootTable: "snake4Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 32, 1.5),
  },
  spider1: {
    key: "spider1",
    displayName: "petite araignée",
    path: spider1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    lootTable: "spider1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  spider2: {
    key: "spider2",
    displayName: "araignée moyenne",
    path: spider2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    lootTable: "spider2Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  spider3: {
    key: "spider3",
    displayName: "grande araignée",
    path: spider3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    lootTable: "spider3Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  worm1: {
    key: "worm1",
    displayName: "ver bleu géant",
    path: worm1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    lootTable: "worm1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  miniDragon1: {
    key: "miniDragon1",
    displayName: "petit dragon jaune",
    path: miniDragon1Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1,
    lootTable: "miniDragon1Drop",
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 32, 1),
  },
  miniDragon2: {
    key: "miniDragon2",
    displayName: "petit dragon jaune et vert",
    path: miniDragon2Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1,
    lootTable: "miniDragon2Drop",
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 32, 1),
  },
  miniDragon3: {
    key: "miniDragon3",
    displayName: "petit dragon vert et rouge",
    path: miniDragon3Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1,
    lootTable: "miniDragon3Drop",
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 32, 1),
  },
  miniDragon4: {
    key: "miniDragon4",
    displayName: "petit dragon vert",
    path: miniDragon4Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1,
    lootTable: "miniDragon4Drop",
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 32, 1),
  },
  miniDragon5: {
    key: "miniDragon5",
    displayName: "petit dragon blanc",
    path: miniDragon5Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1,
    lootTable: "miniDragon5Drop",
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 32, 1),
  },
  miniDragon6: {
    key: "miniDragon6",
    displayName: "petit dragon bleu",
    path: miniDragon6Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1,
    lootTable: "miniDragon6Drop",
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 32, 1),
  },
  plantMonster1: {
    key: "plantMonster1",
    displayName: "Navet géant",
    path: plantMonster1Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1,
    lootTable: "plantMonster1Drop",
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 32, 1),
  },
  plantMonster2: {
    key: "plantMonster2",
    displayName: "plant carnivore",
    path: plantMonster2Spritesheet,
    frameWidth: 32,
    frameHeight: 32,
    scale: 1,
    lootTable: "plantMonster2Drop",
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 32, 1),
  },
  lamia1: {
    key: "lamia1",
    displayName: "lamia rousse",
    path: lamiasSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "lamia1Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_6,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  lamia2: {
    key: "lamia2",
    displayName: "lamia brune",
    path: lamiasSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "lamia2Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  lamia3: {
    key: "lamia3",
    displayName: "lamia blonde",
    path: lamiasSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "lamia3Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  lamia4: {
    key: "lamia4",
    displayName: "lamia châtain",
    path: lamiasSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "lamia4Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_8,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  lamia5: {
    key: "lamia5",
    displayName: "lamia aux cheveux verts",
    path: lamiasSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "lamia5Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  lamia6: {
    key: "lamia6",
    displayName: "lamia aux cheveux verts",
    path: lamiasSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "lamia6Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  vampire1: {
    key: "vampire1",
    displayName: "vampire aux cheveux bleus",
    path: vampiresSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "vampire1Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_1,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  vampire2: {
    key: "vampire2",
    displayName: "vampire aux cheveux noirs",
    path: vampiresSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "vampire2Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_2,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  vampire3: {
    key: "vampire3",
    displayName: "vampire aux cheveux blancs",
    path: vampiresSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "vampire3Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_3,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  vampire4: {
    key: "vampire4",
    displayName: "vampire aux cheveux rouges",
    path: vampiresSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "vampire4Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_4,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },
  vampire5: {
    key: "vampire5",
    displayName: "vampire aux cheveux gris",
    path: vampiresSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 0.7,
    lootTable: "vampire5Drop",
    animations: STANDARD_ANIMATION_FRAMES_3X4_MULTI_5,
    sheetCols: 12,
    sheetRows: 8,
    hitbox: computeSafeHitbox(48, 48, 0.7),
  },

  kobold1: {
    key: "kobold1",
    displayName: "kobold",
    path: kobold1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "kobold1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  kobold2: {
    key: "kobold2",
    displayName: "kobold agressif",
    path: kobold2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "kobold2Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  kobold3: {
    key: "kobold3",
    displayName: "kobold furieux",
    path: kobold3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "kobold3Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  naga1: {
    key: "naga1",
    displayName: "naga avec une lance",
    path: naga1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "naga1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  naga2: {
    key: "naga2",
    displayName: "naga aux cheveux violets",
    path: naga2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "naga2Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  naga3: {
    key: "naga3",
    displayName: "naga avec des épées",
    path: naga3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "naga3Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  naga4: {
    key: "naga4",
    displayName: "naga avec un arc",
    path: naga4Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "naga4Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  naga5: {
    key: "naga5",
    displayName: "naga avec une hache",
    path: naga5Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "naga5Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  naga6: {
    key: "naga6",
    displayName: "mage naga aux cheveux violets",
    path: naga6Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "naga6Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  naga7: {
    key: "naga7",
    displayName: "naga rose",
    path: naga7Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.8,
    lootTable: "naga7Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 0.8),
  },
  orc1: {
    key: "orc1",
    displayName: "orc guerrier",
    path: orc1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "orc1Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  orc2: {
    key: "orc2",
    displayName: "orc voleur",
    path: orc2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "orc2Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  orc3: {
    key: "orc3",
    displayName: "orc avec une queue de cheval",
    path: orc3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "orc3Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  orc4: {
    key: "orc4",
    displayName: "orc",
    path: orc4Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "orc4Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  orc5: {
    key: "orc5",
    displayName: "orc casqué",
    path: orc5Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "orc5Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  orc6: {
    key: "orc6",
    displayName: "orc avec une cicatrice sur le visage",
    path: orc6Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "orc6Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  orc7: {
    key: "orc7",
    displayName: "orc avec coupe iroquoise",
    path: orc7Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "orc7Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  orc8: {
    key: "orc8",
    displayName: "orc pirate",
    path: orc8Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.2,
    lootTable: "orc8Drop",
    animations: STANDARD_ANIMATION_FRAMES,
    sheetCols: 3,
    sheetRows: 4,
    hitbox: computeSafeHitbox(32, 40, 1.2),
  },
  // Boss
  bigbat: {
    key: "bigbat",
    displayName: "chauve-souris géante",
    path: bat1aSpritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 4,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 4),
  },
  ghostskull: {
    key: "ghostskull",
    displayName: "crâne fantôme",
    path: GhostskullSpritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  bigspider: {
    key: "bigspider",
    displayName: "grosse araignée",
    path: BigSpiderSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.5,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.5),
  },
  boneking1: {
    key: "boneking1",
    displayName: "roi des os en tunique noire",
    path: BoneKing1Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.5,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.5),
  },
  boneking2: {
    key: "boneking2",
    displayName: "roi des os en tunique bleue",
    path: BoneKing2Spritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.5,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.5),
  },
  dragon: {
    key: "dragon",
    displayName: "dragon",
    path: dragonSpritesheet,
    frameWidth: 120,
    frameHeight: 120,
    scale: 1,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(120, 120, 1),
  },
  giantant: {
    key: "giantant",
    displayName: "fourmi géante",
    path: giantAntSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.5,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.5),
  },
  medusa: {
    key: "medusa",
    displayName: "méduse",
    path: medusaSpritesheet,
    frameWidth: 48,
    frameHeight: 48,
    scale: 1.5,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 48, 1.5),
  },
  maxibee1: {
    key: "maxibee1",
    displayName: "maxi abeille",
    path: bee1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1.5,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1.5),
  },
  BigBug: {
    key: "BigBug",
    displayName: "insecte géant",
    path: bug1bSpritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 3,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 3),
  },
  GiantFox: {
    key: "GiantFox",
    displayName: "renard géant",
    path: fox2Spritesheet,
    frameWidth: 48,
    frameHeight: 60,
    spacing: 2,
    scale: 4,
    sheetCols: 3,
    sheetRows: 4,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(48, 60, 4),
  },

  zombiequeenBoss: {
    key: "zombiequeenBoss",
    displayName: "reine zombie",
    path: zombiequeenBossSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 2,
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    lootTable: "zombiequeenDrop",
    hitbox: computeSafeHitbox(96, 96, 2),
  },

  beequeenBoss: {
    key: "beequeenBoss",
    displayName: "reine abeille",
    path: beequeenBossSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 2,
    sheetCols: 4,
    sheetRows: 16,
    animations: FULL_ANIMATION_FRAMES,
    lootTable: "beequeenDrop",
    hitbox: computeSafeHitbox(96, 96, 2),
  },
  // NPCs de ville
  NPC_town1_F1: {
    key: "NPC_town1_F1",
    displayName: "PNJ ville 1 femme 1",
    path: town1NPCf1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.9,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 0.9),
  },
  NPC_town1_F2: {
    key: "NPC_town1_F2",
    displayName: "PNJ ville 1 femme 2",
    path: town1NPCf2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town1_F3: {
    key: "NPC_town1_F3",
    displayName: "PNJ ville 1 femme 3",
    path: town1NPCf3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town1_F4: {
    key: "NPC_town1_F4",
    displayName: "PNJ ville 1 femme 4",
    path: town1NPCf4Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town1_F5: {
    key: "NPC_town1_F5",
    displayName: "PNJ ville 1 femme 5",
    path: town1NPCf5Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town1_M1: {
    key: "NPC_town1_M1",
    displayName: "PNJ ville 1 homme 1",
    path: town1NPCm1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.9,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 0.9),
  },
  NPC_town1_M2: {
    key: "NPC_town1_M2",
    displayName: "PNJ ville 1 homme 2",
    path: town1NPCm2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 0.9,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 0.9),
  },
  NPC_town1_M3: {
    key: "NPC_town1_M3",
    displayName: "PNJ ville 1 homme 3",
    path: town1NPCm3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town1_M4: {
    key: "NPC_town1_M4",
    displayName: "PNJ ville 1 homme 4",
    path: town1NPCm4Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town1_M5: {
    key: "NPC_town1_M5",
    displayName: "PNJ ville 1 homme 5",
    path: town1NPCm5Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_F1: {
    key: "NPC_town2_F1",
    displayName: "PNJ ville 2 femme 1",
    path: town2NPCf1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_F2: {
    key: "NPC_town2_F2",
    displayName: "PNJ ville 2 femme 2",
    path: town2NPCf2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_F3: {
    key: "NPC_town2_F3",
    displayName: "PNJ ville 2 femme 3",
    path: town2NPCf3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_F4: {
    key: "NPC_town2_F4",
    displayName: "PNJ ville 2 femme 4",
    path: town2NPCf4Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_F5: {
    key: "NPC_town2_F5",
    displayName: "PNJ ville 2 femme 5",
    path: town2NPCf5Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_M1: {
    key: "NPC_town2_M1",
    displayName: "PNJ ville 2 homme 1",
    path: town2NPCm1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_M2: {
    key: "NPC_town2_M2",
    displayName: "PNJ ville 2 homme 2",
    path: town2NPCm2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_M3: {
    key: "NPC_town2_M3",
    displayName: "PNJ ville 2 homme 3",
    path: town2NPCm3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_M4: {
    key: "NPC_town2_M4",
    displayName: "PNJ ville 2 homme 4",
    path: town2NPCm4Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town2_M5: {
    key: "NPC_town2_M5",
    displayName: "PNJ ville 2 homme 5",
    path: town2NPCm5Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_F1: {
    key: "NPC_town3_F1",
    displayName: "PNJ ville 3 femme 1",
    path: town3NPCf1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_F2: {
    key: "NPC_town3_F2",
    displayName: "PNJ ville 3 femme 2",
    path: town3NPCf2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_F3: {
    key: "NPC_town3_F3",
    displayName: "PNJ ville 3 femme 3",
    path: town3NPCf3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_F4: {
    key: "NPC_town3_F4",
    displayName: "PNJ ville 3 femme 4",
    path: town3NPCf4Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_F5: {
    key: "NPC_town3_F5",
    displayName: "PNJ ville 3 femme 5",
    path: town3NPCf5Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_M1: {
    key: "NPC_town3_M1",
    displayName: "PNJ ville 3 homme 1",
    path: town3NPCm1Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_M2: {
    key: "NPC_town3_M2",
    displayName: "PNJ ville 3 homme 2",
    path: town3NPCm2Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_M3: {
    key: "NPC_town3_M3",
    displayName: "PNJ ville 3 homme 3",
    path: town3NPCm3Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_M4: {
    key: "NPC_town3_M4",
    displayName: "PNJ ville 3 homme 4",
    path: town3NPCm4Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },
  NPC_town3_M5: {
    key: "NPC_town3_M5",
    displayName: "PNJ ville 3 homme 5",
    path: town3NPCm5Spritesheet,
    frameWidth: 32,
    frameHeight: 40,
    scale: 1,
    animations: STANDARD_ANIMATION_FRAMES,
    hitbox: computeSafeHitbox(32, 40, 1),
  },

  meleeSlashEffect: {
    key: "meleeSlashEffect",
    path: meleeSlashSpritesheet,
    frameWidth: 96,
    frameHeight: 96,
    scale: 0.5,
    oneShot: true,
    animations: STANDARD_ANIMATION_FRAMES_4X4,
  },
};

/**
 * Profils de stats des 4 archetypes RPG classiques - meme forme que
 * BASE_STATS/GROWTH_PER_LEVEL dans leveling.js (`base` = stats a
 * depth=1, `growth` = gain par niveau, PEUT etre fractionnaire
 * contrairement aux valeurs generiques - cf. Math.round dans
 * getPlayerStatsForLevel). Volontairement distincts sans qu'aucun ne
 * domine les autres en puissance globale - chacun echange une force
 * contre une faiblesse, principe classique de RPG.
 *
 * `moveSpeed`/`visionRadius`/`meleeRange`/`rangedRange` sont FIXES (pas
 * de progression par niveau, contrairement a base/growth) - lus une
 * seule fois a la creation du heros (cf. MainScene.js), jamais
 * recalcules ensuite :
 *
 * - Guerrier : le plus de PV/defense, degats corps-a-corps solides,
 *   quasi aucun degat a distance - tank de melee pur. Lent, vue courte
 *   (focalise sur ce qui est proche), la plus longue portee de melee
 *   (grande arme), la plus courte portee a distance (pas son domaine).
 * - Archer : degats a distance eleves des le depart et qui montent vite,
 *   PV/defense moderes. Rapide, la meilleure vue (eclaireur/chasseur),
 *   portee de melee courte, la meilleure portee a distance.
 * - Voleur : le plus haut degat corps-a-corps de tous, mais PV/defense
 *   les plus bas du groupe melee. Le plus rapide de tous, bonne vue
 *   (furtif/alerte), portee de melee moyenne, portee a distance
 *   inferieure a la moyenne.
 * - Mage : degats a distance les plus eleves de tous, mais PV/defense
 *   les plus bas du jeu. Vitesse moderee, vue moyenne, la plus courte
 *   portee de melee (evite le corps-a-corps), la meilleure portee a
 *   distance a egalite avec l'archer (portee de la magie).
 */
const HERO_STATS_PROFILES = {
  // guerrier: {
  //   archetype: "guerrier",
  //   base: {
  //     maxHp: 130,
  //     meleeDamage: 10,
  //     rangedDamage: 2,
  //     defense: 3,
  //     mana: 0,
  //     stamina: 20,
  //   },
  //   growth: {
  //     maxHp: 24,
  //     meleeDamage: 2.5,
  //     rangedDamage: 0.5,
  //     defense: 1.4,
  //     mana: 0,
  //     stamina: 1,
  //   },
  //   moveSpeed: 130,
  //   visionRadius: 5,
  //   meleeRange: 56,
  //   rangedRange: 300,
  //   // equipement/objets donnes ET equipes automatiquement au tout debut
  //   // d'une partie NEUVE (jamais a une reprise, cf. MainScene.giveStartingKit)
  //   startingItems: ["woodenSword", "woodenShield"],
  //   startingAmmo: null,
  //   startingAbilities: ["whirlwind", "haste", "flameWeapon", "scoutPulse"],
  // },
  // archer: {
  //   archetype: "archer",
  //   base: {
  //     maxHp: 90,
  //     meleeDamage: 4,
  //     rangedDamage: 10,
  //     defense: 1,
  //     mana: 0,
  //     stamina: 15,
  //   },
  //   growth: {
  //     maxHp: 16,
  //     meleeDamage: 1,
  //     rangedDamage: 2.6,
  //     defense: 0.8,
  //     mana: 0,
  //     stamina: 1,
  //   },
  //   moveSpeed: 160,
  //   visionRadius: 8,
  //   meleeRange: 42,
  //   rangedRange: 440,
  //   startingItems: ["woodenBow"],
  //   startingAmmo: { itemId: "woodenArrow", quantity: 20 },
  //   startingAbilities: ["piercingArrow"],
  // },
  // voleur: {
  //   archetype: "voleur",
  //   base: {
  //     maxHp: 85,
  //     meleeDamage: 11,
  //     rangedDamage: 3,
  //     defense: 0,
  //     mana: 0,
  //     stamina: 18,
  //   },
  //   growth: {
  //     maxHp: 15,
  //     meleeDamage: 2.8,
  //     rangedDamage: 0.7,
  //     defense: 0.6,
  //     mana: 0,
  //     stamina: 1,
  //   },
  //   moveSpeed: 175,
  //   visionRadius: 7,
  //   meleeRange: 46,
  //   rangedRange: 340,
  //   startingItems: ["woodenDagger", "woodenCrossbow"],
  //   startingAmmo: { itemId: "woodenCrossbowBolt", quantity: 30 },
  //   startingAbilities: ["haste", "slow"],
  // },
  // mage: {
  //   archetype: "mage",
  //   base: {
  //     maxHp: 70,
  //     meleeDamage: 2,
  //     rangedDamage: 12,
  //     defense: 0,
  //     mana: 20,
  //     stamina: 20,
  //   },
  //   growth: {
  //     maxHp: 12,
  //     meleeDamage: 0.5,
  //     rangedDamage: 3,
  //     defense: 0.4,
  //     mana: 1,
  //     stamina: 1,
  //   },
  //   moveSpeed: 140,
  //   visionRadius: 6,
  //   meleeRange: 38,
  //   rangedRange: 420,
  //   startingItems: ["woodenStaff"],
  //   startingAmmo: null,
  //   startingAbilities: [],
  // },
  // guerriere: {
  //   archetype: "guerrier",
  //   base: {
  //     maxHp: 130,
  //     meleeDamage: 10,
  //     rangedDamage: 2,
  //     defense: 3,
  //     mana: 0,
  //     stamina: 20,
  //   },
  //   growth: {
  //     maxHp: 24,
  //     meleeDamage: 2.5,
  //     rangedDamage: 0.5,
  //     defense: 1.4,
  //     mana: 0,
  //     stamina: 1,
  //   },
  //   moveSpeed: 130,
  //   visionRadius: 5,
  //   meleeRange: 56,
  //   rangedRange: 300,
  //   startingItems: ["woodenSword", "woodenShield"],
  //   startingAmmo: null,
  //   startingAbilities: [],
  // },
  // archere: {
  //   archetype: "archer",
  //   base: {
  //     maxHp: 90,
  //     meleeDamage: 4,
  //     rangedDamage: 10,
  //     defense: 1,
  //     mana: 0,
  //     stamina: 15,
  //   },
  //   growth: {
  //     maxHp: 16,
  //     meleeDamage: 1,
  //     rangedDamage: 2.6,
  //     defense: 0.8,
  //     mana: 0,
  //     stamina: 1,
  //   },
  //   moveSpeed: 160,
  //   visionRadius: 8,
  //   meleeRange: 42,
  //   rangedRange: 440,
  //   startingItems: ["woodenBow"],
  //   startingAmmo: { itemId: "woodenArrow", quantity: 20 },
  //   startingAbilities: ["piercingArrow"],
  // },
  // voleuse: {
  //   archetype: "voleur",
  //   base: {
  //     maxHp: 85,
  //     meleeDamage: 11,
  //     rangedDamage: 3,
  //     defense: 0,
  //     mana: 0,
  //     stamina: 18,
  //   },
  //   growth: {
  //     maxHp: 15,
  //     meleeDamage: 2.8,
  //     rangedDamage: 0.7,
  //     defense: 0.6,
  //     mana: 0,
  //     stamina: 1,
  //   },
  //   moveSpeed: 175,
  //   visionRadius: 7,
  //   meleeRange: 46,
  //   rangedRange: 340,
  //   startingItems: ["woodenDagger", "woodenCrossbow"],
  //   startingAmmo: { itemId: "woodenCrossbowBolt", quantity: 30 },
  //   startingAbilities: [],
  // },
  // magicienne: {
  //   archetype: "mage",
  //   base: {
  //     maxHp: 70,
  //     meleeDamage: 2,
  //     rangedDamage: 12,
  //     defense: 0,
  //     mana: 20,
  //     stamina: 0,
  //   },
  //   growth: {
  //     maxHp: 12,
  //     meleeDamage: 0.5,
  //     rangedDamage: 3,
  //     defense: 0.4,
  //     mana: 1,
  //     stamina: 0,
  //   },
  //   moveSpeed: 140,
  //   visionRadius: 6,
  //   meleeRange: 38,
  //   rangedRange: 420,
  //   startingItems: ["woodenStaff"],
  //   startingAmmo: null,
  //   startingAbilities: ["fireball"],
  // },
  archer: {
    archetype: "archer",
    base: {
      maxHp: 90,
      meleeDamage: 4,
      rangedDamage: 10,
      defense: 1,
      mana: 0,
      stamina: 15,
    },
    growth: {
      maxHp: 16,
      meleeDamage: 1,
      rangedDamage: 2.6,
      defense: 0.8,
      mana: 0,
      stamina: 1,
    },
    moveSpeed: 160,
    visionRadius: 8,
    meleeRange: 42,
    rangedRange: 440,
    startingItems: [
      "woodenBow",
      // "woodenPickaxe",
      // "woodenAxe",
      // "leatherArmor",
      // "boots",
      // "leatherHelmet",
      // "pants",
      // "belt",
    ],
    startingAmmo: { itemId: "woodenArrow", quantity: 100 },
    startingAbilities: ["piercingArrow", "scoutPulse"],
    startingRecipes: [],
  },
  knight: {
    archetype: "guerrier",
    base: {
      maxHp: 120,
      meleeDamage: 11,
      rangedDamage: 2,
      defense: 4,
      mana: 0,
      stamina: 20,
    },
    growth: {
      maxHp: 18,
      meleeDamage: 2.4,
      rangedDamage: 0.5,
      defense: 1.4,
      mana: 0,
      stamina: 2,
    },
    moveSpeed: 130,
    visionRadius: 6,
    meleeRange: 60,
    rangedRange: 320,
    startingItems: [
      "woodenMallet",
      // "woodenPickaxe", "woodenAxe"
    ],
    startingAmmo: null,
    startingAbilities: ["whirlwind"],
  },
  thief: {
    archetype: "voleur",
    base: {
      maxHp: 80,
      meleeDamage: 6,
      rangedDamage: 4,
      defense: 1,
      mana: 0,
      stamina: 15,
    },
    growth: {
      maxHp: 14,
      meleeDamage: 1.5,
      rangedDamage: 1,
      defense: 0.6,
      mana: 0,
      stamina: 1.5,
    },
    moveSpeed: 170,
    visionRadius: 7,
    meleeRange: 40,
    rangedRange: 400,
    startingItems: ["woodenDagger"],
    startingAmmo: null,
    startingAbilities: [
      "stealth",
      "scoutPulse",
      "detectTraps",
      "detectSecrets",
      "healingAura",
    ],
  },
  warrior: {
    archetype: "guerrier",
    base: {
      maxHp: 120,
      meleeDamage: 15,
      rangedDamage: 3,
      defense: 3,
      mana: 0,
      stamina: 25,
    },
    growth: {
      maxHp: 25,
      meleeDamage: 4,
      rangedDamage: 0.7,
      defense: 1.2,
      mana: 0,
      stamina: 3,
    },
    moveSpeed: 155,
    visionRadius: 7,
    meleeRange: 50,
    rangedRange: 320,
    startingItems: ["woodenSword", "woodenShield"],
    startingAmmo: null,
    startingAbilities: ["shieldBash"],
    startingRecipes: ["reinforcedSwordRecipe"],
  },
  wizard: {
    archetype: "mage",
    base: {
      maxHp: 70,
      meleeDamage: 3,
      rangedDamage: 10,
      defense: 1,
      mana: 30,
      stamina: 10,
    },
    growth: {
      maxHp: 12,
      meleeDamage: 0.5,
      rangedDamage: 2,
      defense: 0.5,
      mana: 5,
      stamina: 1,
    },
    moveSpeed: 150,
    visionRadius: 7,
    meleeRange: 35,
    rangedRange: 450,
    startingItems: [
      "woodenStaff",
      // { itemId: "waterLily", quantity: 2 },
      // "woodenPickaxe",
      // "woodenAxe",
    ],
    startingAmmo: null,
    startingAbilities: ["fireball"],
    // startingRecipes: ["manaPotionRecipe"],
    // damageType: "fire",
    // resistances: { fire: 1 },
  },
  barbarian: {
    archetype: "guerrier",
    base: {
      maxHp: 130,
      meleeDamage: 18,
      rangedDamage: 2,
      defense: 2.5,
      mana: 0,
      stamina: 30,
    },
    growth: {
      maxHp: 30,
      meleeDamage: 5,
      rangedDamage: 0.5,
      defense: 1.5,
      mana: 0,
      stamina: 4,
    },
    moveSpeed: 160,
    visionRadius: 7,
    meleeRange: 55,
    rangedRange: 300,
    startingItems: [
      "woodenMallet",
      // "woodenPickaxe", "woodenAxe"
    ],
    startingAmmo: null,
    startingAbilities: ["taunt"],
  },
  monk: {
    archetype: "mage",
    base: {
      maxHp: 110,
      meleeDamage: 14,
      rangedDamage: 3,
      defense: 2,
      mana: 0,
      stamina: 25,
    },
    growth: {
      maxHp: 25,
      meleeDamage: 4,
      rangedDamage: 0.7,
      defense: 1.2,
      mana: 0,
      stamina: 3,
    },
    moveSpeed: 155,
    visionRadius: 7,
    meleeRange: 50,
    rangedRange: 320,
    startingItems: [
      "woodenStaff",
      // "woodenPickaxe", "woodenAxe"
    ],
    startingAmmo: null,
    startingAbilities: ["curse"],
  },
  druid: {
    archetype: "mage",
    base: {
      maxHp: 120,
      meleeDamage: 12,
      rangedDamage: 4,
      defense: 2,
      mana: 10,
      stamina: 20,
    },
    growth: {
      maxHp: 28,
      meleeDamage: 3,
      rangedDamage: 0.8,
      defense: 1,
      mana: 2,
      stamina: 3,
    },
    moveSpeed: 150,
    visionRadius: 7,
    meleeRange: 45,
    rangedRange: 350,
    startingItems: [
      "woodenStaff",
      // "woodenPickaxe", "woodenAxe"
    ],
    startingAmmo: null,
    startingAbilities: ["summonWolfFamiliar"],
  },
  mage: {
    archetype: "mage",
    base: {
      maxHp: 100,
      meleeDamage: 8,
      rangedDamage: 6,
      defense: 1.5,
      mana: 20,
      stamina: 15,
    },
    growth: {
      maxHp: 20,
      meleeDamage: 2,
      rangedDamage: 1,
      defense: 0.8,
      mana: 3,
      stamina: 2,
    },
    moveSpeed: 140,
    visionRadius: 7,
    meleeRange: 40,
    rangedRange: 400,
    startingItems: [
      "woodenStaff",
      // "woodenPickaxe", "woodenAxe"
    ],
    startingAmmo: null,
    startingAbilities: ["slow"],
  },
};

export const HERO_ROSTER = [
  // {
  //   id: "hero1",
  //   label: "Guerrier",
  //   statsOverride: HERO_STATS_PROFILES.guerrier,
  // },
  // { id: "hero2", label: "Archer", statsOverride: HERO_STATS_PROFILES.archer },
  // { id: "hero3", label: "Voleur", statsOverride: HERO_STATS_PROFILES.voleur },
  // { id: "hero4", label: "Mage", statsOverride: HERO_STATS_PROFILES.mage },
  // {
  //   id: "hero5",
  //   label: "Guerrière",
  //   statsOverride: HERO_STATS_PROFILES.guerriere,
  // },
  // { id: "hero6", label: "Archère", statsOverride: HERO_STATS_PROFILES.archere },
  // {
  //   id: "hero7",
  //   label: "Voleuse",
  //   statsOverride: HERO_STATS_PROFILES.voleuse,
  // },
  // {
  //   id: "hero8",
  //   label: "Magicienne",
  //   statsOverride: HERO_STATS_PROFILES.magicienne,
  // },
  {
    id: "hero9",
    label: "Archer",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.archer,
  },

  {
    id: "hero10",
    label: "Archère",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.archer,
  },
  {
    id: "hero11",
    label: "Chevalier",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.knight,
  },
  {
    id: "hero12",
    label: "Chevalière",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.knight,
  },
  {
    id: "hero13",
    label: "Voleur",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.thief,
  },
  {
    id: "hero14",
    label: "Voleuse",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.thief,
  },
  {
    id: "hero15",
    label: "guerrier",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.warrior,
  },
  {
    id: "hero16",
    label: "Guerrière",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.warrior,
  },
  {
    id: "hero17",
    label: "Sorcier",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.wizard,
  },
  {
    id: "hero18",
    label: "Sorcière",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.wizard,
  },
  {
    id: "hero19",
    label: "Barbare",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.barbarian,
  },
  {
    id: "hero20",
    label: "Barbare",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.barbarian,
  },
  {
    id: "hero21",
    label: "Prêtre",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.monk,
  },
  {
    id: "hero22",
    label: "Nonne",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.monk,
  },
  {
    id: "hero23",
    label: "Druide",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.druid,
  },
  {
    id: "hero24",
    label: "Druidesse",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.druid,
  },
  {
    id: "hero25",
    label: "Mage",
    gender: "male",
    statsOverride: HERO_STATS_PROFILES.mage,
  },
  {
    id: "hero26",
    label: "Magicienne",
    gender: "female",
    statsOverride: HERO_STATS_PROFILES.mage,
  },
];

export function resolveEnemySprite(typeKey) {
  if (SPRITE_REGISTRY[typeKey]) {
    return { entry: SPRITE_REGISTRY[typeKey], spriteKey: typeKey };
  }
  return { entry: SPRITE_REGISTRY.enemyDefault, spriteKey: "enemyDefault" };
}

/**
 * Nom d'affichage d'un type d'ennemi (cf. le champ `displayName` sur
 * chaque entrée de SPRITE_REGISTRY) - utilisé dans le texte des quêtes
 * "tuer X ennemis" (cf. MainScene.js), jamais la clé technique brute.
 * Repli sur la clé technique elle-même si l'entrée est absente ou n'a
 * pas encore de displayName - jamais d'erreur, juste moins joli tant
 * qu'un nom n'a pas été choisi.
 *
 * @param {string} typeKey
 * @returns {string}
 */
export function resolveEnemyDisplayName(typeKey) {
  const entry = SPRITE_REGISTRY[typeKey];
  return (entry && entry.displayName) || typeKey;
}

/**
 * Nom a afficher pour une CIBLE de quete "tuer X ennemis" : si la cible
 * est une famille (cf. champ `family` / `familyName` de SPRITE_REGISTRY),
 * on affiche le nom de famille (toutes couleurs confondues) plutot que
 * le nom de la seule variante de base. Sinon, comportement normal.
 *
 * @param {string} targetType cle de variante ou de famille
 * @returns {string}
 */
export function resolveEnemyTargetName(targetType) {
  // cible = identifiant de famille : cherche le familyName sur
  // n'importe quelle entree de cette famille
  const familyEntry = Object.values(SPRITE_REGISTRY).find(
    (e) => e.family === targetType && e.familyName,
  );
  if (familyEntry) return familyEntry.familyName;
  return resolveEnemyDisplayName(targetType);
}

/**
 * Liste de toutes les entrées "vrais ennemis" de SPRITE_REGISTRY (tout ce
 * qui a un lootTable - exclut le héros, les PNJ NPC_town*, les leviers,
 * enemyDefault et les familiers non rencontrés en tant qu'ennemis comme
 * wolfFamiliar) - utilisé par le bestiaire (BestiaryScreen.js).
 *
 * @returns {Array<{key: string, entry: Object}>}
 */
export function getBestiaryEntries() {
  return Object.entries(SPRITE_REGISTRY)
    .filter(([, entry]) => entry.lootTable)
    .map(([key, entry]) => ({ key, entry }))
    .sort((a, b) =>
      (a.entry.displayName || a.key).localeCompare(
        b.entry.displayName || b.key,
        "fr",
      ),
    );
}

export function resolveHeroSprite(heroId) {
  if (SPRITE_REGISTRY[heroId]) {
    return { entry: SPRITE_REGISTRY[heroId], spriteKey: heroId };
  }
  return { entry: SPRITE_REGISTRY.hero1, spriteKey: "hero1" };
}

/**
 * Profil de stats (cf. HERO_STATS_PROFILES) du heros choisi, pour
 * getPlayerStatsForLevel (leveling.js) - repli sur celui de hero1 si
 * l'id recu ne correspond a aucune entree connue du roster (meme
 * logique de repli que resolveHeroSprite).
 *
 * @param {string} heroId
 * @returns {{base:Object, growth:Object}}
 */
export function resolveHeroStatsOverride(heroId) {
  const hero = HERO_ROSTER.find((h) => h.id === heroId) || HERO_ROSTER[0];
  return hero.statsOverride;
}

// vrai si l'ennemi correspond a la cible de quete `targetType` : meme type
// serveur, meme cle de sprite, ou meme famille (toutes les couleurs d'un
// meme monstre). `spriteKey` est la cle resolue (cf. resolveEnemySprite).
export function matchesEnemyTarget(targetType, archetype, spriteKey) {
  if (targetType === archetype || targetType === spriteKey) return true;
  const family =
    SPRITE_REGISTRY[spriteKey]?.family || SPRITE_REGISTRY[archetype]?.family;
  return !!family && family === targetType;
}

export function getUniqueTexturesToLoad() {
  const seen = new Map();
  for (const entry of Object.values(SPRITE_REGISTRY)) {
    if (!seen.has(entry.key)) {
      seen.set(entry.key, entry);
    }
  }
  return [...seen.values()];
}

export const TILE_IMAGE_REGISTRY = {
  cave: { wallKey: "wall_cave", floorKey: "floor_cave" },
  desert: { wallKey: "wall_desert", floorKey: "floor_desert" },
  tree: { wallKey: "wall_tree", floorKey: "floor_tree" },
  stair: { stairUpKey: "stair_up", stairDownKey: "stair_down" },
};

const TILE_IMAGE_PATHS = {
  wall_cave: wallCaveSprite,
  floor_cave: floorCaveSprite,
  wall_desert: wallDesertSprite,
  floor_desert: floorDesertSprite,
  wall_tree: wallTreeSprite,
  floor_tree: floorTreeSprite,
  stair_up: stairupSprite,
  stair_down: stairdownSprite,
};

/**
 * Liste {key, path} de toutes les images de tuiles/reperes a charger -
 * separee de getUniqueTexturesToLoad() (spritesheets) car il s'agit
 * d'images simples (this.load.image, pas this.load.spritesheet), cf.
 * BootScene.js.
 *
 * Generalisee pour scanner TOUTES les valeurs de chaque entree (pas
 * seulement wallKey/floorKey codes en dur) - une entree peut avoir
 * n'importe quelle forme (wallKey/floorKey pour un biome, stairUpKey/
 * stairDownKey pour les reperes de montee/descente...), tant que ses
 * valeurs correspondent a des cles presentes dans TILE_IMAGE_PATHS.
 * Une valeur null (ex: tree.floorKey) est simplement ignoree, pas une
 * erreur - cf. le commentaire de TILE_IMAGE_REGISTRY plus haut.
 */
export function getTileImagesToLoad() {
  const seen = new Map();
  for (const entry of Object.values(TILE_IMAGE_REGISTRY)) {
    for (const key of Object.values(entry)) {
      if (key && !seen.has(key) && TILE_IMAGE_PATHS[key]) {
        seen.set(key, { key, path: TILE_IMAGE_PATHS[key] });
      }
    }
  }
  return [...seen.values()];
}

/**
 * Spritesheet des coffres - registre DISTINCT de SPRITE_REGISTRY (pas un
 * personnage anime : aucun cycle de marche, juste des frames statiques
 * adressables individuellement - createAnimationsForEntry planterait sur
 * une entree sans structure walkDown/walkLeft/etc.) et de
 * TILE_IMAGE_REGISTRY (pas une texture de tuile repetee - un vrai
 * spritesheet a frames indexees, charge via this.load.spritesheet, cf.
 * BootScene.js).
 */
export const CHEST_SPRITESHEET = {
  key: "chests",
  path: chestsSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
};
export const ICON_SPRITESHEET = {
  key: "icons",
  path: iconSheet1,
  frameWidth: 32,
  frameHeight: 32,
  columns: 10,
  rows: 22,
};
export const ICON_SPRITESHEET_2 = {
  key: "icons2",
  path: iconSheet2,
  frameWidth: 32,
  frameHeight: 32,
  columns: 10,
  rows: 14,
};

export const ICON_SKILL_SPRITESHEET = {
  key: "iconskill1",
  path: iconskill1Spritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 8,
  rows: 10,
};

export const ITEMS_1_SPRITESHEET = {
  key: "items1",
  path: items1Spritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 20,
  rows: 18,
};

export const LEVER_SPRITESHEET = {
  key: "lever",
  path: leverSpritesheet,
  frameWidth: 16,
  frameHeight: 16,
  columns: 3,
  rows: 1,
};

export const MONSTER_LOOTS_SPRITESHEET = {
  key: "monster_loots",
  path: monster_lootsSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 10,
  rows: 9,
};

export const WEAPONS_TIERS_SPRITESHEET = {
  key: "weapons_tiers",
  path: weaponsTiersSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 13,
  rows: 33,
};

export const ARMOR_TIERS_SPRITESHEET = {
  key: "armor_tiers",
  path: armorTiersSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 13,
  rows: 10,
};

export const STAFF_ALL_TIERS_SPRITESHEET = {
  key: "staff_all_tiers",
  path: staffAllTiersSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 10,
  rows: 5,
};

export const ARMOR_TEXTILE_TIERS_SPRITESHEET = {
  key: "armor_textile_tiers",
  path: armorTextileTiersSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 13,
  rows: 10,
};

export const PANTS_TIERS_SPRITESHEET = {
  key: "pants_all_tiers",
  path: pantsAllTiersSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 13,
  rows: 4,
};

export const BELT_ALL_TIERS_SPRITESHEET = {
  key: "belt_all_tiers",
  path: beltAllTiersSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 13,
  rows: 4,
};

export const RING_NECKLACE_ALL_TIERS_SPRITESHEET = {
  key: "ring_necklace_all_tiers",
  path: ringNecklaceAllTiersSpritesheet,
  frameWidth: 32,
  frameHeight: 32,
  columns: 13,
  rows: 10,
};

// icon sheet 1 : 10 colonnes x 22 lignes, frames indexees ligne par ligne

export const ICON_SHEET_1_FRAMES = {
  // huntingBow: 12,

  // warBow: 22,

  woodenArrow: 30,
  ironArrow: 31,
  // bronzeArrow: 32,
  acidArrow: 33,
  fireArrow: 34,
  iceArrow: 35,
  lightningArrow: 36,
  poisonArrow: 37,
  simpleQuiver: 38,
  reinforcedQuiver: 39,
  mageCloth: 40,
  plateArmor: 42,
  woodenRoundShield: 44,
  woodenTowerShield: 45,
  leatherBoots: 46,
  magicianHat: 47,
  sorcererCloak: 50,
  hunterCloak: 51,
  superiorPlateArmor: 52,
  ironRoundShield: 54,
  ironTowerShield: 55,
  adventurerBoots: 56,
  sorcererHat: 57,
  enchantedHat: 58,
  plateHelmet: 59,
  fireStaff: 61,
  lightningStaff: 62,
  iceStaff: 63,
  ringOfHealth: 64,
  ringOfStrength: 65,
  ringOfMagic: 66,
  strengthCharm: 68,
  magicCharm: 69,
  healthPotion: 70,
  mediumHealthPotion: 71,
  largeHealthPotion: 72,
  manaPotion: 73,
  mediumManaPotion: 74,
  largeManaPotion: 75,
  otherObject3: 76,
  otherObject4: 77,
  otherObject5: 78,
  otherObject6: 79,
  gold: 80,
  otherObject8: 81,
  otherObject9: 82,
  otherObject10: 83,
  otherObject11: 84,
  rubis: 85,
  otherObject13: 86,
  emeraude: 87,
  otherObject15: 88,
  diamond: 89,
  treasureMap: 90,
  grimoire: 91,
  summonAngryBrownMushroomScroll: 91,
  summonGnomeScroll: 91,
  summonAngryTrentScroll: 91,
  summonKnifedBatScroll: 91,
  summonDeer1Scroll: 91,
  bag: 92,
  bigBag: 93,
  pouch: 94,
  alricMerchandise: 94,
  brownChest: 95,
  redChest: 96,
  rustyKey: 97,
  silverKey: 98,
  // bronzeKey: 99,
  wood: 100,
  woodAngryTrent: 100,
  stone: 101,
  meat: 102,
  deerMeat: 102,
  cheese: 103,
  apple: 104,
  poisonedApple: 105,
  otherObject33: 106,
  egg: 107,
  brownEgg: 108,
  goldenEgg: 109,
  carrot: 110,
  berries: 111,
  sunflower: 112,
  yellowFlower: 113,
  blueFlower: 114,
  redFlower: 115,
  fishingRod: 116,
  earthworms: 117,
  goldenFish: 118,
  blueFish: 119,
  otherObject47: 120,
  gears: 121,
  otherObject49: 122,
  otherObject50: 123,
  otherObject51: 124,
  otherObject52: 125,
  bigSkull: 126,
  skull: 127,
  otherObject55: 128,
  otherObject56: 129,
  fireWall: 130,
  otherObject58: 131,
  otherObject59: 132,
  otherObject60: 133,
  fireball: 134,
  otherObject62: 135,
  otherObject63: 136,
  otherObject64: 137,
  otherObject65: 138,
  otherObject66: 139,
  otherObject67: 140,
  flameWeapon: 141,
  otherObject69: 142,
  otherObject70: 143,
  otherObject71: 144,
  fireSwordBlazon: 145,
  otherObject73: 146,
  otherObject74: 147,
  blueShieldBlazon: 148,
  threeArrowsBlazon: 149,
  greenSkullBlazon: 150,
  redDwarfBlazon: 151,
  blueSkullBlazon: 152,
  haste: 153,
  otherObject81: 154,
  otherObject82: 155,
  otherObject83: 156,
  otherObject84: 157,
  otherObject85: 158,
  otherObject86: 159,
  otherObject87: 160,
  otherObject88: 161,
  otherObject89: 162,
  otherObject90: 163,
  otherObject91: 164,
  otherObject92: 165,
  otherObject93: 166,
  otherObject94: 167,
  otherObject95: 168,
  otherObject96: 169,
  otherObject97: 170,
  otherObject98: 171,
  otherObject99: 172,
  pinkMushroom: 173,
  redMushroom: 174,
  orangeMushroom: 175,
  blueMushroom: 176,
  redEye: 177,
  yellowEye: 178,
  pinkEye: 179,
  whiteBone: 180,
  brownBone: 181,
  redBone: 182,
  // greenSlime: 183,
  // orangeSlime: 184,
  // redSlime: 185,
  // blueSlime: 186,
  whiteClaw: 187,
  greyClaw: 188,
  brownClaw: 189,
  otherObject117: 190,
  otherObject118: 191,
  otherObject119: 192,
  otherObject120: 193,
  otherObject121: 194,
  otherObject122: 195,
  otherObject123: 196,
  otherObject124: 197,
  otherObject125: 198,
  otherObject126: 199,
  otherObject127: 200,
  otherObject128: 201,
  otherObject129: 202,
  otherObject130: 203,
  otherObject131: 204,
  otherObject132: 205,
  otherObject133: 206,
  otherObject134: 207,
  otherObject135: 208,
  otherObject136: 209,
  otherObject137: 210,
  otherObject138: 211,
  otherObject139: 212,
  otherObject140: 213,
  otherObject141: 214,
  otherObject142: 215,
  otherObject143: 216,
  otherObject144: 217,
  otherObject145: 218,
  otherObject146: 219,
  summonMudGolemScroll: 91,
  summonRedBeetleScroll: 91,
  summonPinkOgreScroll: 91,
  summonBatScroll: 91,
  summonBearScroll: 91,
  summonBeeScroll: 91,
  summonDemonDragonScroll: 91,
  summonDwarfScroll: 91,
  summonFantasy1Scroll: 91,
  summonFantasy2Scroll: 91,
  summonFantasy3Scroll: 91,
  summonFantasy4Scroll: 91,
  summonOrqueGreenScroll: 91,
  summonRedWarriorMushroomScroll: 91,
  summonFantasy7Scroll: 91,
  summonMassecailleBlueScroll: 91,
  summonFantasy9Scroll: 91,
  summonKnightJauneRougeScroll: 91,
  summonGargoyleScroll: 91,
  summonGhostScroll: 91,
  summonGnomeFouScroll: 91,
  summonGolemScroll: 91,
  summonGorillaScroll: 91,
  summonGreendragonScroll: 91,
  summonOgreBrownScroll: 91,
  summonRedbeetleScroll: 91,
  summonRobot1Scroll: 91,
  summonRobot2Scroll: 91,
  summonRobot3Scroll: 91,
  summonRobot4Scroll: 91,
  summonRobot5Scroll: 91,
  summonRobot6Scroll: 91,
  summonRobot7Scroll: 91,
  summonRobot8Scroll: 91,
  summonRobot9Scroll: 91,
  summonRobot10Scroll: 91,
  summonSkeletonScroll: 91,
  summonSkeletonkingScroll: 91,
  summonSlimeScroll: 91,
  summonSpiderScroll: 91,
  summonYellowSlimeScroll: 91,
  summonBlueSlimeScroll: 91,
  summonPurpleSlimeScroll: 91,
  summonYellowWarriorMushroomScroll: 91,
  summonBlueWarriorMushroomScroll: 91,
  summonGreenWarriorMushroomScroll: 91,
  summonPurpleWarriorMushroomScroll: 91,
  summonBlackBearScroll: 91,
  summonWhiteBearScroll: 91,
  summonKnightBleuArgentScroll: 91,
  summonKnightNoirCramoisiScroll: 91,
  summonKnightVertOrScroll: 91,
  summonKnightVioletArgentScroll: 91,
  summonMassecaillePurpleScroll: 91,
  summonMassecailleGreenScroll: 91,
  summonMassecailleRedScroll: 91,
  summonMassecailleYellowScroll: 91,
  summonOrqueBlackScroll: 91,
  summonOrqueYellowScroll: 91,
  summonOrqueBlueScroll: 91,
  summonOrqueRedScroll: 91,
  summonOrquePurpleScroll: 91,
  summonOrqueGreyScroll: 91,
  summonTrollBlueScroll: 91,
  summonTrollGrisScroll: 91,
  summonTrollRoseScroll: 91,
  summonTrollRougeScroll: 91,
  summonTrollVertScroll: 91,
  summonTrollVioletScroll: 91,
  summonWarlockRedScroll: 91,
  summonWarlockWhiteScroll: 91,
  summonWarlockGreenScroll: 91,
  summonWarlockBlueScroll: 91,
  summonWarlockBlackScroll: 91,
  summonWarlockPurpleScroll: 91,
  summonGolemEauScroll: 91,
  summonGolemFeuScroll: 91,
  summonGolemFoudreScroll: 91,
  summonGolemGlaceScroll: 91,
  summonGolemOmbreScroll: 91,
  summonZombiequeenBossScroll: 91,
  summonZombiequeenScroll: 91,
  summonBeequeenBossScroll: 91,
  summonBeequeenScroll: 91,
  summonGrayGriblinScroll: 91,
  summonGreenGriblinScroll: 91,
  summonRedGriblinScroll: 91,
  summonBlueGriblinScroll: 91,
  summonPurpleGriblinScroll: 91,
  summonGoldGriblinScroll: 91,
  summonRedManditaureScroll: 91,
  summonBlueManditaureScroll: 91,
  summonGreenManditaureScroll: 91,
  summonPurpleManditaureScroll: 91,
  summonYellowManditaureScroll: 91,
  summonBlackManditaureScroll: 91,
  summonPurpleSpectrelinScroll: 91,
  summonOrangeSpectrelinScroll: 91,
  summonCyanSpectrelinScroll: 91,
  summonPinkSpectrelinScroll: 91,
  summonSilverSpectrelinScroll: 91,
  summonBronzeSpectrelinScroll: 91,
  loreScroll1: 91,
  summonGreenGemmacrabeScroll: 91,
  summonRedGemmacrabeScroll: 91,
  summonBlueGemmacrabeScroll: 91,
  summonYellowGemmacrabeScroll: 91,
  summonOrangeGemmacrabeScroll: 91,
  summonWhiteGemmacrabeScroll: 91,
  summonBlueGrayVesperinScroll: 91,
  summonSilverVesperinScroll: 91,
  summonGoldVesperinScroll: 91,
  summonCopperVesperinScroll: 91,
  summonSteelVesperinScroll: 91,
  summonEmeraldVesperinScroll: 91,
  summonOrangeTikorinScroll: 91,
  summonLightOakTikorinScroll: 91,
  summonWalnutTikorinScroll: 91,
  summonMahoganyTikorinScroll: 91,
  summonEbonyTikorinScroll: 91,
  summonGoldenBeechTikorinScroll: 91,
  summonPinkLimacorneScroll: 91,
  summonDeepBlueLimacorneScroll: 91,
  summonTurquoiseLimacorneScroll: 91,
  summonAlgaeGreenLimacorneScroll: 91,
  summonCoralLimacorneScroll: 91,
  summonPearlLimacorneScroll: 91,
  summonCraquelinScroll: 91,
  summonCraqueglaceScroll: 91,
  summonCraqueveninScroll: 91,
  summonCraquarcaneScroll: 91,
  summonCraquorScroll: 91,
  summonCraquombreScroll: 91,
  summonRedSlimeScroll: 91,
  summonOrangeSlimeScroll: 91,
  summonSkyBlueSlimeScroll: 91,
  summonGreenSlimeScroll: 91,
};

export const ICON_SHEET_2_FRAMES = {
  greenApple: 61,
};

export const MONSTER_LOOTS_FRAMES = {
  insectWings: 0,
  batWings: 1,
  seaMonsterPaw: 2,
  frogLeg: 3,
  monsterFin: 4,
  crabClaw: 5,
  seaStar: 6,
  monsterTentacle: 7,
  bigSeaShell: 8,
  seaAlgae: 9,
  redMeat: 10,
  whiteMeat: 11,
  canineTooth: 12,
  snakeFang: 13,
  slimeBlob: 14,
  ghostEctoplasm: 15,
  dragonScale: 16,
  birdFeather: 17,
  crowFeather: 18,
  humanEye: 19,
  monsterEye: 20,
  batEye: 20,
  monsterHeart: 21,
  monsterLiver: 22,
  monsterCore: 23,
  angryBrownMushroomCore: 23,
  gnomeGreenCore: 23,
  angryTrentCore: 23,
  knifedBatCore: 23,
  monsterHorn: 24,
  monsterBone: 25,
  deerBone: 25,
  monsterSpine: 26,
  deerAntler: 27,
  humanSkull: 28,
  goblinNose: 29,
  birdNest: 30,
  beeStinger: 31,
  honeycomb: 32,
  spiderLeg: 33,
  insectEgg: 34,
  greyMonsterScale: 35,
  deerHoof: 36,
  bearPaw: 37,
  furTuft: 38,
  gnomeFurTuft: 38,
  batFur: 38,
  orqueGreyFurTuft: 38,
  blackBearFurTuft: 38,
  bearPelt: 39,
  blackBearPelt: 40,
  coal: 41,
  whetstone: 42,
  foolsGold: 43,
  moonStone: 44,
  diamond: 45,
  smokyQuartz: 46,
  ruby: 47,
  aquaMarine: 48,
  peridot: 49,
  lapisLazuli: 50,
  thunderTopaz: 51,
  blueBerries: 52,
  goldenGinger: 53,
  waterLily: 54,
  cherries: 55,
  clover: 56,
  redApple: 57,
  rareMonsterFungus: 58,
  cheese: 59,
  redSmallCultivationPill: 60,
  redBigCultivationPill: 61,
  redHugeCultivationPill: 62,
  blueLowerGradeCultivationPill: 63,
  blueAverageGradeCultivationPill: 64,
  blueHigherGradeCultivationPill: 65,
  nuts: 66,
  pepper: 67,
  gingerRoot: 68,
  cookies: 69,
  fortuneCookie: 70,
  candy: 71,
  seaShell: 72,
  redSeaShell: 73,
  fishTail: 74,
  greenMonsterScale: 75,
  turtleShell: 76,
  strippedMonsterEgg: 77,
  greenBlueDottedMonsterEgg: 78,
  yellowRedStripedMonsterEgg: 79,
  monsterTeeth: 80,
  monsterClaw: 81,
  gnomeClaw: 81,
  monsterTail: 82,
  monsterEar: 83,
  monsterRib: 84,
  antitode: 85,
  craftedManaPotion: 86,
  craftedHealthPotion: 87,
  poison: 88,
  mushroom: 89,
  mudGolemCore: 23,
  redBeetleCore: 23,
  pinkOgreCore: 23,
  batCore: 23,
  brownBearCore: 23,
  beeCore: 23,
  demonDragonCore: 23,
  dwarfCore: 23,
  fantasy1Core: 23,
  fantasy2Core: 23,
  fantasy3Core: 23,
  fantasy4Core: 23,
  orqueGreenCore: 23,
  redWarriorMushroomCore: 23,
  fantasy7Core: 23,
  massecailleBlueCore: 23,
  fantasy9Core: 23,
  knightJauneRougeCore: 23,
  gargoyleCore: 23,
  ghostCore: 23,
  gnomeFouCore: 23,
  golemCore: 23,
  gorillaCore: 23,
  greendragonCore: 23,
  ogreBrownCore: 23,
  redbeetleCore: 23,
  robot1Core: 23,
  robot2Core: 23,
  robot3Core: 23,
  robot4Core: 23,
  robot5Core: 23,
  robot6Core: 23,
  robot7Core: 23,
  robot8Core: 23,
  robot9Core: 23,
  robot10Core: 23,
  skeletonCore: 23,
  skeletonkingCore: 23,
  slimeCore: 23,
  spiderCore: 23,
  yellowSlimeCore: 23,
  blueSlimeCore: 23,
  purpleSlimeCore: 23,
  yellowWarriorMushroomCore: 23,
  blueWarriorMushroomCore: 23,
  greenWarriorMushroomCore: 23,
  purpleWarriorMushroomCore: 23,
  blackBearCore: 23,
  whiteBearCore: 23,
  knightBleuArgentCore: 23,
  knightNoirCramoisiCore: 23,
  knightVertOrCore: 23,
  knightVioletArgentCore: 23,
  massecaillePurpleCore: 23,
  massecailleGreenCore: 23,
  massecailleRedCore: 23,
  massecailleYellowCore: 23,
  orqueBlackCore: 23,
  orqueYellowCore: 23,
  orqueBlueCore: 23,
  orqueRedCore: 23,
  orquePurpleCore: 23,
  orqueGreyCore: 23,
  trollBlueCore: 23,
  trollGrisCore: 23,
  trollRoseCore: 23,
  trollRougeCore: 23,
  trollVertCore: 23,
  trollVioletCore: 23,
  warlockRedCore: 23,
  warlockWhiteCore: 23,
  warlockGreenCore: 23,
  warlockBlueCore: 23,
  warlockBlackCore: 23,
  warlockPurpleCore: 23,
  golemEauCore: 23,
  golemFeuCore: 23,
  golemFoudreCore: 23,
  golemGlaceCore: 23,
  golemOmbreCore: 23,
  zombiequeenBossCore: 23,
  zombiequeenCore: 23,
  beequeenBossCore: 23,
  beequeenCore: 23,
  grayGriblinCore: 23,
  greenGriblinCore: 23,
  redGriblinCore: 23,
  blueGriblinCore: 23,
  purpleGriblinCore: 23,
  goldGriblinCore: 23,
  redManditaureCore: 23,
  blueManditaureCore: 23,
  greenManditaureCore: 23,
  purpleManditaureCore: 23,
  yellowManditaureCore: 23,
  blackManditaureCore: 23,
  purpleSpectrelinCore: 23,
  orangeSpectrelinCore: 23,
  cyanSpectrelinCore: 23,
  pinkSpectrelinCore: 23,
  silverSpectrelinCore: 23,
  bronzeSpectrelinCore: 23,
  greenGemmacrabeCore: 23,
  redGemmacrabeCore: 23,
  blueGemmacrabeCore: 23,
  yellowGemmacrabeCore: 23,
  orangeGemmacrabeCore: 23,
  whiteGemmacrabeCore: 23,
  blueGrayVesperinCore: 23,
  silverVesperinCore: 23,
  goldVesperinCore: 23,
  copperVesperinCore: 23,
  steelVesperinCore: 23,
  emeraldVesperinCore: 23,
  orangeTikorinCore: 23,
  lightOakTikorinCore: 23,
  walnutTikorinCore: 23,
  mahoganyTikorinCore: 23,
  ebonyTikorinCore: 23,
  goldenBeechTikorinCore: 23,
  pinkLimacorneCore: 23,
  deepBlueLimacorneCore: 23,
  turquoiseLimacorneCore: 23,
  algaeGreenLimacorneCore: 23,
  coralLimacorneCore: 23,
  pearlLimacorneCore: 23,
  craquelinCore: 23,
  craqueglaceCore: 23,
  craqueveninCore: 23,
  craquarcaneCore: 23,
  craquorCore: 23,
  craquombreCore: 23,
  redSlimeCore: 23,
  orangeSlimeCore: 23,
  skyBlueSlimeCore: 23,
  greenSlimeCore: 23,
};

export const ICON_SKILL_1_FRAMES = {
  fireballBook: 0,
  electricShockBook: 10,
};

export const ITEMS_1_FRAMES = {
  throwableShank: 0,
  throwableButterKnife: 1,
  throwableKunai: 2,
  throwableShuriken: 3,
  throwableBoomerang: 9,
  branch: 20,
  // toutes les essences de bois partagent le meme sprite de base que
  // "branch" - la distinction visuelle vient de la teinte CSS appliquee
  // dans ItemIcon (ICON_TINTS), pas d'une frame differente
  oakWood: 20,
  ashWood: 20,
  yewWood: 20,
  ebonyWood: 20,
  petrifiedWood: 20,
  mistwood: 20,
  runewood: 20,
  skywood: 20,
  scarletwood: 20,
  sacredWood: 20,
  eternalWood: 20,
  starwood: 20,
  woodenCrossbowBolt: 25,
  copperOre: 40,
  copperIngot: 41,
  copperMetalChunk: 42,
  copperDust: 43,
  ironOre: 60,
  ironIngot: 61,
  ironMetalChunk: 62,
  ironDust: 63,
  silverOre: 80,
  silverIngot: 81,
  silverMetalChunk: 82,
  silverDust: 83,
  coalOre: 100,
  steelIngot: 101,
  steelMetalChunk: 102,
  steelDust: 103,
  goldOre: 120,
  goldIngot: 121,
  goldMetalChunk: 122,
  goldDust: 123,
  platiniumOre: 140,
  platiniumIngot: 141,
  platiniumMetalChunk: 142,
  platiniumDust: 143,
  cobaltOre: 160,
  cobaltIngot: 161,
  cobaltMetalChunk: 162,
  cobaltDust: 163,
  adamantineOre: 180,
  adamantineIngot: 181,
  adamantineMetalChunk: 182,
  adamantineDust: 183,
  crimsonOre: 200,
  crimsonIngot: 201,
  crimsonMetalChunk: 202,
  crimsonDust: 203,
  angelicOre: 220,
  angelicIngot: 221,
  angelicMetalChunk: 222,
  angelicDust: 223,
  fatefulOre: 240,
  fatefulIngot: 241,
  fatefulMetalChunk: 242,
  fatefulDust: 243,
  novaOre: 260,
  novaIngot: 261,
  novaMetalChunk: 262,
  novaDust: 263,
  whiteFeather: 300,
  greyFeather: 302,
  blackFeather: 304,
  brownFeather: 306,
  redFeather: 308,
  lightPurpleFeather: 310,
  purpleFeather: 312,
  blueFeather: 314,
  cyanFeather: 316,
  greenFeather: 318,
  yellowFeather: 320,
  bigWhiteFeather: 322,
  bigRedFeather: 323,
  bigLightPurpleFeather: 324,
  bigPurpleFeather: 325,
  bigBlueFeather: 326,
  bigCyanFeather: 329,
  bigGreenFeather: 327,
  bigYellowFeather: 328,
};

export const WEAPON_TIERS_FRAMES = {
  // Dagger - base
  woodenDagger: 0,
  copperDagger: 1,
  ironDagger: 2,
  steelDagger: 3,
  silverDagger: 4,
  goldDagger: 5,
  platiniumDagger: 6,
  cobaltDagger: 7,
  adamantineDagger: 8,
  crimsonDagger: 9,
  angelicDagger: 10,
  fatefulDagger: 11,
  novaDagger: 12,

  // Dagger - aiguisée
  sharpWoodenDagger: 13,
  sharpCopperDagger: 14,
  sharpIronDagger: 15,
  sharpSteelDagger: 16,
  sharpSilverDagger: 17,
  sharpGoldDagger: 18,
  sharpPlatiniumDagger: 19,
  sharpCobaltDagger: 20,
  sharpAdamantineDagger: 21,
  sharpCrimsonDagger: 22,
  sharpAngelicDagger: 23,
  sharpFatefulDagger: 24,
  sharpNovaDagger: 25,

  // Dagger - renforcée
  reinforcedWoodenDagger: 26,
  reinforcedCopperDagger: 27,
  reinforcedIronDagger: 28,
  reinforcedSteelDagger: 29,
  reinforcedSilverDagger: 30,
  reinforcedGoldDagger: 31,
  reinforcedPlatiniumDagger: 32,
  reinforcedCobaltDagger: 33,
  reinforcedAdamantineDagger: 34,
  reinforcedCrimsonDagger: 35,
  reinforcedAngelicDagger: 36,
  reinforcedFatefulDagger: 37,
  reinforcedNovaDagger: 38,

  // Sword - base
  woodenSword: 39,
  copperSword: 40,
  ironSword: 41,
  steelSword: 42,
  silverSword: 43,
  goldSword: 44,
  platiniumSword: 45,
  cobaltSword: 46,
  adamantineSword: 47,
  crimsonSword: 48,
  angelicSword: 49,
  fatefulSword: 50,
  novaSword: 51,

  // Sword - aiguisée
  sharpWoodenSword: 52,
  sharpCopperSword: 53,
  sharpIronSword: 54,
  sharpSteelSword: 55,
  sharpSilverSword: 56,
  sharpGoldSword: 57,
  sharpPlatiniumSword: 58,
  sharpCobaltSword: 59,
  sharpAdamantineSword: 60,
  sharpCrimsonSword: 61,
  sharpAngelicSword: 62,
  sharpFatefulSword: 63,
  sharpNovaSword: 64,

  // Sword - renforcée
  reinforcedWoodenSword: 65,
  reinforcedCopperSword: 66,
  reinforcedIronSword: 67,
  reinforcedSteelSword: 68,
  reinforcedSilverSword: 69,
  reinforcedGoldSword: 70,
  reinforcedPlatiniumSword: 71,
  reinforcedCobaltSword: 72,
  reinforcedAdamantineSword: 73,
  reinforcedCrimsonSword: 74,
  reinforcedAngelicSword: 75,
  reinforcedFatefulSword: 76,
  reinforcedNovaSword: 77,

  // Bow - base
  woodenBow: 78,
  oakBow: 79,
  ashBow: 80,
  yewBow: 81,
  ebonyBow: 82,
  petrifiedBow: 83,
  mistwoodBow: 84,
  runewoodBow: 85,
  skywoodBow: 86,
  scarletwoodBow: 87,
  sacredBow: 88,
  eternalBow: 89,
  starwoodBow: 90,

  // Bow - aiguisée
  sharpWoodenBow: 91,
  sharpOakBow: 92,
  sharpAshBow: 93,
  sharpYewBow: 94,
  sharpEbonyBow: 95,
  sharpPetrifiedBow: 96,
  sharpMistwoodBow: 97,
  sharpRunewoodBow: 98,
  sharpSkywoodBow: 99,
  sharpScarletwoodBow: 100,
  sharpSacredBow: 101,
  sharpEternalBow: 102,
  sharpStarwoodBow: 103,

  // Bow - renforcée
  reinforcedWoodenBow: 104,
  reinforcedOakBow: 105,
  reinforcedAshBow: 106,
  reinforcedYewBow: 107,
  reinforcedEbonyBow: 108,
  reinforcedPetrifiedBow: 109,
  reinforcedMistwoodBow: 110,
  reinforcedRunewoodBow: 111,
  reinforcedSkywoodBow: 112,
  reinforcedScarletwoodBow: 113,
  reinforcedSacredBow: 114,
  reinforcedEternalBow: 115,
  reinforcedStarwoodBow: 116,

  // Spear - base
  woodenSpear: 117,
  copperSpear: 118,
  ironSpear: 119,
  steelSpear: 120,
  silverSpear: 121,
  goldSpear: 122,
  platiniumSpear: 123,
  cobaltSpear: 124,
  adamantineSpear: 125,
  crimsonSpear: 126,
  angelicSpear: 127,
  fatefulSpear: 128,
  novaSpear: 129,

  // Spear - aiguisée
  sharpWoodenSpear: 130,
  sharpCopperSpear: 131,
  sharpIronSpear: 132,
  sharpSteelSpear: 133,
  sharpSilverSpear: 134,
  sharpGoldSpear: 135,
  sharpPlatiniumSpear: 136,
  sharpCobaltSpear: 137,
  sharpAdamantineSpear: 138,
  sharpCrimsonSpear: 139,
  sharpAngelicSpear: 140,
  sharpFatefulSpear: 141,
  sharpNovaSpear: 142,

  // Spear - renforcée
  reinforcedWoodenSpear: 143,
  reinforcedCopperSpear: 144,
  reinforcedIronSpear: 145,
  reinforcedSteelSpear: 146,
  reinforcedSilverSpear: 147,
  reinforcedGoldSpear: 148,
  reinforcedPlatiniumSpear: 149,
  reinforcedCobaltSpear: 150,
  reinforcedAdamantineSpear: 151,
  reinforcedCrimsonSpear: 152,
  reinforcedAngelicSpear: 153,
  reinforcedFatefulSpear: 154,
  reinforcedNovaSpear: 155,

  // Axe - base
  woodenAxe: 156,
  copperAxe: 157,
  ironAxe: 158,
  steelAxe: 159,
  silverAxe: 160,
  goldAxe: 161,
  platiniumAxe: 162,
  cobaltAxe: 163,
  adamantineAxe: 164,
  crimsonAxe: 165,
  angelicAxe: 166,
  fatefulAxe: 167,
  novaAxe: 168,

  // Axe - aiguisée
  sharpWoodenAxe: 169,
  sharpCopperAxe: 170,
  sharpIronAxe: 171,
  sharpSteelAxe: 172,
  sharpSilverAxe: 173,
  sharpGoldAxe: 174,
  sharpPlatiniumAxe: 175,
  sharpCobaltAxe: 176,
  sharpAdamantineAxe: 177,
  sharpCrimsonAxe: 178,
  sharpAngelicAxe: 179,
  sharpFatefulAxe: 180,
  sharpNovaAxe: 181,

  // Axe - renforcée
  reinforcedWoodenAxe: 182,
  reinforcedCopperAxe: 183,
  reinforcedIronAxe: 184,
  reinforcedSteelAxe: 185,
  reinforcedSilverAxe: 186,
  reinforcedGoldAxe: 187,
  reinforcedPlatiniumAxe: 188,
  reinforcedCobaltAxe: 189,
  reinforcedAdamantineAxe: 190,
  reinforcedCrimsonAxe: 191,
  reinforcedAngelicAxe: 192,
  reinforcedFatefulAxe: 193,
  reinforcedNovaAxe: 194,

  // Mallet - base
  woodenMallet: 195,
  copperMallet: 196,
  ironMallet: 197,
  steelMallet: 198,
  silverMallet: 199,
  goldMallet: 200,
  platiniumMallet: 201,
  cobaltMallet: 202,
  adamantineMallet: 203,
  crimsonMallet: 204,
  angelicMallet: 205,
  fatefulMallet: 206,
  novaMallet: 207,

  // Mallet - aiguisée
  sharpWoodenMallet: 208,
  sharpCopperMallet: 209,
  sharpIronMallet: 210,
  sharpSteelMallet: 211,
  sharpSilverMallet: 212,
  sharpGoldMallet: 213,
  sharpPlatiniumMallet: 214,
  sharpCobaltMallet: 215,
  sharpAdamantineMallet: 216,
  sharpCrimsonMallet: 217,
  sharpAngelicMallet: 218,
  sharpFatefulMallet: 219,
  sharpNovaMallet: 220,

  // Mallet - renforcée
  reinforcedWoodenMallet: 221,
  reinforcedCopperMallet: 222,
  reinforcedIronMallet: 223,
  reinforcedSteelMallet: 224,
  reinforcedSilverMallet: 225,
  reinforcedGoldMallet: 226,
  reinforcedPlatiniumMallet: 227,
  reinforcedCobaltMallet: 228,
  reinforcedAdamantineMallet: 229,
  reinforcedCrimsonMallet: 230,
  reinforcedAngelicMallet: 231,
  reinforcedFatefulMallet: 232,
  reinforcedNovaMallet: 233,

  // Shovel - base
  woodenShovel: 234,
  copperShovel: 235,
  ironShovel: 236,
  steelShovel: 237,
  silverShovel: 238,
  goldShovel: 239,
  platiniumShovel: 240,
  cobaltShovel: 241,
  adamantineShovel: 242,
  crimsonShovel: 243,
  angelicShovel: 244,
  fatefulShovel: 245,
  novaShovel: 246,

  // Shovel - aiguisée
  sharpWoodenShovel: 247,
  sharpCopperShovel: 248,
  sharpIronShovel: 249,
  sharpSteelShovel: 250,
  sharpSilverShovel: 251,
  sharpGoldShovel: 252,
  sharpPlatiniumShovel: 253,
  sharpCobaltShovel: 254,
  sharpAdamantineShovel: 255,
  sharpCrimsonShovel: 256,
  sharpAngelicShovel: 257,
  sharpFatefulShovel: 258,
  sharpNovaShovel: 259,

  // Shovel - renforcée
  reinforcedWoodenShovel: 260,
  reinforcedCopperShovel: 261,
  reinforcedIronShovel: 262,
  reinforcedSteelShovel: 263,
  reinforcedSilverShovel: 264,
  reinforcedGoldShovel: 265,
  reinforcedPlatiniumShovel: 266,
  reinforcedCobaltShovel: 267,
  reinforcedAdamantineShovel: 268,
  reinforcedCrimsonShovel: 269,
  reinforcedAngelicShovel: 270,
  reinforcedFatefulShovel: 271,
  reinforcedNovaShovel: 272,

  // Pickaxe - base
  woodenPickaxe: 273,
  copperPickaxe: 274,
  ironPickaxe: 275,
  steelPickaxe: 276,
  steelPickaxeBrenn: 276,
  silverPickaxe: 277,
  goldPickaxe: 278,
  platiniumPickaxe: 279,
  cobaltPickaxe: 280,
  adamantinePickaxe: 281,
  crimsonPickaxe: 282,
  angelicPickaxe: 283,
  fatefulPickaxe: 284,
  novaPickaxe: 285,

  // Pickaxe - aiguisée
  sharpWoodenPickaxe: 286,
  sharpCopperPickaxe: 287,
  sharpIronPickaxe: 288,
  sharpSteelPickaxe: 289,
  sharpSilverPickaxe: 290,
  sharpGoldPickaxe: 291,
  sharpPlatiniumPickaxe: 292,
  sharpCobaltPickaxe: 293,
  sharpAdamantinePickaxe: 294,
  sharpCrimsonPickaxe: 295,
  sharpAngelicPickaxe: 296,
  sharpFatefulPickaxe: 297,
  sharpNovaPickaxe: 298,

  // Pickaxe - renforcée
  reinforcedWoodenPickaxe: 299,
  reinforcedCopperPickaxe: 300,
  reinforcedIronPickaxe: 301,
  reinforcedSteelPickaxe: 302,
  reinforcedSilverPickaxe: 303,
  reinforcedGoldPickaxe: 304,
  reinforcedPlatiniumPickaxe: 305,
  reinforcedCobaltPickaxe: 306,
  reinforcedAdamantinePickaxe: 307,
  reinforcedCrimsonPickaxe: 308,
  reinforcedAngelicPickaxe: 309,
  reinforcedFatefulPickaxe: 310,
  reinforcedNovaPickaxe: 311,

  // Hammer - base
  woodenHammer: 312,
  copperHammer: 313,
  ironHammer: 314,
  steelHammer: 315,
  silverHammer: 316,
  goldHammer: 317,
  platiniumHammer: 318,
  cobaltHammer: 319,
  adamantineHammer: 320,
  crimsonHammer: 321,
  angelicHammer: 322,
  fatefulHammer: 323,
  novaHammer: 324,

  // Hammer - aiguisée
  sharpWoodenHammer: 325,
  sharpCopperHammer: 326,
  sharpIronHammer: 327,
  sharpSteelHammer: 328,
  sharpSilverHammer: 329,
  sharpGoldHammer: 330,
  sharpPlatiniumHammer: 331,
  sharpCobaltHammer: 332,
  sharpAdamantineHammer: 333,
  sharpCrimsonHammer: 334,
  sharpAngelicHammer: 335,
  sharpFatefulHammer: 336,
  sharpNovaHammer: 337,

  // Hammer - renforcée
  reinforcedWoodenHammer: 338,
  reinforcedCopperHammer: 339,
  reinforcedIronHammer: 340,
  reinforcedSteelHammer: 341,
  reinforcedSilverHammer: 342,
  reinforcedGoldHammer: 343,
  reinforcedPlatiniumHammer: 344,
  reinforcedCobaltHammer: 345,
  reinforcedAdamantineHammer: 346,
  reinforcedCrimsonHammer: 347,
  reinforcedAngelicHammer: 348,
  reinforcedFatefulHammer: 349,
  reinforcedNovaHammer: 350,

  // Sickle - base
  woodenSickle: 351,
  copperSickle: 352,
  ironSickle: 353,
  steelSickle: 354,
  silverSickle: 355,
  goldSickle: 356,
  platiniumSickle: 357,
  cobaltSickle: 358,
  adamantineSickle: 359,
  crimsonSickle: 360,
  angelicSickle: 361,
  fatefulSickle: 362,
  novaSickle: 363,

  // Sickle - aiguisée
  sharpWoodenSickle: 364,
  sharpCopperSickle: 365,
  sharpIronSickle: 366,
  sharpSteelSickle: 367,
  sharpSilverSickle: 368,
  sharpGoldSickle: 369,
  sharpPlatiniumSickle: 370,
  sharpCobaltSickle: 371,
  sharpAdamantineSickle: 372,
  sharpCrimsonSickle: 373,
  sharpAngelicSickle: 374,
  sharpFatefulSickle: 375,
  sharpNovaSickle: 376,

  // Sickle - renforcée
  reinforcedWoodenSickle: 377,
  reinforcedCopperSickle: 378,
  reinforcedIronSickle: 379,
  reinforcedSteelSickle: 380,
  reinforcedSilverSickle: 381,
  reinforcedGoldSickle: 382,
  reinforcedPlatiniumSickle: 383,
  reinforcedCobaltSickle: 384,
  reinforcedAdamantineSickle: 385,
  reinforcedCrimsonSickle: 386,
  reinforcedAngelicSickle: 387,
  reinforcedFatefulSickle: 388,
  reinforcedNovaSickle: 389,

  // Crossbow - base
  woodenCrossbow: 390,
  oakCrossbow: 391,
  ashCrossbow: 392,
  yewCrossbow: 393,
  ebonyCrossbow: 394,
  petrifiedCrossbow: 395,
  mistwoodCrossbow: 396,
  runewoodCrossbow: 397,
  skywoodCrossbow: 398,
  scarletwoodCrossbow: 399,
  sacredCrossbow: 400,
  eternalCrossbow: 401,
  starwoodCrossbow: 402,

  // Crossbow - aiguisée
  sharpWoodenCrossbow: 403,
  sharpOakCrossbow: 404,
  sharpAshCrossbow: 405,
  sharpYewCrossbow: 406,
  sharpEbonyCrossbow: 407,
  sharpPetrifiedCrossbow: 408,
  sharpMistwoodCrossbow: 409,
  sharpRunewoodCrossbow: 410,
  sharpSkywoodCrossbow: 411,
  sharpScarletwoodCrossbow: 412,
  sharpSacredCrossbow: 413,
  sharpEternalCrossbow: 414,
  sharpStarwoodCrossbow: 415,

  // Crossbow - renforcée
  reinforcedWoodenCrossbow: 416,
  reinforcedOakCrossbow: 417,
  reinforcedAshCrossbow: 418,
  reinforcedYewCrossbow: 419,
  reinforcedEbonyCrossbow: 420,
  reinforcedPetrifiedCrossbow: 421,
  reinforcedMistwoodCrossbow: 422,
  reinforcedRunewoodCrossbow: 423,
  reinforcedSkywoodCrossbow: 424,
  reinforcedScarletwoodCrossbow: 425,
  reinforcedSacredCrossbow: 426,
  reinforcedEternalCrossbow: 427,
  reinforcedStarwoodCrossbow: 428,
};

export const ARMOR_TIERS_FRAMES = {
  // Armor - normal
  woodenArmor: 0,
  copperArmor: 1,
  ironArmor: 2,
  steelArmor: 3,
  silverArmor: 4,
  goldArmor: 5,
  platiniumArmor: 6,
  cobaltArmor: 7,
  adamantineArmor: 8,
  crimsonArmor: 9,
  angelicArmor: 10,
  fatefulArmor: 11,
  novaArmor: 12,

  // Armor - renforcée
  reinforcedWoodenArmor: 13,
  reinforcedCopperArmor: 14,
  reinforcedIronArmor: 15,
  reinforcedSteelArmor: 16,
  reinforcedSilverArmor: 17,
  reinforcedGoldArmor: 18,
  reinforcedPlatiniumArmor: 19,
  reinforcedCobaltArmor: 20,
  reinforcedAdamantineArmor: 21,
  reinforcedCrimsonArmor: 22,
  reinforcedAngelicArmor: 23,
  reinforcedFatefulArmor: 24,
  reinforcedNovaArmor: 25,

  // Buckler - normal
  woodenBuckler: 26,
  oakBuckler: 27,
  ashBuckler: 28,
  yewBuckler: 29,
  ebonyBuckler: 30,
  petrifiedBuckler: 31,
  mistwoodBuckler: 32,
  runewoodBuckler: 33,
  skywoodBuckler: 34,
  scarletwoodBuckler: 35,
  sacredBuckler: 36,
  eternalBuckler: 37,
  starwoodBuckler: 38,

  // Buckler - renforcée
  reinforcedWoodenBuckler: 39,
  reinforcedOakBuckler: 40,
  reinforcedAshBuckler: 41,
  reinforcedYewBuckler: 42,
  reinforcedEbonyBuckler: 43,
  reinforcedPetrifiedBuckler: 44,
  reinforcedMistwoodBuckler: 45,
  reinforcedRunewoodBuckler: 46,
  reinforcedSkywoodBuckler: 47,
  reinforcedScarletwoodBuckler: 48,
  reinforcedSacredBuckler: 49,
  reinforcedEternalBuckler: 50,
  reinforcedStarwoodBuckler: 51,

  // Shield - normal
  woodenShield: 52,
  copperShield: 53,
  ironShield: 54,
  steelShield: 55,
  silverShield: 56,
  goldShield: 57,
  platiniumShield: 58,
  cobaltShield: 59,
  adamantineShield: 60,
  crimsonShield: 61,
  angelicShield: 62,
  fatefulShield: 63,
  novaShield: 64,

  // Shield - renforcée
  reinforcedWoodenShield: 65,
  reinforcedCopperShield: 66,
  reinforcedIronShield: 67,
  reinforcedSteelShield: 68,
  reinforcedSilverShield: 69,
  reinforcedGoldShield: 70,
  reinforcedPlatiniumShield: 71,
  reinforcedCobaltShield: 72,
  reinforcedAdamantineShield: 73,
  reinforcedCrimsonShield: 74,
  reinforcedAngelicShield: 75,
  reinforcedFatefulShield: 76,
  reinforcedNovaShield: 77,

  // GreatShield - normal
  woodenGreatShield: 78,
  copperGreatShield: 79,
  ironGreatShield: 80,
  steelGreatShield: 81,
  silverGreatShield: 82,
  goldGreatShield: 83,
  platiniumGreatShield: 84,
  cobaltGreatShield: 85,
  adamantineGreatShield: 86,
  crimsonGreatShield: 87,
  angelicGreatShield: 88,
  fatefulGreatShield: 89,
  novaGreatShield: 90,

  // GreatShield - renforcée
  reinforcedWoodenGreatShield: 91,
  reinforcedCopperGreatShield: 92,
  reinforcedIronGreatShield: 93,
  reinforcedSteelGreatShield: 94,
  reinforcedSilverGreatShield: 95,
  reinforcedGoldGreatShield: 96,
  reinforcedPlatiniumGreatShield: 97,
  reinforcedCobaltGreatShield: 98,
  reinforcedAdamantineGreatShield: 99,
  reinforcedCrimsonGreatShield: 100,
  reinforcedAngelicGreatShield: 101,
  reinforcedFatefulGreatShield: 102,
  reinforcedNovaGreatShield: 103,

  // Helmet - normal
  woodenHelmet: 104,
  copperHelmet: 105,
  ironHelmet: 106,
  steelHelmet: 107,
  silverHelmet: 108,
  goldHelmet: 109,
  platiniumHelmet: 110,
  cobaltHelmet: 111,
  adamantineHelmet: 112,
  crimsonHelmet: 113,
  angelicHelmet: 114,
  fatefulHelmet: 115,
  novaHelmet: 116,

  // Helmet - renforcée
  reinforcedWoodenHelmet: 117,
  reinforcedCopperHelmet: 118,
  reinforcedIronHelmet: 119,
  reinforcedSteelHelmet: 120,
  reinforcedSilverHelmet: 121,
  reinforcedGoldHelmet: 122,
  reinforcedPlatiniumHelmet: 123,
  reinforcedCobaltHelmet: 124,
  reinforcedAdamantineHelmet: 125,
  reinforcedCrimsonHelmet: 126,
  reinforcedAngelicHelmet: 127,
  reinforcedFatefulHelmet: 128,
  reinforcedNovaHelmet: 129,
};

export const STAFF_TIERS_FRAMES = {
  // ligne 0 - normal (métal)
  woodenStaff: 0,
  copperStaff: 1,
  ironStaff: 2,
  steelStaff: 3,
  silverStaff: 4,
  goldStaff: 5,
  platiniumStaff: 6,
  cobaltStaff: 7,
  adamantineStaff: 8,
  crimsonStaff: 9,
  angelicStaff: 10,
  fatefulStaff: 11,
  novaStaff: 12,

  // ligne 1 - sharp (métal)
  sharpWoodenStaff: 13,
  sharpCopperStaff: 14,
  sharpIronStaff: 15,
  sharpSteelStaff: 16,
  sharpSilverStaff: 17,
  sharpGoldStaff: 18,
  sharpPlatiniumStaff: 19,
  sharpCobaltStaff: 20,
  sharpAdamantineStaff: 21,
  sharpCrimsonStaff: 22,
  sharpAngelicStaff: 23,
  sharpFatefulStaff: 24,
  sharpNovaStaff: 25,

  // ligne 2 - reinforced (métal)
  reinforcedWoodenStaff: 26,
  reinforcedCopperStaff: 27,
  reinforcedIronStaff: 28,
  reinforcedSteelStaff: 29,
  reinforcedSilverStaff: 30,
  reinforcedGoldStaff: 31,
  reinforcedPlatiniumStaff: 32,
  reinforcedCobaltStaff: 33,
  reinforcedAdamantineStaff: 34,
  reinforcedCrimsonStaff: 35,
  reinforcedAngelicStaff: 36,
  reinforcedFatefulStaff: 37,
  reinforcedNovaStaff: 38,

  // ligne 3 - normal (bois) -- woodenStaff/reinforcedWoodenStaff pointent vers les MEMES tiers que le métal (même sprite "wood"), ici dupliqués sous un autre nom pour éviter les collisions de clé
  oakStaff: 40,
  ashStaff: 41,
  yewStaff: 42,
  ebonyStaff: 43,
  petrifiedStaff: 44,
  mistwoodStaff: 45,
  runewoodStaff: 46,
  skywoodStaff: 47,
  scarletwoodStaff: 48,
  sacredStaff: 49,
  eternalStaff: 50,
  starwoodStaff: 51,

  // ligne 4 - reinforced (bois)
  reinforcedOakStaff: 53,
  reinforcedAshStaff: 54,
  reinforcedYewStaff: 55,
  reinforcedEbonyStaff: 56,
  reinforcedPetrifiedStaff: 57,
  reinforcedMistwoodStaff: 58,
  reinforcedRunewoodStaff: 59,
  reinforcedSkywoodStaff: 60,
  reinforcedScarletwoodStaff: 61,
  reinforcedSacredStaff: 62,
  reinforcedEternalStaff: 63,
  reinforcedStarwoodStaff: 64,
};

export const ARMOR_TEXTILE_TIERS_FRAMES = {
  // MageRobe - normal
  mageRobe: 0,
  slimeBlobMageRobe: 1,
  bearPeltMageRobe: 2,
  spiderLegMageRobe: 3,
  greyMonsterScaleMageRobe: 4,
  crabClawMageRobe: 5,
  blackBearPeltMageRobe: 6,
  turtleShellMageRobe: 7,
  greenMonsterScaleMageRobe: 8,
  batWingsMageRobe: 9,
  dragonScaleMageRobe: 10,
  ghostEctoplasmMageRobe: 11,
  monsterCoreMageRobe: 12,

  // MageRobe - renforcée
  reinforcedmageRobe: 13,
  reinforcedSlimeBlobMageRobe: 14,
  reinforcedBearPeltMageRobe: 15,
  reinforcedSpiderLegMageRobe: 16,
  reinforcedGreyMonsterScaleMageRobe: 17,
  reinforcedCrabClawMageRobe: 18,
  reinforcedBlackBearPeltMageRobe: 19,
  reinforcedTurtleShellMageRobe: 20,
  reinforcedGreenMonsterScaleMageRobe: 21,
  reinforcedBatWingsMageRobe: 22,
  reinforcedDragonScaleMageRobe: 23,
  reinforcedGhostEctoplasmMageRobe: 24,
  reinforcedMonsterCoreMageRobe: 25,

  // LeatherArmor - normal
  leatherArmor: 26,
  slimeBlobLeatherArmor: 27,
  bearPeltLeatherArmor: 28,
  spiderLegLeatherArmor: 29,
  greyMonsterScaleLeatherArmor: 30,
  crabClawLeatherArmor: 31,
  blackBearPeltLeatherArmor: 32,
  turtleShellLeatherArmor: 33,
  greenMonsterScaleLeatherArmor: 34,
  batWingsLeatherArmor: 35,
  dragonScaleLeatherArmor: 36,
  ghostEctoplasmLeatherArmor: 37,
  monsterCoreLeatherArmor: 38,

  // LeatherArmor - renforcée
  reinforcedLeatherArmor: 39,
  reinforcedSlimeBlobLeatherArmor: 40,
  reinforcedBearPeltLeatherArmor: 41,
  reinforcedSpiderLegLeatherArmor: 42,
  reinforcedGreyMonsterScaleLeatherArmor: 43,
  reinforcedCrabClawLeatherArmor: 44,
  reinforcedBlackBearPeltLeatherArmor: 45,
  reinforcedTurtleShellLeatherArmor: 46,
  reinforcedGreenMonsterScaleLeatherArmor: 47,
  reinforcedBatWingsLeatherArmor: 48,
  reinforcedDragonScaleLeatherArmor: 49,
  reinforcedGhostEctoplasmLeatherArmor: 50,
  reinforcedMonsterCoreLeatherArmor: 51,

  // Boots - normal
  boots: 52,
  slimeBlobBoots: 53,
  bearPeltBoots: 54,
  spiderLegBoots: 55,
  greyMonsterScaleBoots: 56,
  crabClawBoots: 57,
  blackBearPeltBoots: 58,
  turtleShellBoots: 59,
  greenMonsterScaleBoots: 60,
  batWingsBoots: 61,
  dragonScaleBoots: 62,
  ghostEctoplasmBoots: 63,
  monsterCoreBoots: 64,

  // Boots - renforcée
  reinforcedBoots: 65,
  reinforcedSlimeBlobBoots: 66,
  reinforcedBearPeltBoots: 67,
  reinforcedSpiderLegBoots: 68,
  reinforcedGreyMonsterScaleBoots: 69,
  reinforcedCrabClawBoots: 70,
  reinforcedBlackBearPeltBoots: 71,
  reinforcedTurtleShellBoots: 72,
  reinforcedGreenMonsterScaleBoots: 73,
  reinforcedBatWingsBoots: 74,
  reinforcedDragonScaleBoots: 75,
  reinforcedGhostEctoplasmBoots: 76,
  reinforcedMonsterCoreBoots: 77,

  // MageHat - normal
  mageHat: 78,
  slimeBlobMageHat: 79,
  bearPeltMageHat: 80,
  spiderLegMageHat: 81,
  greyMonsterScaleMageHat: 82,
  crabClawMageHat: 83,
  blackBearPeltMageHat: 84,
  turtleShellMageHat: 85,
  greenMonsterScaleMageHat: 86,
  batWingsMageHat: 87,
  dragonScaleMageHat: 88,
  ghostEctoplasmMageHat: 89,
  monsterCoreMageHat: 90,

  // MageHat - renforcée
  reinforcedMageHat: 91,
  reinforcedSlimeBlobMageHat: 92,
  reinforcedBearPeltMageHat: 93,
  reinforcedSpiderLegMageHat: 94,
  reinforcedGreyMonsterScaleMageHat: 95,
  reinforcedCrabClawMageHat: 96,
  reinforcedBlackBearPeltMageHat: 97,
  reinforcedTurtleShellMageHat: 98,
  reinforcedGreenMonsterScaleMageHat: 99,
  reinforcedBatWingsMageHat: 100,
  reinforcedDragonScaleMageHat: 101,
  reinforcedGhostEctoplasmMageHat: 102,
  reinforcedMonsterCoreMageHat: 103,

  // LeatherHelmet - normal
  leatherHelmet: 104,
  slimeBlobLeatherHelmet: 105,
  bearPeltLeatherHelmet: 106,
  spiderLegLeatherHelmet: 107,
  greyMonsterScaleLeatherHelmet: 108,
  crabClawLeatherHelmet: 109,
  blackBearPeltLeatherHelmet: 110,
  turtleShellLeatherHelmet: 111,
  greenMonsterScaleLeatherHelmet: 112,
  batWingsLeatherHelmet: 113,
  dragonScaleLeatherHelmet: 114,
  ghostEctoplasmLeatherHelmet: 115,
  monsterCoreLeatherHelmet: 116,

  // LeatherHelmet - renforcée
  reinforcedLeatherHelmet: 117,
  reinforcedSlimeBlobLeatherHelmet: 118,
  reinforcedBearPeltLeatherHelmet: 119,
  reinforcedSpiderLegLeatherHelmet: 120,
  reinforcedGreyMonsterScaleLeatherHelmet: 121,
  reinforcedCrabClawLeatherHelmet: 122,
  reinforcedBlackBearPeltLeatherHelmet: 123,
  reinforcedTurtleShellLeatherHelmet: 124,
  reinforcedGreenMonsterScaleLeatherHelmet: 125,
  reinforcedBatWingsLeatherHelmet: 126,
  reinforcedDragonScaleLeatherHelmet: 127,
  reinforcedGhostEctoplasmLeatherHelmet: 128,
  reinforcedMonsterCoreLeatherHelmet: 129,
};

export const PANTS_TIERS_FRAMES = {
  // ligne 0 - normal (métal)
  armorPants: 0,
  copperArmorPants: 1,
  ironArmorPants: 2,
  steelArmorPants: 3,
  silverArmorPants: 4,
  goldArmorPants: 5,
  platiniumArmorPants: 6,
  cobaltArmorPants: 7,
  adamantineArmorPants: 8,
  crimsonArmorPants: 9,
  angelicArmorPants: 10,
  fatefulArmorPants: 11,
  novaArmorPants: 12,

  // ligne 1 - reinforced (métal)
  reinforcedArmorPants: 13,
  reinforcedCopperArmorPants: 14,
  reinforcedIronArmorPants: 15,
  reinforcedSteelArmorPants: 16,
  reinforcedSilverArmorPants: 17,
  reinforcedGoldArmorPants: 18,
  reinforcedPlatiniumArmorPants: 19,
  reinforcedCobaltArmorPants: 20,
  reinforcedAdamantineArmorPants: 21,
  reinforcedCrimsonArmorPants: 22,
  reinforcedAngelicArmorPants: 23,
  reinforcedFatefulArmorPants: 24,
  reinforcedNovaArmorPants: 25,

  // ligne 2 - normal (textile/cuir)
  pants: 26,
  slimeBlobPants: 27,
  bearPeltPants: 28,
  spiderLegPants: 29,
  greyMonsterScalePants: 30,
  crabClawPants: 31,
  blackBearPeltPants: 32,
  turtleShellPants: 33,
  greenMonsterScalePants: 34,
  batWingsPants: 35,
  dragonScalePants: 36,
  ghostEctoplasmPants: 37,
  monsterCorePants: 38,

  // ligne 3 - reinforced (textile/cuir)
  reinforcedPants: 39,
  reinforcedSlimeBlobPants: 40,
  reinforcedBearPeltPants: 41,
  reinforcedSpiderLegPants: 42,
  reinforcedGreyMonsterScalePants: 43,
  reinforcedCrabClawPants: 44,
  reinforcedBlackBearPeltPants: 45,
  reinforcedTurtleShellPants: 46,
  reinforcedGreenMonsterScalePants: 47,
  reinforcedBatWingsPants: 48,
  reinforcedDragonScalePants: 49,
  reinforcedGhostEctoplasmPants: 50,
  reinforcedMonsterCorePants: 51,
};

export const BELT_ALL_TIERS_FRAMES = {
  // ligne 0 - normal (métal)
  armorBelt: 0,
  copperArmorBelt: 1,
  ironArmorBelt: 2,
  steelArmorBelt: 3,
  silverArmorBelt: 4,
  goldArmorBelt: 5,
  platiniumArmorBelt: 6,
  cobaltArmorBelt: 7,
  adamantineArmorBelt: 8,
  crimsonArmorBelt: 9,
  angelicArmorBelt: 10,
  fatefulArmorBelt: 11,
  novaArmorBelt: 12,

  // ligne 1 - reinforced (métal)
  reinforcedArmorBelt: 13,
  reinforcedCopperArmorBelt: 14,
  reinforcedIronArmorBelt: 15,
  reinforcedSteelArmorBelt: 16,
  reinforcedSilverArmorBelt: 17,
  reinforcedGoldArmorBelt: 18,
  reinforcedPlatiniumArmorBelt: 19,
  reinforcedCobaltArmorBelt: 20,
  reinforcedAdamantineArmorBelt: 21,
  reinforcedCrimsonArmorBelt: 22,
  reinforcedAngelicArmorBelt: 23,
  reinforcedFatefulArmorBelt: 24,
  reinforcedNovaArmorBelt: 25,

  // ligne 2 - normal (textile/cuir)
  belt: 26,
  slimeBlobBelt: 27,
  bearPeltBelt: 28,
  spiderLegBelt: 29,
  greyMonsterScaleBelt: 30,
  crabClawBelt: 31,
  blackBearPeltBelt: 32,
  turtleShellBelt: 33,
  greenMonsterScaleBelt: 34,
  batWingsBelt: 35,
  dragonScaleBelt: 36,
  ghostEctoplasmBelt: 37,
  monsterCoreBelt: 38,

  // ligne 3 - reinforced (textile/cuir)
  reinforcedBelt: 39,
  reinforcedSlimeBlobBelt: 40,
  reinforcedBearPeltBelt: 41,
  reinforcedSpiderLegBelt: 42,
  reinforcedGreyMonsterScaleBelt: 43,
  reinforcedCrabClawBelt: 44,
  reinforcedBlackBearPeltBelt: 45,
  reinforcedTurtleShellBelt: 46,
  reinforcedGreenMonsterScaleBelt: 47,
  reinforcedBatWingsBelt: 48,
  reinforcedDragonScaleBelt: 49,
  reinforcedGhostEctoplasmBelt: 50,
  reinforcedMonsterCoreBelt: 51,
};

export const RING_NECKLACE_TIERS_FRAMES = {
  hpRing: 0,
  copperHpRing: 1,
  ironHpRing: 2,
  steelHpRing: 3,
  silverHpRing: 4,
  goldHpRing: 5,
  platiniumHpRing: 6,
  cobaltHpRing: 7,
  adamantineHpRing: 8,
  crimsonHpRing: 9,
  angelicHpRing: 10,
  fatefulHpRing: 11,
  novaHpRing: 12,

  staminaRing: 13,
  copperStaminaRing: 14,
  ironStaminaRing: 15,
  steelStaminaRing: 16,
  silverStaminaRing: 17,
  goldStaminaRing: 18,
  platiniumStaminaRing: 19,
  cobaltStaminaRing: 20,
  adamantineStaminaRing: 21,
  crimsonStaminaRing: 22,
  angelicStaminaRing: 23,
  fatefulStaminaRing: 24,
  novaStaminaRing: 25,

  manaRing: 26,
  copperManaRing: 27,
  ironManaRing: 28,
  steelManaRing: 29,
  silverManaRing: 30,
  goldManaRing: 31,
  platiniumManaRing: 32,
  cobaltManaRing: 33,
  adamantineManaRing: 34,
  crimsonManaRing: 35,
  angelicManaRing: 36,
  fatefulManaRing: 37,
  novaManaRing: 38,

  oakHpRing: 40,
  ashHpRing: 41,
  yewHpRing: 42,
  ebonyHpRing: 43,
  petrifiedHpRing: 44,
  mistwoodHpRing: 45,
  runewoodHpRing: 46,
  skywoodHpRing: 47,
  scarletwoodHpRing: 48,
  sacredHpRing: 49,
  eternalHpRing: 50,
  starwoodHpRing: 51,

  oakStaminaRing: 53,
  ashStaminaRing: 54,
  yewStaminaRing: 55,
  ebonyStaminaRing: 56,
  petrifiedStaminaRing: 57,
  mistwoodStaminaRing: 58,
  runewoodStaminaRing: 59,
  skywoodStaminaRing: 60,
  scarletwoodStaminaRing: 61,
  sacredStaminaRing: 62,
  eternalStaminaRing: 63,
  starwoodStaminaRing: 64,

  oakManaRing: 66,
  ashManaRing: 67,
  yewManaRing: 68,
  ebonyManaRing: 69,
  petrifiedManaRing: 70,
  mistwoodManaRing: 71,
  runewoodManaRing: 72,
  skywoodManaRing: 73,
  scarletwoodManaRing: 74,
  sacredManaRing: 75,
  eternalManaRing: 76,
  starwoodManaRing: 77,

  hpNecklace: 78,
  copperHpNecklace: 79,
  ironHpNecklace: 80,
  steelHpNecklace: 81,
  silverHpNecklace: 82,
  goldHpNecklace: 83,
  platiniumHpNecklace: 84,
  cobaltHpNecklace: 85,
  adamantineHpNecklace: 86,
  crimsonHpNecklace: 87,
  angelicHpNecklace: 88,
  fatefulHpNecklace: 89,
  novaHpNecklace: 90,

  staminaNecklace: 91,
  copperStaminaNecklace: 92,
  ironStaminaNecklace: 93,
  steelStaminaNecklace: 94,
  silverStaminaNecklace: 95,
  goldStaminaNecklace: 96,
  platiniumStaminaNecklace: 97,
  cobaltStaminaNecklace: 98,
  adamantineStaminaNecklace: 99,
  crimsonStaminaNecklace: 100,
  angelicStaminaNecklace: 101,
  fatefulStaminaNecklace: 102,
  novaStaminaNecklace: 103,

  manaNecklace: 104,
  copperManaNecklace: 105,
  ironManaNecklace: 106,
  steelManaNecklace: 107,
  silverManaNecklace: 108,
  goldManaNecklace: 109,
  platiniumManaNecklace: 110,
  cobaltManaNecklace: 111,
  adamantineManaNecklace: 112,
  crimsonManaNecklace: 113,
  angelicManaNecklace: 114,
  fatefulManaNecklace: 115,
  novaManaNecklace: 116,

  slimeBlobHpNecklace: 118,
  bearPeltHpNecklace: 119,
  spiderLegHpNecklace: 120,
  greyMonsterScaleHpNecklace: 121,
  crabClawHpNecklace: 122,
  blackBearPeltHpNecklace: 123,
  turtleShellHpNecklace: 124,
  greenMonsterScaleHpNecklace: 125,
  batWingsHpNecklace: 126,
  dragonScaleHpNecklace: 127,
  ghostEctoplasmHpNecklace: 128,
  monsterCoreHpNecklace: 129,

  slimeBlobStaminaNecklace: 131,
  bearPeltStaminaNecklace: 132,
  spiderLegStaminaNecklace: 133,
  greyMonsterScaleStaminaNecklace: 134,
  crabClawStaminaNecklace: 135,
  blackBearPeltStaminaNecklace: 136,
  turtleShellStaminaNecklace: 137,
  greenMonsterScaleStaminaNecklace: 138,
  batWingsStaminaNecklace: 139,
  dragonScaleStaminaNecklace: 140,
  ghostEctoplasmStaminaNecklace: 141,
  monsterCoreStaminaNecklace: 142,

  slimeBlobManaNecklace: 144,
  bearPeltManaNecklace: 145,
  spiderLegManaNecklace: 146,
  greyMonsterScaleManaNecklace: 147,
  crabClawManaNecklace: 148,
  blackBearPeltManaNecklace: 149,
  turtleShellManaNecklace: 150,
  greenMonsterScaleManaNecklace: 151,
  batWingsManaNecklace: 152,
  dragonScaleManaNecklace: 153,
  ghostEctoplasmManaNecklace: 154,
  monsterCoreManaNecklace: 155,
};

export const DETAILS_FRAMES = {
  vegetalFiber: 38,
};

export const ICON_SCROLL_FRAMES = {
  blanckScroll: 0,
};

export const GEMS_SPRITESHEET_FRAMES = {
  burnGem: 0,
  bleedGem: 1,
  acidGem: 2,
  slowGem: 3,
  stunGem: 4,
  hasteGem: 5,
  repelGem: 6,
  slowWardGem: 7,
  stunWardGem: 8,
  randomTeleportGem: 9,
  staticStormWardGem: 10,
  thornsWardGem: 11,
  sporesWardGem: 12,
  curseWardGem: 13,
  riposteGem: 14,
  parryGem: 15,
  freezeWardGem: 16,
  rootWardGem: 17,
  shockwaveGem: 18,
  miningSpeedGem: 19,
  miningYieldGem: 20,
  miningLuckGem: 21,
  poisonGem: 22,
  poisonGemT2: 23,
  poisonGemT3: 24,
  poisonGemT4: 25,
  poisonGemT5: 26,
  weakenGem: 27,
  weakenGemT2: 28,
  weakenGemT3: 29,
  weakenGemT4: 30,
  weakenGemT5: 31,
  rootGem: 32,
  rootGemT2: 33,
  rootGemT3: 34,
  rootGemT4: 35,
  rootGemT5: 36,
  burnGemT2: 37,
  burnGemT3: 38,
  burnGemT4: 39,
  burnGemT5: 40,
  bleedGemT2: 41,
  bleedGemT3: 42,
  bleedGemT4: 43,
  bleedGemT5: 44,
  acidGemT2: 45,
  acidGemT3: 46,
  acidGemT4: 47,
  acidGemT5: 48,
  slowGemT2: 49,
  slowGemT3: 50,
  slowGemT4: 51,
  slowGemT5: 52,
  stunGemT2: 53,
  stunGemT3: 54,
  stunGemT4: 55,
  stunGemT5: 56,
  hasteGemT2: 57,
  hasteGemT3: 58,
  hasteGemT4: 59,
  hasteGemT5: 60,
  repelGemT2: 61,
  repelGemT3: 62,
  repelGemT4: 63,
  repelGemT5: 64,
  slowWardGemT2: 65,
  slowWardGemT3: 66,
  slowWardGemT4: 67,
  slowWardGemT5: 68,
  stunWardGemT2: 69,
  stunWardGemT3: 70,
  stunWardGemT4: 71,
  stunWardGemT5: 72,
  randomTeleportGemT2: 73,
  randomTeleportGemT3: 74,
  randomTeleportGemT4: 75,
  randomTeleportGemT5: 76,
  staticStormWardGemT2: 77,
  staticStormWardGemT3: 78,
  staticStormWardGemT4: 79,
  staticStormWardGemT5: 80,
  thornsWardGemT2: 81,
  thornsWardGemT3: 82,
  thornsWardGemT4: 83,
  thornsWardGemT5: 84,
  sporesWardGemT2: 85,
  sporesWardGemT3: 86,
  sporesWardGemT4: 87,
  sporesWardGemT5: 88,
  curseWardGemT2: 89,
  curseWardGemT3: 90,
  curseWardGemT4: 91,
  curseWardGemT5: 92,
  riposteGemT2: 93,
  riposteGemT3: 94,
  riposteGemT4: 95,
  riposteGemT5: 96,
  parryGemT2: 97,
  parryGemT3: 98,
  parryGemT4: 99,
  parryGemT5: 100,
  freezeWardGemT2: 101,
  freezeWardGemT3: 102,
  freezeWardGemT4: 103,
  freezeWardGemT5: 104,
  rootWardGemT2: 105,
  rootWardGemT3: 106,
  rootWardGemT4: 107,
  rootWardGemT5: 108,
  shockwaveGemT2: 109,
  shockwaveGemT3: 110,
  shockwaveGemT4: 111,
  shockwaveGemT5: 112,
  miningSpeedGemT2: 113,
  miningSpeedGemT3: 114,
  miningSpeedGemT4: 115,
  miningSpeedGemT5: 116,
  miningYieldGemT2: 117,
  miningYieldGemT3: 118,
  miningYieldGemT4: 119,
  miningYieldGemT5: 120,
  miningLuckGemT2: 121,
  miningLuckGemT3: 122,
  miningLuckGemT4: 123,
  miningLuckGemT5: 124,
  frostNovaGem: 125,
  frostNovaGemT2: 126,
  frostNovaGemT3: 127,
  frostNovaGemT4: 128,
  frostNovaGemT5: 129,
  icePrisonGem: 130,
  icePrisonGemT2: 131,
  icePrisonGemT3: 132,
  icePrisonGemT4: 133,
  icePrisonGemT5: 134,
  fireNovaGem: 135,
  fireNovaGemT2: 136,
  fireNovaGemT3: 137,
  fireNovaGemT4: 138,
  fireNovaGemT5: 139,
  whirlwindGem: 140,
  whirlwindGemT2: 141,
  whirlwindGemT3: 142,
  whirlwindGemT4: 143,
  whirlwindGemT5: 144,
  smiteGem: 145,
  smiteGemT2: 146,
  smiteGemT3: 147,
  smiteGemT4: 148,
  smiteGemT5: 149,
  arcaneBurstGem: 150,
  arcaneBurstGemT2: 151,
  arcaneBurstGemT3: 152,
  arcaneBurstGemT4: 153,
  arcaneBurstGemT5: 154,
  chainLightningGem: 155,
  chainLightningGemT2: 156,
  chainLightningGemT3: 157,
  chainLightningGemT4: 158,
  chainLightningGemT5: 159,
  vortexGem: 160,
  vortexGemT2: 161,
  vortexGemT3: 162,
  vortexGemT4: 163,
  vortexGemT5: 164,
  quakeGem: 165,
  quakeGemT2: 166,
  quakeGemT3: 167,
  quakeGemT4: 168,
  quakeGemT5: 169,
  blizzardGem: 170,
  blizzardGemT2: 171,
  blizzardGemT3: 172,
  blizzardGemT4: 173,
  blizzardGemT5: 174,
  firePoolGem: 175,
  firePoolGemT2: 176,
  firePoolGemT3: 177,
  firePoolGemT4: 178,
  firePoolGemT5: 179,
  shortDashGem: 180,
  shortDashGemT2: 181,
  shortDashGemT3: 182,
  shortDashGemT4: 183,
  shortDashGemT5: 184,
  stealthGem: 185,
  stealthGemT2: 186,
  stealthGemT3: 187,
  stealthGemT4: 188,
  stealthGemT5: 189,
  manaShieldGem: 190,
  manaShieldGemT2: 191,
  manaShieldGemT3: 192,
  manaShieldGemT4: 193,
  manaShieldGemT5: 194,
};

export const CHEST_VARIANTS = [
  { closedFrame: 0, openFrame: 3 },
  { closedFrame: 1, openFrame: 4 },
  { closedFrame: 2, openFrame: 5 },
  { closedFrame: 6, openFrame: 9 },
  { closedFrame: 7, openFrame: 10 },
  { closedFrame: 8, openFrame: 11 },
];
